// This file is auto-generated by @hey-api/openapi-ts

import { type Options, accountAccountsList, accountAccountsCreate, accountAccountsDestroy, accountAccountsRetrieve, accountAccountsPartialUpdate, accountAccountsUpdate, accountAccountsOptInsUpdate, accountUsersList, accountUsersCreate, accountUsersRetrieve, accountUsersPartialUpdate, accountUsersUpdate, accountUsersFeatureFlagsRetrieve, accountUsersFeatureFlagsCreate, accountUsersMeRetrieve, accountUsersMePartialUpdate, accountUsersMeCreate, accountUsersValidateCreate, agentsSimpleAgentThreadsList, agentsSimpleAgentThreadsCreate, agentsSimpleAgentThreadsDestroy, agentsSimpleAgentThreadsRetrieve, agentsSimpleAgentThreadsPartialUpdate, agentsSimpleAgentThreadsUpdate, agentsSimpleAgentsList, agentsSimpleAgentsRetrieve, analyticsFeedbackCreate, analyticsSurveyList, analyticsSurveyCreate, analyticsSurveyDestroy, analyticsSurveyRetrieve, analyticsSurveyPartialUpdate, analyticsSurveyUpdate, analyticsSurveyAiAnalysisList, analyticsSurveyPrepareEmailContentRetrieve, analyticsSurveyPublishCreate, analyticsSurveyResultsList, appsAppsList, appsAppsCreate, appsAppsDestroy, appsAppsRetrieve, appsAppsPartialUpdate, appsAppsUpdate, appsDeploymentsList, appsDeploymentsInvokeCreate, appsInstalledAppsList, appsInstalledAppsCreate, appsInstalledAppsDestroy, appsInstalledAppsRetrieve, appsInstalledAppsPartialUpdate, appsInstalledAppsUpdate, campaignAssetsList, campaignAssetsCreate, campaignAssetsDestroy, campaignAssetsRetrieve, campaignAssetsPartialUpdate, campaignAssetsUpdate, campaignAudiencesList, campaignAudiencesCreate, campaignAudiencesDestroy, campaignAudiencesRetrieve, campaignAudiencesPartialUpdate, campaignAudiencesUpdate, campaignAudiencesEstimateMatchRateCreate, campaignCampaignsList, campaignCampaignsCreate, campaignCampaignsDestroy, campaignCampaignsRetrieve, campaignCampaignsPartialUpdate, campaignCampaignsUpdate, campaignContentTypesList, campaignContentTypesCreate, campaignContentTypesDestroy, campaignContentTypesRetrieve, campaignContentTypesPartialUpdate, campaignContentTypesUpdate, configClientsList, configClientsCreate, configClientsDestroy, configClientsRetrieve, configClientsPartialUpdate, configClientsUpdate, configClientsDetailsRetrieve, configClientsLanguagesRetrieve, configClientsLookupRetrieve, configCouriersList, configCouriersCreate, configCouriersDestroy, configCouriersRetrieve, configCouriersPartialUpdate, configCouriersUpdate, configFilterFieldsList, configFilterFieldsCreate, configFilterFieldsDestroy, configFilterFieldsRetrieve, configFilterFieldsPartialUpdate, configFilterFieldsUpdate, configIntegrationsList, configIntegrationsCreate, configIntegrationsDestroy, configIntegrationsRetrieve, configIntegrationsPartialUpdate, configIntegrationsUpdate, configReferenceItemsList, configReferenceItemsCreate, configReferenceItemsDestroy, configReferenceItemsRetrieve, configReferenceItemsPartialUpdate, configReferenceItemsUpdate, configSmsAutoreplyConfigList, configSmsAutoreplyConfigCreate, configSmsAutoreplyConfigDestroy, configSmsAutoreplyConfigRetrieve, configSmsAutoreplyConfigPartialUpdate, configSmsAutoreplyConfigUpdate, configWhitelabelDomainConfigsList, configWhitelabelDomainConfigsRetrieve, configWhitelistedDomainsList, configWhitelistedDomainsCreate, configWhitelistedDomainsDestroy, configWhitelistedDomainsBulkCreateCreate, configWhitelistedDomainsLookupRetrieve, importsList, importsCreate, importsRetrieve, journeyConfigurationsList, journeyConfigurationsCreate, journeyConfigurationsDestroy, journeyConfigurationsRetrieve, journeyConfigurationsPartialUpdate, journeyConfigurationsUpdate, journeyConfigurationsPublishCreate, journeyConfigurationsFlowAnalysisRetrieve, journeyConfigurationsLookupRetrieve, journeyEventsList, journeyEventsCreate, journeyEventsDestroy, journeyEventsRetrieve, journeyEventsPartialUpdate, journeyEventsUpdate, journeyExperimentsList, journeyExperimentsCreate, journeyExperimentsDestroy, journeyExperimentsRetrieve, journeyExperimentsPartialUpdate, journeyExperimentsUpdate, journeyExperimentsPublishCreate, journeyExperimentsResultsList, journeyExperimentsWinnerVariantPartialUpdate, journeyFlowVisualizationsList, journeyFlowVisualizationsCreate, journeyFlowVisualizationsDestroy, journeyFlowVisualizationsRetrieve, journeyFlowVisualizationsPartialUpdate, journeyFlowVisualizationsUpdate, journeyLayoutsList, journeyLayoutsCreate, journeyLayoutsDestroy, journeyLayoutsRetrieve, journeyLayoutsPartialUpdate, journeyLayoutsUpdate, journeyLayoutsDetailsRetrieve, journeyLayoutsEditorConfigRetrieve, journeyLayoutsHistoryRetrieve, journeyLayoutsHistoryRetrieve2, journeyLayoutsPublishCreate, journeyLayoutsRevertCreate, journeyLayoutsDeletedRetrieve, journeyMediasList, journeyMediasCreate, journeyMediasDestroy, journeyMediasRetrieve, journeyMediasPartialUpdate, journeyMediasUpdate, journeyMessageTypesList, journeyMessageTypesCreate, journeyMessageTypesDestroy, journeyMessageTypesRetrieve, journeyMessageTypesPartialUpdate, journeyMessageTypesUpdate, journeyMessageTypesAiGenerateCreate, journeyMessagesList, journeyMessagesCreate, journeyMessagesDestroy, journeyMessagesRetrieve, journeyMessagesPartialUpdate, journeyMessagesUpdate, journeyMessagesDetailsRetrieve, journeyMessagesEditorConfigRetrieve, journeyMessagesHistoryRetrieve, journeyMessagesHistoryRetrieve2, journeyMessagesPublishCreate, journeyMessagesRevertCreate, journeyMessagesTestCreate, journeyMessagesTestWebhookCreate, journeyMessagesAiTranslateCreate, journeyMessagesDeletedRetrieve, journeyMessagesGenerateRetrieve, journeyMessagesMigrateCreate, journeyPartialsList, journeyPartialsCreate, journeyPartialsDestroy, journeyPartialsRetrieve, journeyPartialsPartialUpdate, journeyPartialsUpdate, journeyPartialsEditorConfigRetrieve, journeyPartialsHistoryRetrieve, journeyPartialsHistoryRetrieve2, journeyPartialsPublishCreate, journeyPartialsRevertCreate, journeyPartialsDeletedRetrieve, journeyPlaceholdersList, journeyPlaceholdersCreate, journeyPlaceholdersDestroy, journeyPlaceholdersRetrieve, journeyPlaceholdersPartialUpdate, journeyPlaceholdersUpdate, journeySharedFiltersList, journeySharedFiltersCreate, journeySharedFiltersDestroy, journeySharedFiltersRetrieve, journeySharedFiltersPartialUpdate, journeySharedFiltersUpdate, journeyTriggersList, journeyTriggersCreate, journeyTriggersDestroy, journeyTriggersRetrieve, journeyTriggersPartialUpdate, journeyTriggersUpdate, notificationsNotificationList, notificationsNotificationCreate, notificationsNotificationDestroy, notificationsNotificationRetrieve, notificationsNotificationPartialUpdate, notificationsNotificationUpdate, portalCustomAnalyticsList, portalCustomAnalyticsCreate, portalCustomAnalyticsDestroy, portalCustomAnalyticsRetrieve, portalCustomAnalyticsPartialUpdate, portalCustomAnalyticsUpdate, portalCustomAnalyticsIframeRetrieve, portalCustomerPortalsList, portalCustomerPortalsCreate, portalCustomerPortalsDestroy, portalCustomerPortalsRetrieve, portalCustomerPortalsPartialUpdate, portalCustomerPortalsUpdate, portalDataProtectionRequestsList, portalDataProtectionRequestsCreate, portalDataProtectionRequestsDestroy, portalDataProtectionRequestsRetrieve, portalDataProtectionRequestsPartialUpdate, portalDataProtectionRequestsUpdate, portalDataProtectionRequestsBulkCreate, portalReportEmbedTokenTokenCreate, portalReportsList, portalReportsCreate, portalReportsDestroy, portalReportsRetrieve, portalReportsPartialUpdate, portalReportsUpdate, portalSharedObjectsList, portalSharedObjectsCreate, portalSharedObjectsDestroy, portalSharedObjectsRetrieve, portalSharedObjectsPartialUpdate, portalSharedObjectsUpdate, promiseCourierServiceLevelsList, promiseCourierServiceLevelsCreate, promiseCourierServiceLevelsDestroy, promiseCourierServiceLevelsRetrieve, promiseCourierServiceLevelsPartialUpdate, promiseCourierServiceLevelsUpdate, promiseDeliveryMethodsList, promiseDeliveryMethodsCreate, promiseDeliveryMethodsDestroy, promiseDeliveryMethodsRetrieve, promiseDeliveryMethodsPartialUpdate, promiseDeliveryMethodsUpdate, promiseDeliveryPredictionServicesList, promiseDeliveryPredictionServicesCreate, promiseDeliveryPredictionServicesDestroy, promiseDeliveryPredictionServicesRetrieve, promiseDeliveryPredictionServicesPartialUpdate, promiseDeliveryPredictionServicesUpdate, promiseDeliveryPredictionServicesPublishCreate, promiseDeliveryPredictionServicesPublishedRetrieve, promiseTrendingDelayConfigurationsList, promiseTrendingDelayConfigurationsCreate, promiseTrendingDelayConfigurationsDestroy, promiseTrendingDelayConfigurationsRetrieve, promiseTrendingDelayConfigurationsPartialUpdate, promiseTrendingDelayConfigurationsUpdate, promiseWarehousesList, promiseWarehousesCreate, promiseWarehousesDestroy, promiseWarehousesRetrieve, promiseWarehousesPartialUpdate, promiseWarehousesUpdate, returnsCourierApisList, returnsCourierApisCreate, returnsCourierApisDestroy, returnsCourierApisRetrieve, returnsCourierApisPartialUpdate, returnsCourierApisUpdate, returnsCourierApisSchemaRetrieve, returnsDocumentTemplatesList, returnsDocumentTemplatesCreate, returnsDocumentTemplatesDestroy, returnsDocumentTemplatesRetrieve, returnsDocumentTemplatesPartialUpdate, returnsDocumentTemplatesUpdate, returnsDocumentTemplatesPublishCreate, returnsDocumentTemplatesLookupRetrieve, returnsOrderApisList, returnsOrderApisCreate, returnsOrderApisDestroy, returnsOrderApisRetrieve, returnsOrderApisPartialUpdate, returnsOrderApisUpdate, returnsOrderApisSchemaRetrieve, returnsPortalsList, returnsPortalsCreate, returnsPortalsDestroy, returnsPortalsRetrieve, returnsPortalsPartialUpdate, returnsPortalsUpdate, returnsPortalsDetailsRetrieve, returnsPortalsPublishCreate, returnsPortalsSchemaRetrieve, returnsPortalsLookupRetrieve, returnsReturnReasonsList, returnsReturnReasonsCreate, returnsReturnReasonsDestroy, returnsReturnReasonsRetrieve, returnsReturnReasonsPartialUpdate, returnsReturnReasonsUpdate, returnsReturnReasonsMoveToCreate, returnsReturnRegistrationsList, returnsReturnRegistrationsCreate, returnsReturnRegistrationsDestroy, returnsReturnRegistrationsRetrieve, returnsReturnRegistrationsPartialUpdate, returnsReturnRegistrationsUpdate, returnsReturnRegistrationsStatusCreate, returnsRulesList, returnsRulesCreate, returnsRulesDestroy, returnsRulesRetrieve, returnsRulesPartialUpdate, returnsRulesUpdate, returnsTranslationsList, returnsTranslationsCreate, returnsTranslationsDestroy, returnsTranslationsRetrieve, returnsTranslationsPartialUpdate, returnsTranslationsUpdate, returnsTranslationsSchemaRetrieve, serviceRecipesList, serviceRecipesRetrieve, serviceRecipesApplyCreate, serviceRecipesApplicationsList, serviceRecipesApplicationsRetrieve, serviceRecipesApplicationsPublishCreate, serviceServicesList, serviceServicesCreate, serviceServicesDestroy, serviceServicesRetrieve, serviceServicesPartialUpdate, serviceServicesUpdate, serviceServicesSchemaRetrieve, testappTestList, testappTestCreate, testappTestDestroy, testappTestRetrieve, testappTestPartialUpdate, testappTestUpdate, testappTestRaiseErrorRetrieve, trackEmailsList, trackEmailsRetrieve, trackEventsList, trackEventsRetrieve, trackEventsAvailableTypesRetrieve, trackOrderStatusPagesList, trackOrderStatusPagesCreate, trackOrderStatusPagesDestroy, trackOrderStatusPagesRetrieve, trackOrderStatusPagesPartialUpdate, trackOrderStatusPagesUpdate, trackPlaceInfoList, trackPlaceInfoCreate, trackPlaceInfoDestroy, trackPlaceInfoRetrieve, trackPlaceInfoPartialUpdate, trackPlaceInfoUpdate, trackPlaceInfoLookupCreate, trackRecipientsList, trackRecipientsRetrieve, trackTrackingsList, trackTrackingsRetrieve } from '../sdk.gen';
import { queryOptions, infiniteQueryOptions, type InfiniteData, type DefaultError, type UseMutationOptions } from '@tanstack/react-query';
import type { AccountAccountsListData, AccountAccountsListResponse, AccountAccountsCreateData, AccountAccountsCreateResponse, AccountAccountsDestroyData, AccountAccountsDestroyResponse, AccountAccountsRetrieveData, AccountAccountsPartialUpdateData, AccountAccountsPartialUpdateResponse, AccountAccountsUpdateData, AccountAccountsUpdateResponse, AccountAccountsOptInsUpdateData, AccountAccountsOptInsUpdateResponse, AccountUsersListData, AccountUsersListResponse, AccountUsersCreateData, AccountUsersCreateResponse, AccountUsersRetrieveData, AccountUsersPartialUpdateData, AccountUsersPartialUpdateResponse, AccountUsersUpdateData, AccountUsersUpdateResponse, AccountUsersFeatureFlagsRetrieveData, AccountUsersFeatureFlagsCreateData, AccountUsersFeatureFlagsCreateResponse, AccountUsersMeRetrieveData, AccountUsersMePartialUpdateData, AccountUsersMePartialUpdateResponse, AccountUsersMeCreateData, AccountUsersMeCreateResponse, AccountUsersValidateCreateData, AccountUsersValidateCreateResponse, AgentsSimpleAgentThreadsListData, AgentsSimpleAgentThreadsListResponse, AgentsSimpleAgentThreadsCreateData, AgentsSimpleAgentThreadsCreateResponse, AgentsSimpleAgentThreadsDestroyData, AgentsSimpleAgentThreadsDestroyResponse, AgentsSimpleAgentThreadsRetrieveData, AgentsSimpleAgentThreadsPartialUpdateData, AgentsSimpleAgentThreadsPartialUpdateResponse, AgentsSimpleAgentThreadsUpdateData, AgentsSimpleAgentThreadsUpdateResponse, AgentsSimpleAgentsListData, AgentsSimpleAgentsListResponse, AgentsSimpleAgentsRetrieveData, AnalyticsFeedbackCreateData, AnalyticsFeedbackCreateResponse, AnalyticsSurveyListData, AnalyticsSurveyListResponse, AnalyticsSurveyCreateData, AnalyticsSurveyCreateResponse, AnalyticsSurveyDestroyData, AnalyticsSurveyDestroyResponse, AnalyticsSurveyRetrieveData, AnalyticsSurveyPartialUpdateData, AnalyticsSurveyPartialUpdateResponse, AnalyticsSurveyUpdateData, AnalyticsSurveyUpdateResponse, AnalyticsSurveyAiAnalysisListData, AnalyticsSurveyAiAnalysisListResponse, AnalyticsSurveyPrepareEmailContentRetrieveData, AnalyticsSurveyPublishCreateData, AnalyticsSurveyPublishCreateResponse, AnalyticsSurveyResultsListData, AnalyticsSurveyResultsListResponse, AppsAppsListData, AppsAppsListResponse, AppsAppsCreateData, AppsAppsCreateResponse, AppsAppsDestroyData, AppsAppsDestroyResponse, AppsAppsRetrieveData, AppsAppsPartialUpdateData, AppsAppsPartialUpdateResponse, AppsAppsUpdateData, AppsAppsUpdateResponse, AppsDeploymentsListData, AppsDeploymentsListResponse, AppsDeploymentsInvokeCreateData, AppsDeploymentsInvokeCreateResponse, AppsInstalledAppsListData, AppsInstalledAppsListResponse, AppsInstalledAppsCreateData, AppsInstalledAppsCreateResponse, AppsInstalledAppsDestroyData, AppsInstalledAppsDestroyResponse, AppsInstalledAppsRetrieveData, AppsInstalledAppsPartialUpdateData, AppsInstalledAppsPartialUpdateResponse, AppsInstalledAppsUpdateData, AppsInstalledAppsUpdateResponse, CampaignAssetsListData, CampaignAssetsListResponse, CampaignAssetsCreateData, CampaignAssetsCreateResponse, CampaignAssetsDestroyData, CampaignAssetsDestroyResponse, CampaignAssetsRetrieveData, CampaignAssetsPartialUpdateData, CampaignAssetsPartialUpdateResponse, CampaignAssetsUpdateData, CampaignAssetsUpdateResponse, CampaignAudiencesListData, CampaignAudiencesListResponse, CampaignAudiencesCreateData, CampaignAudiencesCreateResponse, CampaignAudiencesDestroyData, CampaignAudiencesDestroyResponse, CampaignAudiencesRetrieveData, CampaignAudiencesPartialUpdateData, CampaignAudiencesPartialUpdateResponse, CampaignAudiencesUpdateData, CampaignAudiencesUpdateResponse, CampaignAudiencesEstimateMatchRateCreateData, CampaignCampaignsListData, CampaignCampaignsListResponse, CampaignCampaignsCreateData, CampaignCampaignsCreateResponse, CampaignCampaignsDestroyData, CampaignCampaignsDestroyResponse, CampaignCampaignsRetrieveData, CampaignCampaignsPartialUpdateData, CampaignCampaignsPartialUpdateResponse, CampaignCampaignsUpdateData, CampaignCampaignsUpdateResponse, CampaignContentTypesListData, CampaignContentTypesListResponse, CampaignContentTypesCreateData, CampaignContentTypesCreateResponse, CampaignContentTypesDestroyData, CampaignContentTypesDestroyResponse, CampaignContentTypesRetrieveData, CampaignContentTypesPartialUpdateData, CampaignContentTypesPartialUpdateResponse, CampaignContentTypesUpdateData, CampaignContentTypesUpdateResponse, ConfigClientsListData, ConfigClientsListResponse, ConfigClientsCreateData, ConfigClientsCreateResponse, ConfigClientsDestroyData, ConfigClientsDestroyResponse, ConfigClientsRetrieveData, ConfigClientsPartialUpdateData, ConfigClientsPartialUpdateResponse, ConfigClientsUpdateData, ConfigClientsUpdateResponse, ConfigClientsDetailsRetrieveData, ConfigClientsLanguagesRetrieveData, ConfigClientsLookupRetrieveData, ConfigCouriersListData, ConfigCouriersListResponse, ConfigCouriersCreateData, ConfigCouriersCreateResponse, ConfigCouriersDestroyData, ConfigCouriersDestroyResponse, ConfigCouriersRetrieveData, ConfigCouriersPartialUpdateData, ConfigCouriersPartialUpdateResponse, ConfigCouriersUpdateData, ConfigCouriersUpdateResponse, ConfigFilterFieldsListData, ConfigFilterFieldsListResponse, ConfigFilterFieldsCreateData, ConfigFilterFieldsCreateResponse, ConfigFilterFieldsDestroyData, ConfigFilterFieldsDestroyResponse, ConfigFilterFieldsRetrieveData, ConfigFilterFieldsPartialUpdateData, ConfigFilterFieldsPartialUpdateResponse, ConfigFilterFieldsUpdateData, ConfigFilterFieldsUpdateResponse, ConfigIntegrationsListData, ConfigIntegrationsListResponse, ConfigIntegrationsCreateData, ConfigIntegrationsCreateResponse, ConfigIntegrationsDestroyData, ConfigIntegrationsDestroyResponse, ConfigIntegrationsRetrieveData, ConfigIntegrationsPartialUpdateData, ConfigIntegrationsPartialUpdateResponse, ConfigIntegrationsUpdateData, ConfigIntegrationsUpdateResponse, ConfigReferenceItemsListData, ConfigReferenceItemsListResponse, ConfigReferenceItemsCreateData, ConfigReferenceItemsCreateResponse, ConfigReferenceItemsDestroyData, ConfigReferenceItemsDestroyResponse, ConfigReferenceItemsRetrieveData, ConfigReferenceItemsPartialUpdateData, ConfigReferenceItemsPartialUpdateResponse, ConfigReferenceItemsUpdateData, ConfigReferenceItemsUpdateResponse, ConfigSmsAutoreplyConfigListData, ConfigSmsAutoreplyConfigListResponse, ConfigSmsAutoreplyConfigCreateData, ConfigSmsAutoreplyConfigCreateResponse, ConfigSmsAutoreplyConfigDestroyData, ConfigSmsAutoreplyConfigDestroyResponse, ConfigSmsAutoreplyConfigRetrieveData, ConfigSmsAutoreplyConfigPartialUpdateData, ConfigSmsAutoreplyConfigPartialUpdateResponse, ConfigSmsAutoreplyConfigUpdateData, ConfigSmsAutoreplyConfigUpdateResponse, ConfigWhitelabelDomainConfigsListData, ConfigWhitelabelDomainConfigsListResponse, ConfigWhitelabelDomainConfigsRetrieveData, ConfigWhitelistedDomainsListData, ConfigWhitelistedDomainsListResponse, ConfigWhitelistedDomainsCreateData, ConfigWhitelistedDomainsCreateResponse, ConfigWhitelistedDomainsDestroyData, ConfigWhitelistedDomainsDestroyResponse, ConfigWhitelistedDomainsBulkCreateCreateData, ConfigWhitelistedDomainsBulkCreateCreateResponse, ConfigWhitelistedDomainsLookupRetrieveData, ImportsListData, ImportsListResponse, ImportsCreateData, ImportsCreateResponse, ImportsRetrieveData, JourneyConfigurationsListData, JourneyConfigurationsListResponse, JourneyConfigurationsCreateData, JourneyConfigurationsCreateResponse, JourneyConfigurationsDestroyData, JourneyConfigurationsDestroyResponse, JourneyConfigurationsRetrieveData, JourneyConfigurationsPartialUpdateData, JourneyConfigurationsPartialUpdateResponse, JourneyConfigurationsUpdateData, JourneyConfigurationsUpdateResponse, JourneyConfigurationsPublishCreateData, JourneyConfigurationsPublishCreateResponse, JourneyConfigurationsFlowAnalysisRetrieveData, JourneyConfigurationsLookupRetrieveData, JourneyEventsListData, JourneyEventsListResponse, JourneyEventsCreateData, JourneyEventsCreateResponse, JourneyEventsDestroyData, JourneyEventsDestroyResponse, JourneyEventsRetrieveData, JourneyEventsPartialUpdateData, JourneyEventsPartialUpdateResponse, JourneyEventsUpdateData, JourneyEventsUpdateResponse, JourneyExperimentsListData, JourneyExperimentsListResponse, JourneyExperimentsCreateData, JourneyExperimentsCreateResponse, JourneyExperimentsDestroyData, JourneyExperimentsDestroyResponse, JourneyExperimentsRetrieveData, JourneyExperimentsPartialUpdateData, JourneyExperimentsPartialUpdateResponse, JourneyExperimentsUpdateData, JourneyExperimentsUpdateResponse, JourneyExperimentsPublishCreateData, JourneyExperimentsPublishCreateResponse, JourneyExperimentsResultsListData, JourneyExperimentsResultsListResponse, JourneyExperimentsWinnerVariantPartialUpdateData, JourneyExperimentsWinnerVariantPartialUpdateResponse, JourneyFlowVisualizationsListData, JourneyFlowVisualizationsListResponse, JourneyFlowVisualizationsCreateData, JourneyFlowVisualizationsCreateResponse, JourneyFlowVisualizationsDestroyData, JourneyFlowVisualizationsDestroyResponse, JourneyFlowVisualizationsRetrieveData, JourneyFlowVisualizationsPartialUpdateData, JourneyFlowVisualizationsPartialUpdateResponse, JourneyFlowVisualizationsUpdateData, JourneyFlowVisualizationsUpdateResponse, JourneyLayoutsListData, JourneyLayoutsListResponse, JourneyLayoutsCreateData, JourneyLayoutsCreateResponse, JourneyLayoutsDestroyData, JourneyLayoutsDestroyResponse, JourneyLayoutsRetrieveData, JourneyLayoutsPartialUpdateData, JourneyLayoutsPartialUpdateResponse, JourneyLayoutsUpdateData, JourneyLayoutsUpdateResponse, JourneyLayoutsDetailsRetrieveData, JourneyLayoutsEditorConfigRetrieveData, JourneyLayoutsHistoryRetrieveData, JourneyLayoutsHistoryRetrieve2Data, JourneyLayoutsPublishCreateData, JourneyLayoutsPublishCreateResponse, JourneyLayoutsRevertCreateData, JourneyLayoutsRevertCreateResponse, JourneyLayoutsDeletedRetrieveData, JourneyMediasListData, JourneyMediasListResponse, JourneyMediasCreateData, JourneyMediasCreateResponse, JourneyMediasDestroyData, JourneyMediasDestroyResponse, JourneyMediasRetrieveData, JourneyMediasPartialUpdateData, JourneyMediasPartialUpdateResponse, JourneyMediasUpdateData, JourneyMediasUpdateResponse, JourneyMessageTypesListData, JourneyMessageTypesListResponse, JourneyMessageTypesCreateData, JourneyMessageTypesCreateResponse, JourneyMessageTypesDestroyData, JourneyMessageTypesDestroyResponse, JourneyMessageTypesRetrieveData, JourneyMessageTypesPartialUpdateData, JourneyMessageTypesPartialUpdateResponse, JourneyMessageTypesUpdateData, JourneyMessageTypesUpdateResponse, JourneyMessageTypesAiGenerateCreateData, JourneyMessageTypesAiGenerateCreateResponse, JourneyMessagesListData, JourneyMessagesListResponse, JourneyMessagesCreateData, JourneyMessagesCreateResponse, JourneyMessagesDestroyData, JourneyMessagesDestroyResponse, JourneyMessagesRetrieveData, JourneyMessagesPartialUpdateData, JourneyMessagesPartialUpdateResponse, JourneyMessagesUpdateData, JourneyMessagesUpdateResponse, JourneyMessagesDetailsRetrieveData, JourneyMessagesEditorConfigRetrieveData, JourneyMessagesHistoryRetrieveData, JourneyMessagesHistoryRetrieve2Data, JourneyMessagesPublishCreateData, JourneyMessagesPublishCreateResponse, JourneyMessagesRevertCreateData, JourneyMessagesRevertCreateResponse, JourneyMessagesTestCreateData, JourneyMessagesTestCreateResponse, JourneyMessagesTestWebhookCreateData, JourneyMessagesAiTranslateCreateData, JourneyMessagesAiTranslateCreateResponse, JourneyMessagesDeletedRetrieveData, JourneyMessagesGenerateRetrieveData, JourneyMessagesMigrateCreateData, JourneyMessagesMigrateCreateResponse, JourneyPartialsListData, JourneyPartialsListResponse, JourneyPartialsCreateData, JourneyPartialsCreateResponse, JourneyPartialsDestroyData, JourneyPartialsDestroyResponse, JourneyPartialsRetrieveData, JourneyPartialsPartialUpdateData, JourneyPartialsPartialUpdateResponse, JourneyPartialsUpdateData, JourneyPartialsUpdateResponse, JourneyPartialsEditorConfigRetrieveData, JourneyPartialsHistoryRetrieveData, JourneyPartialsHistoryRetrieve2Data, JourneyPartialsPublishCreateData, JourneyPartialsPublishCreateResponse, JourneyPartialsRevertCreateData, JourneyPartialsRevertCreateResponse, JourneyPartialsDeletedRetrieveData, JourneyPlaceholdersListData, JourneyPlaceholdersListResponse, JourneyPlaceholdersCreateData, JourneyPlaceholdersCreateResponse, JourneyPlaceholdersDestroyData, JourneyPlaceholdersDestroyResponse, JourneyPlaceholdersRetrieveData, JourneyPlaceholdersPartialUpdateData, JourneyPlaceholdersPartialUpdateResponse, JourneyPlaceholdersUpdateData, JourneyPlaceholdersUpdateResponse, JourneySharedFiltersListData, JourneySharedFiltersListResponse, JourneySharedFiltersCreateData, JourneySharedFiltersCreateResponse, JourneySharedFiltersDestroyData, JourneySharedFiltersDestroyResponse, JourneySharedFiltersRetrieveData, JourneySharedFiltersPartialUpdateData, JourneySharedFiltersPartialUpdateResponse, JourneySharedFiltersUpdateData, JourneySharedFiltersUpdateResponse, JourneyTriggersListData, JourneyTriggersListResponse, JourneyTriggersCreateData, JourneyTriggersCreateResponse, JourneyTriggersDestroyData, JourneyTriggersDestroyResponse, JourneyTriggersRetrieveData, JourneyTriggersPartialUpdateData, JourneyTriggersPartialUpdateResponse, JourneyTriggersUpdateData, JourneyTriggersUpdateResponse, NotificationsNotificationListData, NotificationsNotificationListResponse, NotificationsNotificationCreateData, NotificationsNotificationCreateResponse, NotificationsNotificationDestroyData, NotificationsNotificationDestroyResponse, NotificationsNotificationRetrieveData, NotificationsNotificationPartialUpdateData, NotificationsNotificationPartialUpdateResponse, NotificationsNotificationUpdateData, NotificationsNotificationUpdateResponse, PortalCustomAnalyticsListData, PortalCustomAnalyticsListResponse, PortalCustomAnalyticsCreateData, PortalCustomAnalyticsCreateResponse, PortalCustomAnalyticsDestroyData, PortalCustomAnalyticsDestroyResponse, PortalCustomAnalyticsRetrieveData, PortalCustomAnalyticsPartialUpdateData, PortalCustomAnalyticsPartialUpdateResponse, PortalCustomAnalyticsUpdateData, PortalCustomAnalyticsUpdateResponse, PortalCustomAnalyticsIframeRetrieveData, PortalCustomerPortalsListData, PortalCustomerPortalsListResponse, PortalCustomerPortalsCreateData, PortalCustomerPortalsCreateResponse, PortalCustomerPortalsDestroyData, PortalCustomerPortalsDestroyResponse, PortalCustomerPortalsRetrieveData, PortalCustomerPortalsPartialUpdateData, PortalCustomerPortalsPartialUpdateResponse, PortalCustomerPortalsUpdateData, PortalCustomerPortalsUpdateResponse, PortalDataProtectionRequestsListData, PortalDataProtectionRequestsListResponse, PortalDataProtectionRequestsCreateData, PortalDataProtectionRequestsCreateResponse, PortalDataProtectionRequestsDestroyData, PortalDataProtectionRequestsDestroyResponse, PortalDataProtectionRequestsRetrieveData, PortalDataProtectionRequestsPartialUpdateData, PortalDataProtectionRequestsPartialUpdateResponse, PortalDataProtectionRequestsUpdateData, PortalDataProtectionRequestsUpdateResponse, PortalDataProtectionRequestsBulkCreateData, PortalDataProtectionRequestsBulkCreateResponse, PortalReportEmbedTokenTokenCreateData, PortalReportEmbedTokenTokenCreateResponse, PortalReportsListData, PortalReportsListResponse, PortalReportsCreateData, PortalReportsCreateResponse, PortalReportsDestroyData, PortalReportsDestroyResponse, PortalReportsRetrieveData, PortalReportsPartialUpdateData, PortalReportsPartialUpdateResponse, PortalReportsUpdateData, PortalReportsUpdateResponse, PortalSharedObjectsListData, PortalSharedObjectsListResponse, PortalSharedObjectsCreateData, PortalSharedObjectsCreateResponse, PortalSharedObjectsDestroyData, PortalSharedObjectsDestroyResponse, PortalSharedObjectsRetrieveData, PortalSharedObjectsPartialUpdateData, PortalSharedObjectsPartialUpdateResponse, PortalSharedObjectsUpdateData, PortalSharedObjectsUpdateResponse, PromiseCourierServiceLevelsListData, PromiseCourierServiceLevelsListResponse, PromiseCourierServiceLevelsCreateData, PromiseCourierServiceLevelsCreateResponse, PromiseCourierServiceLevelsDestroyData, PromiseCourierServiceLevelsDestroyResponse, PromiseCourierServiceLevelsRetrieveData, PromiseCourierServiceLevelsPartialUpdateData, PromiseCourierServiceLevelsPartialUpdateResponse, PromiseCourierServiceLevelsUpdateData, PromiseCourierServiceLevelsUpdateResponse, PromiseDeliveryMethodsListData, PromiseDeliveryMethodsListResponse, PromiseDeliveryMethodsCreateData, PromiseDeliveryMethodsCreateResponse, PromiseDeliveryMethodsDestroyData, PromiseDeliveryMethodsDestroyResponse, PromiseDeliveryMethodsRetrieveData, PromiseDeliveryMethodsPartialUpdateData, PromiseDeliveryMethodsPartialUpdateResponse, PromiseDeliveryMethodsUpdateData, PromiseDeliveryMethodsUpdateResponse, PromiseDeliveryPredictionServicesListData, PromiseDeliveryPredictionServicesListResponse, PromiseDeliveryPredictionServicesCreateData, PromiseDeliveryPredictionServicesCreateResponse, PromiseDeliveryPredictionServicesDestroyData, PromiseDeliveryPredictionServicesDestroyResponse, PromiseDeliveryPredictionServicesRetrieveData, PromiseDeliveryPredictionServicesPartialUpdateData, PromiseDeliveryPredictionServicesPartialUpdateResponse, PromiseDeliveryPredictionServicesUpdateData, PromiseDeliveryPredictionServicesUpdateResponse, PromiseDeliveryPredictionServicesPublishCreateData, PromiseDeliveryPredictionServicesPublishCreateResponse, PromiseDeliveryPredictionServicesPublishedRetrieveData, PromiseTrendingDelayConfigurationsListData, PromiseTrendingDelayConfigurationsListResponse, PromiseTrendingDelayConfigurationsCreateData, PromiseTrendingDelayConfigurationsCreateResponse, PromiseTrendingDelayConfigurationsDestroyData, PromiseTrendingDelayConfigurationsDestroyResponse, PromiseTrendingDelayConfigurationsRetrieveData, PromiseTrendingDelayConfigurationsPartialUpdateData, PromiseTrendingDelayConfigurationsPartialUpdateResponse, PromiseTrendingDelayConfigurationsUpdateData, PromiseTrendingDelayConfigurationsUpdateResponse, PromiseWarehousesListData, PromiseWarehousesListResponse, PromiseWarehousesCreateData, PromiseWarehousesCreateResponse, PromiseWarehousesDestroyData, PromiseWarehousesDestroyResponse, PromiseWarehousesRetrieveData, PromiseWarehousesPartialUpdateData, PromiseWarehousesPartialUpdateResponse, PromiseWarehousesUpdateData, PromiseWarehousesUpdateResponse, ReturnsCourierApisListData, ReturnsCourierApisListResponse, ReturnsCourierApisCreateData, ReturnsCourierApisCreateResponse, ReturnsCourierApisDestroyData, ReturnsCourierApisDestroyResponse, ReturnsCourierApisRetrieveData, ReturnsCourierApisPartialUpdateData, ReturnsCourierApisPartialUpdateResponse, ReturnsCourierApisUpdateData, ReturnsCourierApisUpdateResponse, ReturnsCourierApisSchemaRetrieveData, ReturnsDocumentTemplatesListData, ReturnsDocumentTemplatesListResponse, ReturnsDocumentTemplatesCreateData, ReturnsDocumentTemplatesCreateResponse, ReturnsDocumentTemplatesDestroyData, ReturnsDocumentTemplatesDestroyResponse, ReturnsDocumentTemplatesRetrieveData, ReturnsDocumentTemplatesPartialUpdateData, ReturnsDocumentTemplatesPartialUpdateResponse, ReturnsDocumentTemplatesUpdateData, ReturnsDocumentTemplatesUpdateResponse, ReturnsDocumentTemplatesPublishCreateData, ReturnsDocumentTemplatesPublishCreateResponse, ReturnsDocumentTemplatesLookupRetrieveData, ReturnsOrderApisListData, ReturnsOrderApisListResponse, ReturnsOrderApisCreateData, ReturnsOrderApisCreateResponse, ReturnsOrderApisDestroyData, ReturnsOrderApisDestroyResponse, ReturnsOrderApisRetrieveData, ReturnsOrderApisPartialUpdateData, ReturnsOrderApisPartialUpdateResponse, ReturnsOrderApisUpdateData, ReturnsOrderApisUpdateResponse, ReturnsOrderApisSchemaRetrieveData, ReturnsPortalsListData, ReturnsPortalsListResponse, ReturnsPortalsCreateData, ReturnsPortalsCreateResponse, ReturnsPortalsDestroyData, ReturnsPortalsDestroyResponse, ReturnsPortalsRetrieveData, ReturnsPortalsPartialUpdateData, ReturnsPortalsPartialUpdateResponse, ReturnsPortalsUpdateData, ReturnsPortalsUpdateResponse, ReturnsPortalsDetailsRetrieveData, ReturnsPortalsPublishCreateData, ReturnsPortalsPublishCreateResponse, ReturnsPortalsSchemaRetrieveData, ReturnsPortalsLookupRetrieveData, ReturnsReturnReasonsListData, ReturnsReturnReasonsListResponse, ReturnsReturnReasonsCreateData, ReturnsReturnReasonsCreateResponse, ReturnsReturnReasonsDestroyData, ReturnsReturnReasonsDestroyResponse, ReturnsReturnReasonsRetrieveData, ReturnsReturnReasonsPartialUpdateData, ReturnsReturnReasonsPartialUpdateResponse, ReturnsReturnReasonsUpdateData, ReturnsReturnReasonsUpdateResponse, ReturnsReturnReasonsMoveToCreateData, ReturnsReturnReasonsMoveToCreateResponse, ReturnsReturnRegistrationsListData, ReturnsReturnRegistrationsListResponse, ReturnsReturnRegistrationsCreateData, ReturnsReturnRegistrationsCreateResponse, ReturnsReturnRegistrationsDestroyData, ReturnsReturnRegistrationsDestroyResponse, ReturnsReturnRegistrationsRetrieveData, ReturnsReturnRegistrationsPartialUpdateData, ReturnsReturnRegistrationsPartialUpdateResponse, ReturnsReturnRegistrationsUpdateData, ReturnsReturnRegistrationsUpdateResponse, ReturnsReturnRegistrationsStatusCreateData, ReturnsReturnRegistrationsStatusCreateResponse, ReturnsRulesListData, ReturnsRulesListResponse, ReturnsRulesCreateData, ReturnsRulesCreateResponse, ReturnsRulesDestroyData, ReturnsRulesDestroyResponse, ReturnsRulesRetrieveData, ReturnsRulesPartialUpdateData, ReturnsRulesPartialUpdateResponse, ReturnsRulesUpdateData, ReturnsRulesUpdateResponse, ReturnsTranslationsListData, ReturnsTranslationsListResponse, ReturnsTranslationsCreateData, ReturnsTranslationsCreateResponse, ReturnsTranslationsDestroyData, ReturnsTranslationsDestroyResponse, ReturnsTranslationsRetrieveData, ReturnsTranslationsPartialUpdateData, ReturnsTranslationsPartialUpdateResponse, ReturnsTranslationsUpdateData, ReturnsTranslationsUpdateResponse, ReturnsTranslationsSchemaRetrieveData, ServiceRecipesListData, ServiceRecipesListResponse, ServiceRecipesRetrieveData, ServiceRecipesApplyCreateData, ServiceRecipesApplyCreateResponse, ServiceRecipesApplicationsListData, ServiceRecipesApplicationsListResponse, ServiceRecipesApplicationsRetrieveData, ServiceRecipesApplicationsPublishCreateData, ServiceRecipesApplicationsPublishCreateResponse, ServiceServicesListData, ServiceServicesListResponse, ServiceServicesCreateData, ServiceServicesCreateResponse, ServiceServicesDestroyData, ServiceServicesDestroyResponse, ServiceServicesRetrieveData, ServiceServicesPartialUpdateData, ServiceServicesPartialUpdateResponse, ServiceServicesUpdateData, ServiceServicesUpdateResponse, ServiceServicesSchemaRetrieveData, TestappTestListData, TestappTestListResponse, TestappTestCreateData, TestappTestCreateResponse, TestappTestDestroyData, TestappTestDestroyResponse, TestappTestRetrieveData, TestappTestPartialUpdateData, TestappTestPartialUpdateResponse, TestappTestUpdateData, TestappTestUpdateResponse, TestappTestRaiseErrorRetrieveData, TrackEmailsListData, TrackEmailsListResponse, TrackEmailsRetrieveData, TrackEventsListData, TrackEventsListResponse, TrackEventsRetrieveData, TrackEventsAvailableTypesRetrieveData, TrackOrderStatusPagesListData, TrackOrderStatusPagesListResponse, TrackOrderStatusPagesCreateData, TrackOrderStatusPagesCreateResponse, TrackOrderStatusPagesDestroyData, TrackOrderStatusPagesDestroyResponse, TrackOrderStatusPagesRetrieveData, TrackOrderStatusPagesPartialUpdateData, TrackOrderStatusPagesPartialUpdateResponse, TrackOrderStatusPagesUpdateData, TrackOrderStatusPagesUpdateResponse, TrackPlaceInfoListData, TrackPlaceInfoListResponse, TrackPlaceInfoCreateData, TrackPlaceInfoCreateResponse, TrackPlaceInfoDestroyData, TrackPlaceInfoDestroyResponse, TrackPlaceInfoRetrieveData, TrackPlaceInfoPartialUpdateData, TrackPlaceInfoPartialUpdateResponse, TrackPlaceInfoUpdateData, TrackPlaceInfoUpdateResponse, TrackPlaceInfoLookupCreateData, TrackPlaceInfoLookupCreateResponse, TrackRecipientsListData, TrackRecipientsListResponse, TrackRecipientsRetrieveData, TrackTrackingsListData, TrackTrackingsListResponse, TrackTrackingsRetrieveData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const accountAccountsListQueryKey = (options?: Options<AccountAccountsListData>) => createQueryKey('accountAccountsList', options);

export const accountAccountsListOptions = (options?: Options<AccountAccountsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountAccountsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountAccountsListQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = queryKey[0];
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const accountAccountsListInfiniteQueryKey = (options?: Options<AccountAccountsListData>): QueryKey<Options<AccountAccountsListData>> => createQueryKey('accountAccountsList', options, true);

export const accountAccountsListInfiniteOptions = (options?: Options<AccountAccountsListData>) => {
    return infiniteQueryOptions<AccountAccountsListResponse, DefaultError, InfiniteData<AccountAccountsListResponse>, QueryKey<Options<AccountAccountsListData>>, number | Pick<QueryKey<Options<AccountAccountsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AccountAccountsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await accountAccountsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountAccountsListInfiniteQueryKey(options)
    });
};

export const accountAccountsCreateQueryKey = (options: Options<AccountAccountsCreateData>) => createQueryKey('accountAccountsCreate', options);

export const accountAccountsCreateOptions = (options: Options<AccountAccountsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountAccountsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountAccountsCreateQueryKey(options)
    });
};

export const accountAccountsCreateMutation = (options?: Partial<Options<AccountAccountsCreateData>>): UseMutationOptions<AccountAccountsCreateResponse, DefaultError, Options<AccountAccountsCreateData>> => {
    const mutationOptions: UseMutationOptions<AccountAccountsCreateResponse, DefaultError, Options<AccountAccountsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountAccountsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountAccountsDestroyMutation = (options?: Partial<Options<AccountAccountsDestroyData>>): UseMutationOptions<AccountAccountsDestroyResponse, DefaultError, Options<AccountAccountsDestroyData>> => {
    const mutationOptions: UseMutationOptions<AccountAccountsDestroyResponse, DefaultError, Options<AccountAccountsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountAccountsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountAccountsRetrieveQueryKey = (options: Options<AccountAccountsRetrieveData>) => createQueryKey('accountAccountsRetrieve', options);

export const accountAccountsRetrieveOptions = (options: Options<AccountAccountsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountAccountsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountAccountsRetrieveQueryKey(options)
    });
};

export const accountAccountsPartialUpdateMutation = (options?: Partial<Options<AccountAccountsPartialUpdateData>>): UseMutationOptions<AccountAccountsPartialUpdateResponse, DefaultError, Options<AccountAccountsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<AccountAccountsPartialUpdateResponse, DefaultError, Options<AccountAccountsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountAccountsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountAccountsUpdateMutation = (options?: Partial<Options<AccountAccountsUpdateData>>): UseMutationOptions<AccountAccountsUpdateResponse, DefaultError, Options<AccountAccountsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AccountAccountsUpdateResponse, DefaultError, Options<AccountAccountsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountAccountsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountAccountsOptInsUpdateMutation = (options?: Partial<Options<AccountAccountsOptInsUpdateData>>): UseMutationOptions<AccountAccountsOptInsUpdateResponse, DefaultError, Options<AccountAccountsOptInsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AccountAccountsOptInsUpdateResponse, DefaultError, Options<AccountAccountsOptInsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountAccountsOptInsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountUsersListQueryKey = (options?: Options<AccountUsersListData>) => createQueryKey('accountUsersList', options);

export const accountUsersListOptions = (options?: Options<AccountUsersListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersListQueryKey(options)
    });
};

export const accountUsersListInfiniteQueryKey = (options?: Options<AccountUsersListData>): QueryKey<Options<AccountUsersListData>> => createQueryKey('accountUsersList', options, true);

export const accountUsersListInfiniteOptions = (options?: Options<AccountUsersListData>) => {
    return infiniteQueryOptions<AccountUsersListResponse, DefaultError, InfiniteData<AccountUsersListResponse>, QueryKey<Options<AccountUsersListData>>, number | Pick<QueryKey<Options<AccountUsersListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AccountUsersListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await accountUsersList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersListInfiniteQueryKey(options)
    });
};

export const accountUsersCreateQueryKey = (options: Options<AccountUsersCreateData>) => createQueryKey('accountUsersCreate', options);

export const accountUsersCreateOptions = (options: Options<AccountUsersCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersCreateQueryKey(options)
    });
};

export const accountUsersCreateMutation = (options?: Partial<Options<AccountUsersCreateData>>): UseMutationOptions<AccountUsersCreateResponse, DefaultError, Options<AccountUsersCreateData>> => {
    const mutationOptions: UseMutationOptions<AccountUsersCreateResponse, DefaultError, Options<AccountUsersCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountUsersCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountUsersRetrieveQueryKey = (options: Options<AccountUsersRetrieveData>) => createQueryKey('accountUsersRetrieve', options);

export const accountUsersRetrieveOptions = (options: Options<AccountUsersRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersRetrieveQueryKey(options)
    });
};

export const accountUsersPartialUpdateMutation = (options?: Partial<Options<AccountUsersPartialUpdateData>>): UseMutationOptions<AccountUsersPartialUpdateResponse, DefaultError, Options<AccountUsersPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<AccountUsersPartialUpdateResponse, DefaultError, Options<AccountUsersPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountUsersPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountUsersUpdateMutation = (options?: Partial<Options<AccountUsersUpdateData>>): UseMutationOptions<AccountUsersUpdateResponse, DefaultError, Options<AccountUsersUpdateData>> => {
    const mutationOptions: UseMutationOptions<AccountUsersUpdateResponse, DefaultError, Options<AccountUsersUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountUsersUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountUsersFeatureFlagsRetrieveQueryKey = (options?: Options<AccountUsersFeatureFlagsRetrieveData>) => createQueryKey('accountUsersFeatureFlagsRetrieve', options);

export const accountUsersFeatureFlagsRetrieveOptions = (options?: Options<AccountUsersFeatureFlagsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersFeatureFlagsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersFeatureFlagsRetrieveQueryKey(options)
    });
};

export const accountUsersFeatureFlagsCreateQueryKey = (options?: Options<AccountUsersFeatureFlagsCreateData>) => createQueryKey('accountUsersFeatureFlagsCreate', options);

export const accountUsersFeatureFlagsCreateOptions = (options?: Options<AccountUsersFeatureFlagsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersFeatureFlagsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersFeatureFlagsCreateQueryKey(options)
    });
};

export const accountUsersFeatureFlagsCreateMutation = (options?: Partial<Options<AccountUsersFeatureFlagsCreateData>>): UseMutationOptions<AccountUsersFeatureFlagsCreateResponse, DefaultError, Options<AccountUsersFeatureFlagsCreateData>> => {
    const mutationOptions: UseMutationOptions<AccountUsersFeatureFlagsCreateResponse, DefaultError, Options<AccountUsersFeatureFlagsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountUsersFeatureFlagsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountUsersMeRetrieveQueryKey = (options?: Options<AccountUsersMeRetrieveData>) => createQueryKey('accountUsersMeRetrieve', options);

export const accountUsersMeRetrieveOptions = (options?: Options<AccountUsersMeRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersMeRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersMeRetrieveQueryKey(options)
    });
};

export const accountUsersMePartialUpdateMutation = (options?: Partial<Options<AccountUsersMePartialUpdateData>>): UseMutationOptions<AccountUsersMePartialUpdateResponse, DefaultError, Options<AccountUsersMePartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<AccountUsersMePartialUpdateResponse, DefaultError, Options<AccountUsersMePartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountUsersMePartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountUsersMeCreateQueryKey = (options?: Options<AccountUsersMeCreateData>) => createQueryKey('accountUsersMeCreate', options);

export const accountUsersMeCreateOptions = (options?: Options<AccountUsersMeCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersMeCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersMeCreateQueryKey(options)
    });
};

export const accountUsersMeCreateMutation = (options?: Partial<Options<AccountUsersMeCreateData>>): UseMutationOptions<AccountUsersMeCreateResponse, DefaultError, Options<AccountUsersMeCreateData>> => {
    const mutationOptions: UseMutationOptions<AccountUsersMeCreateResponse, DefaultError, Options<AccountUsersMeCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountUsersMeCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountUsersValidateCreateQueryKey = (options: Options<AccountUsersValidateCreateData>) => createQueryKey('accountUsersValidateCreate', options);

export const accountUsersValidateCreateOptions = (options: Options<AccountUsersValidateCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountUsersValidateCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accountUsersValidateCreateQueryKey(options)
    });
};

export const accountUsersValidateCreateMutation = (options?: Partial<Options<AccountUsersValidateCreateData>>): UseMutationOptions<AccountUsersValidateCreateResponse, DefaultError, Options<AccountUsersValidateCreateData>> => {
    const mutationOptions: UseMutationOptions<AccountUsersValidateCreateResponse, DefaultError, Options<AccountUsersValidateCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await accountUsersValidateCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentsSimpleAgentThreadsListQueryKey = (options?: Options<AgentsSimpleAgentThreadsListData>) => createQueryKey('agentsSimpleAgentThreadsList', options);

export const agentsSimpleAgentThreadsListOptions = (options?: Options<AgentsSimpleAgentThreadsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await agentsSimpleAgentThreadsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentsSimpleAgentThreadsListQueryKey(options)
    });
};

export const agentsSimpleAgentThreadsListInfiniteQueryKey = (options?: Options<AgentsSimpleAgentThreadsListData>): QueryKey<Options<AgentsSimpleAgentThreadsListData>> => createQueryKey('agentsSimpleAgentThreadsList', options, true);

export const agentsSimpleAgentThreadsListInfiniteOptions = (options?: Options<AgentsSimpleAgentThreadsListData>) => {
    return infiniteQueryOptions<AgentsSimpleAgentThreadsListResponse, DefaultError, InfiniteData<AgentsSimpleAgentThreadsListResponse>, QueryKey<Options<AgentsSimpleAgentThreadsListData>>, number | Pick<QueryKey<Options<AgentsSimpleAgentThreadsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AgentsSimpleAgentThreadsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await agentsSimpleAgentThreadsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentsSimpleAgentThreadsListInfiniteQueryKey(options)
    });
};

export const agentsSimpleAgentThreadsCreateQueryKey = (options: Options<AgentsSimpleAgentThreadsCreateData>) => createQueryKey('agentsSimpleAgentThreadsCreate', options);

export const agentsSimpleAgentThreadsCreateOptions = (options: Options<AgentsSimpleAgentThreadsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await agentsSimpleAgentThreadsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentsSimpleAgentThreadsCreateQueryKey(options)
    });
};

export const agentsSimpleAgentThreadsCreateMutation = (options?: Partial<Options<AgentsSimpleAgentThreadsCreateData>>): UseMutationOptions<AgentsSimpleAgentThreadsCreateResponse, DefaultError, Options<AgentsSimpleAgentThreadsCreateData>> => {
    const mutationOptions: UseMutationOptions<AgentsSimpleAgentThreadsCreateResponse, DefaultError, Options<AgentsSimpleAgentThreadsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await agentsSimpleAgentThreadsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentsSimpleAgentThreadsDestroyMutation = (options?: Partial<Options<AgentsSimpleAgentThreadsDestroyData>>): UseMutationOptions<AgentsSimpleAgentThreadsDestroyResponse, DefaultError, Options<AgentsSimpleAgentThreadsDestroyData>> => {
    const mutationOptions: UseMutationOptions<AgentsSimpleAgentThreadsDestroyResponse, DefaultError, Options<AgentsSimpleAgentThreadsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await agentsSimpleAgentThreadsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentsSimpleAgentThreadsRetrieveQueryKey = (options: Options<AgentsSimpleAgentThreadsRetrieveData>) => createQueryKey('agentsSimpleAgentThreadsRetrieve', options);

export const agentsSimpleAgentThreadsRetrieveOptions = (options: Options<AgentsSimpleAgentThreadsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await agentsSimpleAgentThreadsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentsSimpleAgentThreadsRetrieveQueryKey(options)
    });
};

export const agentsSimpleAgentThreadsPartialUpdateMutation = (options?: Partial<Options<AgentsSimpleAgentThreadsPartialUpdateData>>): UseMutationOptions<AgentsSimpleAgentThreadsPartialUpdateResponse, DefaultError, Options<AgentsSimpleAgentThreadsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<AgentsSimpleAgentThreadsPartialUpdateResponse, DefaultError, Options<AgentsSimpleAgentThreadsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await agentsSimpleAgentThreadsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentsSimpleAgentThreadsUpdateMutation = (options?: Partial<Options<AgentsSimpleAgentThreadsUpdateData>>): UseMutationOptions<AgentsSimpleAgentThreadsUpdateResponse, DefaultError, Options<AgentsSimpleAgentThreadsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AgentsSimpleAgentThreadsUpdateResponse, DefaultError, Options<AgentsSimpleAgentThreadsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await agentsSimpleAgentThreadsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentsSimpleAgentsListQueryKey = (options?: Options<AgentsSimpleAgentsListData>) => createQueryKey('agentsSimpleAgentsList', options);

export const agentsSimpleAgentsListOptions = (options?: Options<AgentsSimpleAgentsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await agentsSimpleAgentsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentsSimpleAgentsListQueryKey(options)
    });
};

export const agentsSimpleAgentsListInfiniteQueryKey = (options?: Options<AgentsSimpleAgentsListData>): QueryKey<Options<AgentsSimpleAgentsListData>> => createQueryKey('agentsSimpleAgentsList', options, true);

export const agentsSimpleAgentsListInfiniteOptions = (options?: Options<AgentsSimpleAgentsListData>) => {
    return infiniteQueryOptions<AgentsSimpleAgentsListResponse, DefaultError, InfiniteData<AgentsSimpleAgentsListResponse>, QueryKey<Options<AgentsSimpleAgentsListData>>, number | Pick<QueryKey<Options<AgentsSimpleAgentsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AgentsSimpleAgentsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await agentsSimpleAgentsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentsSimpleAgentsListInfiniteQueryKey(options)
    });
};

export const agentsSimpleAgentsRetrieveQueryKey = (options: Options<AgentsSimpleAgentsRetrieveData>) => createQueryKey('agentsSimpleAgentsRetrieve', options);

export const agentsSimpleAgentsRetrieveOptions = (options: Options<AgentsSimpleAgentsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await agentsSimpleAgentsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentsSimpleAgentsRetrieveQueryKey(options)
    });
};

export const analyticsFeedbackCreateQueryKey = (options: Options<AnalyticsFeedbackCreateData>) => createQueryKey('analyticsFeedbackCreate', options);

export const analyticsFeedbackCreateOptions = (options: Options<AnalyticsFeedbackCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsFeedbackCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsFeedbackCreateQueryKey(options)
    });
};

export const analyticsFeedbackCreateMutation = (options?: Partial<Options<AnalyticsFeedbackCreateData>>): UseMutationOptions<AnalyticsFeedbackCreateResponse, DefaultError, Options<AnalyticsFeedbackCreateData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsFeedbackCreateResponse, DefaultError, Options<AnalyticsFeedbackCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await analyticsFeedbackCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsSurveyListQueryKey = (options?: Options<AnalyticsSurveyListData>) => createQueryKey('analyticsSurveyList', options);

export const analyticsSurveyListOptions = (options?: Options<AnalyticsSurveyListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsSurveyList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyListQueryKey(options)
    });
};

export const analyticsSurveyListInfiniteQueryKey = (options?: Options<AnalyticsSurveyListData>): QueryKey<Options<AnalyticsSurveyListData>> => createQueryKey('analyticsSurveyList', options, true);

export const analyticsSurveyListInfiniteOptions = (options?: Options<AnalyticsSurveyListData>) => {
    return infiniteQueryOptions<AnalyticsSurveyListResponse, DefaultError, InfiniteData<AnalyticsSurveyListResponse>, QueryKey<Options<AnalyticsSurveyListData>>, number | Pick<QueryKey<Options<AnalyticsSurveyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AnalyticsSurveyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await analyticsSurveyList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyListInfiniteQueryKey(options)
    });
};

export const analyticsSurveyCreateQueryKey = (options: Options<AnalyticsSurveyCreateData>) => createQueryKey('analyticsSurveyCreate', options);

export const analyticsSurveyCreateOptions = (options: Options<AnalyticsSurveyCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsSurveyCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyCreateQueryKey(options)
    });
};

export const analyticsSurveyCreateMutation = (options?: Partial<Options<AnalyticsSurveyCreateData>>): UseMutationOptions<AnalyticsSurveyCreateResponse, DefaultError, Options<AnalyticsSurveyCreateData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsSurveyCreateResponse, DefaultError, Options<AnalyticsSurveyCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await analyticsSurveyCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsSurveyDestroyMutation = (options?: Partial<Options<AnalyticsSurveyDestroyData>>): UseMutationOptions<AnalyticsSurveyDestroyResponse, DefaultError, Options<AnalyticsSurveyDestroyData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsSurveyDestroyResponse, DefaultError, Options<AnalyticsSurveyDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await analyticsSurveyDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsSurveyRetrieveQueryKey = (options: Options<AnalyticsSurveyRetrieveData>) => createQueryKey('analyticsSurveyRetrieve', options);

export const analyticsSurveyRetrieveOptions = (options: Options<AnalyticsSurveyRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsSurveyRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyRetrieveQueryKey(options)
    });
};

export const analyticsSurveyPartialUpdateMutation = (options?: Partial<Options<AnalyticsSurveyPartialUpdateData>>): UseMutationOptions<AnalyticsSurveyPartialUpdateResponse, DefaultError, Options<AnalyticsSurveyPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsSurveyPartialUpdateResponse, DefaultError, Options<AnalyticsSurveyPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await analyticsSurveyPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsSurveyUpdateMutation = (options?: Partial<Options<AnalyticsSurveyUpdateData>>): UseMutationOptions<AnalyticsSurveyUpdateResponse, DefaultError, Options<AnalyticsSurveyUpdateData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsSurveyUpdateResponse, DefaultError, Options<AnalyticsSurveyUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await analyticsSurveyUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsSurveyAiAnalysisListQueryKey = (options: Options<AnalyticsSurveyAiAnalysisListData>) => createQueryKey('analyticsSurveyAiAnalysisList', options);

export const analyticsSurveyAiAnalysisListOptions = (options: Options<AnalyticsSurveyAiAnalysisListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsSurveyAiAnalysisList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyAiAnalysisListQueryKey(options)
    });
};

export const analyticsSurveyAiAnalysisListInfiniteQueryKey = (options: Options<AnalyticsSurveyAiAnalysisListData>): QueryKey<Options<AnalyticsSurveyAiAnalysisListData>> => createQueryKey('analyticsSurveyAiAnalysisList', options, true);

export const analyticsSurveyAiAnalysisListInfiniteOptions = (options: Options<AnalyticsSurveyAiAnalysisListData>) => {
    return infiniteQueryOptions<AnalyticsSurveyAiAnalysisListResponse, DefaultError, InfiniteData<AnalyticsSurveyAiAnalysisListResponse>, QueryKey<Options<AnalyticsSurveyAiAnalysisListData>>, number | Pick<QueryKey<Options<AnalyticsSurveyAiAnalysisListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AnalyticsSurveyAiAnalysisListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await analyticsSurveyAiAnalysisList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyAiAnalysisListInfiniteQueryKey(options)
    });
};

export const analyticsSurveyPrepareEmailContentRetrieveQueryKey = (options: Options<AnalyticsSurveyPrepareEmailContentRetrieveData>) => createQueryKey('analyticsSurveyPrepareEmailContentRetrieve', options);

export const analyticsSurveyPrepareEmailContentRetrieveOptions = (options: Options<AnalyticsSurveyPrepareEmailContentRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsSurveyPrepareEmailContentRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyPrepareEmailContentRetrieveQueryKey(options)
    });
};

export const analyticsSurveyPublishCreateQueryKey = (options: Options<AnalyticsSurveyPublishCreateData>) => createQueryKey('analyticsSurveyPublishCreate', options);

export const analyticsSurveyPublishCreateOptions = (options: Options<AnalyticsSurveyPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsSurveyPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyPublishCreateQueryKey(options)
    });
};

export const analyticsSurveyPublishCreateMutation = (options?: Partial<Options<AnalyticsSurveyPublishCreateData>>): UseMutationOptions<AnalyticsSurveyPublishCreateResponse, DefaultError, Options<AnalyticsSurveyPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsSurveyPublishCreateResponse, DefaultError, Options<AnalyticsSurveyPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await analyticsSurveyPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsSurveyResultsListQueryKey = (options: Options<AnalyticsSurveyResultsListData>) => createQueryKey('analyticsSurveyResultsList', options);

export const analyticsSurveyResultsListOptions = (options: Options<AnalyticsSurveyResultsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await analyticsSurveyResultsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyResultsListQueryKey(options)
    });
};

export const analyticsSurveyResultsListInfiniteQueryKey = (options: Options<AnalyticsSurveyResultsListData>): QueryKey<Options<AnalyticsSurveyResultsListData>> => createQueryKey('analyticsSurveyResultsList', options, true);

export const analyticsSurveyResultsListInfiniteOptions = (options: Options<AnalyticsSurveyResultsListData>) => {
    return infiniteQueryOptions<AnalyticsSurveyResultsListResponse, DefaultError, InfiniteData<AnalyticsSurveyResultsListResponse>, QueryKey<Options<AnalyticsSurveyResultsListData>>, number | Pick<QueryKey<Options<AnalyticsSurveyResultsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AnalyticsSurveyResultsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await analyticsSurveyResultsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: analyticsSurveyResultsListInfiniteQueryKey(options)
    });
};

export const appsAppsListQueryKey = (options?: Options<AppsAppsListData>) => createQueryKey('appsAppsList', options);

export const appsAppsListOptions = (options?: Options<AppsAppsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsAppsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsAppsListQueryKey(options)
    });
};

export const appsAppsListInfiniteQueryKey = (options?: Options<AppsAppsListData>): QueryKey<Options<AppsAppsListData>> => createQueryKey('appsAppsList', options, true);

export const appsAppsListInfiniteOptions = (options?: Options<AppsAppsListData>) => {
    return infiniteQueryOptions<AppsAppsListResponse, DefaultError, InfiniteData<AppsAppsListResponse>, QueryKey<Options<AppsAppsListData>>, number | Pick<QueryKey<Options<AppsAppsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AppsAppsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await appsAppsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsAppsListInfiniteQueryKey(options)
    });
};

export const appsAppsCreateQueryKey = (options: Options<AppsAppsCreateData>) => createQueryKey('appsAppsCreate', options);

export const appsAppsCreateOptions = (options: Options<AppsAppsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsAppsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsAppsCreateQueryKey(options)
    });
};

export const appsAppsCreateMutation = (options?: Partial<Options<AppsAppsCreateData>>): UseMutationOptions<AppsAppsCreateResponse, DefaultError, Options<AppsAppsCreateData>> => {
    const mutationOptions: UseMutationOptions<AppsAppsCreateResponse, DefaultError, Options<AppsAppsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsAppsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsAppsDestroyMutation = (options?: Partial<Options<AppsAppsDestroyData>>): UseMutationOptions<AppsAppsDestroyResponse, DefaultError, Options<AppsAppsDestroyData>> => {
    const mutationOptions: UseMutationOptions<AppsAppsDestroyResponse, DefaultError, Options<AppsAppsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsAppsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsAppsRetrieveQueryKey = (options: Options<AppsAppsRetrieveData>) => createQueryKey('appsAppsRetrieve', options);

export const appsAppsRetrieveOptions = (options: Options<AppsAppsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsAppsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsAppsRetrieveQueryKey(options)
    });
};

export const appsAppsPartialUpdateMutation = (options?: Partial<Options<AppsAppsPartialUpdateData>>): UseMutationOptions<AppsAppsPartialUpdateResponse, DefaultError, Options<AppsAppsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<AppsAppsPartialUpdateResponse, DefaultError, Options<AppsAppsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsAppsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsAppsUpdateMutation = (options?: Partial<Options<AppsAppsUpdateData>>): UseMutationOptions<AppsAppsUpdateResponse, DefaultError, Options<AppsAppsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AppsAppsUpdateResponse, DefaultError, Options<AppsAppsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsAppsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsDeploymentsListQueryKey = (options: Options<AppsDeploymentsListData>) => createQueryKey('appsDeploymentsList', options);

export const appsDeploymentsListOptions = (options: Options<AppsDeploymentsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsDeploymentsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsDeploymentsListQueryKey(options)
    });
};

export const appsDeploymentsListInfiniteQueryKey = (options: Options<AppsDeploymentsListData>): QueryKey<Options<AppsDeploymentsListData>> => createQueryKey('appsDeploymentsList', options, true);

export const appsDeploymentsListInfiniteOptions = (options: Options<AppsDeploymentsListData>) => {
    return infiniteQueryOptions<AppsDeploymentsListResponse, DefaultError, InfiniteData<AppsDeploymentsListResponse>, QueryKey<Options<AppsDeploymentsListData>>, number | Pick<QueryKey<Options<AppsDeploymentsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AppsDeploymentsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await appsDeploymentsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsDeploymentsListInfiniteQueryKey(options)
    });
};

export const appsDeploymentsInvokeCreateQueryKey = (options: Options<AppsDeploymentsInvokeCreateData>) => createQueryKey('appsDeploymentsInvokeCreate', options);

export const appsDeploymentsInvokeCreateOptions = (options: Options<AppsDeploymentsInvokeCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsDeploymentsInvokeCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsDeploymentsInvokeCreateQueryKey(options)
    });
};

export const appsDeploymentsInvokeCreateMutation = (options?: Partial<Options<AppsDeploymentsInvokeCreateData>>): UseMutationOptions<AppsDeploymentsInvokeCreateResponse, DefaultError, Options<AppsDeploymentsInvokeCreateData>> => {
    const mutationOptions: UseMutationOptions<AppsDeploymentsInvokeCreateResponse, DefaultError, Options<AppsDeploymentsInvokeCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsDeploymentsInvokeCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsInstalledAppsListQueryKey = (options?: Options<AppsInstalledAppsListData>) => createQueryKey('appsInstalledAppsList', options);

export const appsInstalledAppsListOptions = (options?: Options<AppsInstalledAppsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsInstalledAppsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsInstalledAppsListQueryKey(options)
    });
};

export const appsInstalledAppsListInfiniteQueryKey = (options?: Options<AppsInstalledAppsListData>): QueryKey<Options<AppsInstalledAppsListData>> => createQueryKey('appsInstalledAppsList', options, true);

export const appsInstalledAppsListInfiniteOptions = (options?: Options<AppsInstalledAppsListData>) => {
    return infiniteQueryOptions<AppsInstalledAppsListResponse, DefaultError, InfiniteData<AppsInstalledAppsListResponse>, QueryKey<Options<AppsInstalledAppsListData>>, number | Pick<QueryKey<Options<AppsInstalledAppsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AppsInstalledAppsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await appsInstalledAppsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsInstalledAppsListInfiniteQueryKey(options)
    });
};

export const appsInstalledAppsCreateQueryKey = (options: Options<AppsInstalledAppsCreateData>) => createQueryKey('appsInstalledAppsCreate', options);

export const appsInstalledAppsCreateOptions = (options: Options<AppsInstalledAppsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsInstalledAppsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsInstalledAppsCreateQueryKey(options)
    });
};

export const appsInstalledAppsCreateMutation = (options?: Partial<Options<AppsInstalledAppsCreateData>>): UseMutationOptions<AppsInstalledAppsCreateResponse, DefaultError, Options<AppsInstalledAppsCreateData>> => {
    const mutationOptions: UseMutationOptions<AppsInstalledAppsCreateResponse, DefaultError, Options<AppsInstalledAppsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsInstalledAppsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsInstalledAppsDestroyMutation = (options?: Partial<Options<AppsInstalledAppsDestroyData>>): UseMutationOptions<AppsInstalledAppsDestroyResponse, DefaultError, Options<AppsInstalledAppsDestroyData>> => {
    const mutationOptions: UseMutationOptions<AppsInstalledAppsDestroyResponse, DefaultError, Options<AppsInstalledAppsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsInstalledAppsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsInstalledAppsRetrieveQueryKey = (options: Options<AppsInstalledAppsRetrieveData>) => createQueryKey('appsInstalledAppsRetrieve', options);

export const appsInstalledAppsRetrieveOptions = (options: Options<AppsInstalledAppsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appsInstalledAppsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appsInstalledAppsRetrieveQueryKey(options)
    });
};

export const appsInstalledAppsPartialUpdateMutation = (options?: Partial<Options<AppsInstalledAppsPartialUpdateData>>): UseMutationOptions<AppsInstalledAppsPartialUpdateResponse, DefaultError, Options<AppsInstalledAppsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<AppsInstalledAppsPartialUpdateResponse, DefaultError, Options<AppsInstalledAppsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsInstalledAppsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appsInstalledAppsUpdateMutation = (options?: Partial<Options<AppsInstalledAppsUpdateData>>): UseMutationOptions<AppsInstalledAppsUpdateResponse, DefaultError, Options<AppsInstalledAppsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AppsInstalledAppsUpdateResponse, DefaultError, Options<AppsInstalledAppsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appsInstalledAppsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAssetsListQueryKey = (options?: Options<CampaignAssetsListData>) => createQueryKey('campaignAssetsList', options);

export const campaignAssetsListOptions = (options?: Options<CampaignAssetsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignAssetsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAssetsListQueryKey(options)
    });
};

export const campaignAssetsListInfiniteQueryKey = (options?: Options<CampaignAssetsListData>): QueryKey<Options<CampaignAssetsListData>> => createQueryKey('campaignAssetsList', options, true);

export const campaignAssetsListInfiniteOptions = (options?: Options<CampaignAssetsListData>) => {
    return infiniteQueryOptions<CampaignAssetsListResponse, DefaultError, InfiniteData<CampaignAssetsListResponse>, QueryKey<Options<CampaignAssetsListData>>, number | Pick<QueryKey<Options<CampaignAssetsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CampaignAssetsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await campaignAssetsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAssetsListInfiniteQueryKey(options)
    });
};

export const campaignAssetsCreateQueryKey = (options: Options<CampaignAssetsCreateData>) => createQueryKey('campaignAssetsCreate', options);

export const campaignAssetsCreateOptions = (options: Options<CampaignAssetsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignAssetsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAssetsCreateQueryKey(options)
    });
};

export const campaignAssetsCreateMutation = (options?: Partial<Options<CampaignAssetsCreateData>>): UseMutationOptions<CampaignAssetsCreateResponse, DefaultError, Options<CampaignAssetsCreateData>> => {
    const mutationOptions: UseMutationOptions<CampaignAssetsCreateResponse, DefaultError, Options<CampaignAssetsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAssetsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAssetsDestroyMutation = (options?: Partial<Options<CampaignAssetsDestroyData>>): UseMutationOptions<CampaignAssetsDestroyResponse, DefaultError, Options<CampaignAssetsDestroyData>> => {
    const mutationOptions: UseMutationOptions<CampaignAssetsDestroyResponse, DefaultError, Options<CampaignAssetsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAssetsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAssetsRetrieveQueryKey = (options: Options<CampaignAssetsRetrieveData>) => createQueryKey('campaignAssetsRetrieve', options);

export const campaignAssetsRetrieveOptions = (options: Options<CampaignAssetsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignAssetsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAssetsRetrieveQueryKey(options)
    });
};

export const campaignAssetsPartialUpdateMutation = (options?: Partial<Options<CampaignAssetsPartialUpdateData>>): UseMutationOptions<CampaignAssetsPartialUpdateResponse, DefaultError, Options<CampaignAssetsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignAssetsPartialUpdateResponse, DefaultError, Options<CampaignAssetsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAssetsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAssetsUpdateMutation = (options?: Partial<Options<CampaignAssetsUpdateData>>): UseMutationOptions<CampaignAssetsUpdateResponse, DefaultError, Options<CampaignAssetsUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignAssetsUpdateResponse, DefaultError, Options<CampaignAssetsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAssetsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAudiencesListQueryKey = (options?: Options<CampaignAudiencesListData>) => createQueryKey('campaignAudiencesList', options);

export const campaignAudiencesListOptions = (options?: Options<CampaignAudiencesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignAudiencesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAudiencesListQueryKey(options)
    });
};

export const campaignAudiencesListInfiniteQueryKey = (options?: Options<CampaignAudiencesListData>): QueryKey<Options<CampaignAudiencesListData>> => createQueryKey('campaignAudiencesList', options, true);

export const campaignAudiencesListInfiniteOptions = (options?: Options<CampaignAudiencesListData>) => {
    return infiniteQueryOptions<CampaignAudiencesListResponse, DefaultError, InfiniteData<CampaignAudiencesListResponse>, QueryKey<Options<CampaignAudiencesListData>>, number | Pick<QueryKey<Options<CampaignAudiencesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CampaignAudiencesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await campaignAudiencesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAudiencesListInfiniteQueryKey(options)
    });
};

export const campaignAudiencesCreateQueryKey = (options: Options<CampaignAudiencesCreateData>) => createQueryKey('campaignAudiencesCreate', options);

export const campaignAudiencesCreateOptions = (options: Options<CampaignAudiencesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignAudiencesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAudiencesCreateQueryKey(options)
    });
};

export const campaignAudiencesCreateMutation = (options?: Partial<Options<CampaignAudiencesCreateData>>): UseMutationOptions<CampaignAudiencesCreateResponse, DefaultError, Options<CampaignAudiencesCreateData>> => {
    const mutationOptions: UseMutationOptions<CampaignAudiencesCreateResponse, DefaultError, Options<CampaignAudiencesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAudiencesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAudiencesDestroyMutation = (options?: Partial<Options<CampaignAudiencesDestroyData>>): UseMutationOptions<CampaignAudiencesDestroyResponse, DefaultError, Options<CampaignAudiencesDestroyData>> => {
    const mutationOptions: UseMutationOptions<CampaignAudiencesDestroyResponse, DefaultError, Options<CampaignAudiencesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAudiencesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAudiencesRetrieveQueryKey = (options: Options<CampaignAudiencesRetrieveData>) => createQueryKey('campaignAudiencesRetrieve', options);

export const campaignAudiencesRetrieveOptions = (options: Options<CampaignAudiencesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignAudiencesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAudiencesRetrieveQueryKey(options)
    });
};

export const campaignAudiencesPartialUpdateMutation = (options?: Partial<Options<CampaignAudiencesPartialUpdateData>>): UseMutationOptions<CampaignAudiencesPartialUpdateResponse, DefaultError, Options<CampaignAudiencesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignAudiencesPartialUpdateResponse, DefaultError, Options<CampaignAudiencesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAudiencesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAudiencesUpdateMutation = (options?: Partial<Options<CampaignAudiencesUpdateData>>): UseMutationOptions<CampaignAudiencesUpdateResponse, DefaultError, Options<CampaignAudiencesUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignAudiencesUpdateResponse, DefaultError, Options<CampaignAudiencesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAudiencesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignAudiencesEstimateMatchRateCreateQueryKey = (options: Options<CampaignAudiencesEstimateMatchRateCreateData>) => createQueryKey('campaignAudiencesEstimateMatchRateCreate', options);

export const campaignAudiencesEstimateMatchRateCreateOptions = (options: Options<CampaignAudiencesEstimateMatchRateCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignAudiencesEstimateMatchRateCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignAudiencesEstimateMatchRateCreateQueryKey(options)
    });
};

export const campaignAudiencesEstimateMatchRateCreateMutation = (options?: Partial<Options<CampaignAudiencesEstimateMatchRateCreateData>>): UseMutationOptions<unknown, DefaultError, Options<CampaignAudiencesEstimateMatchRateCreateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CampaignAudiencesEstimateMatchRateCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignAudiencesEstimateMatchRateCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignCampaignsListQueryKey = (options?: Options<CampaignCampaignsListData>) => createQueryKey('campaignCampaignsList', options);

export const campaignCampaignsListOptions = (options?: Options<CampaignCampaignsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignCampaignsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignCampaignsListQueryKey(options)
    });
};

export const campaignCampaignsListInfiniteQueryKey = (options?: Options<CampaignCampaignsListData>): QueryKey<Options<CampaignCampaignsListData>> => createQueryKey('campaignCampaignsList', options, true);

export const campaignCampaignsListInfiniteOptions = (options?: Options<CampaignCampaignsListData>) => {
    return infiniteQueryOptions<CampaignCampaignsListResponse, DefaultError, InfiniteData<CampaignCampaignsListResponse>, QueryKey<Options<CampaignCampaignsListData>>, number | Pick<QueryKey<Options<CampaignCampaignsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CampaignCampaignsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await campaignCampaignsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignCampaignsListInfiniteQueryKey(options)
    });
};

export const campaignCampaignsCreateQueryKey = (options: Options<CampaignCampaignsCreateData>) => createQueryKey('campaignCampaignsCreate', options);

export const campaignCampaignsCreateOptions = (options: Options<CampaignCampaignsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignCampaignsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignCampaignsCreateQueryKey(options)
    });
};

export const campaignCampaignsCreateMutation = (options?: Partial<Options<CampaignCampaignsCreateData>>): UseMutationOptions<CampaignCampaignsCreateResponse, DefaultError, Options<CampaignCampaignsCreateData>> => {
    const mutationOptions: UseMutationOptions<CampaignCampaignsCreateResponse, DefaultError, Options<CampaignCampaignsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignCampaignsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignCampaignsDestroyMutation = (options?: Partial<Options<CampaignCampaignsDestroyData>>): UseMutationOptions<CampaignCampaignsDestroyResponse, DefaultError, Options<CampaignCampaignsDestroyData>> => {
    const mutationOptions: UseMutationOptions<CampaignCampaignsDestroyResponse, DefaultError, Options<CampaignCampaignsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignCampaignsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignCampaignsRetrieveQueryKey = (options: Options<CampaignCampaignsRetrieveData>) => createQueryKey('campaignCampaignsRetrieve', options);

export const campaignCampaignsRetrieveOptions = (options: Options<CampaignCampaignsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignCampaignsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignCampaignsRetrieveQueryKey(options)
    });
};

export const campaignCampaignsPartialUpdateMutation = (options?: Partial<Options<CampaignCampaignsPartialUpdateData>>): UseMutationOptions<CampaignCampaignsPartialUpdateResponse, DefaultError, Options<CampaignCampaignsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignCampaignsPartialUpdateResponse, DefaultError, Options<CampaignCampaignsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignCampaignsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignCampaignsUpdateMutation = (options?: Partial<Options<CampaignCampaignsUpdateData>>): UseMutationOptions<CampaignCampaignsUpdateResponse, DefaultError, Options<CampaignCampaignsUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignCampaignsUpdateResponse, DefaultError, Options<CampaignCampaignsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignCampaignsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignContentTypesListQueryKey = (options?: Options<CampaignContentTypesListData>) => createQueryKey('campaignContentTypesList', options);

export const campaignContentTypesListOptions = (options?: Options<CampaignContentTypesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignContentTypesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignContentTypesListQueryKey(options)
    });
};

export const campaignContentTypesListInfiniteQueryKey = (options?: Options<CampaignContentTypesListData>): QueryKey<Options<CampaignContentTypesListData>> => createQueryKey('campaignContentTypesList', options, true);

export const campaignContentTypesListInfiniteOptions = (options?: Options<CampaignContentTypesListData>) => {
    return infiniteQueryOptions<CampaignContentTypesListResponse, DefaultError, InfiniteData<CampaignContentTypesListResponse>, QueryKey<Options<CampaignContentTypesListData>>, number | Pick<QueryKey<Options<CampaignContentTypesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CampaignContentTypesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await campaignContentTypesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignContentTypesListInfiniteQueryKey(options)
    });
};

export const campaignContentTypesCreateQueryKey = (options: Options<CampaignContentTypesCreateData>) => createQueryKey('campaignContentTypesCreate', options);

export const campaignContentTypesCreateOptions = (options: Options<CampaignContentTypesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignContentTypesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignContentTypesCreateQueryKey(options)
    });
};

export const campaignContentTypesCreateMutation = (options?: Partial<Options<CampaignContentTypesCreateData>>): UseMutationOptions<CampaignContentTypesCreateResponse, DefaultError, Options<CampaignContentTypesCreateData>> => {
    const mutationOptions: UseMutationOptions<CampaignContentTypesCreateResponse, DefaultError, Options<CampaignContentTypesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignContentTypesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignContentTypesDestroyMutation = (options?: Partial<Options<CampaignContentTypesDestroyData>>): UseMutationOptions<CampaignContentTypesDestroyResponse, DefaultError, Options<CampaignContentTypesDestroyData>> => {
    const mutationOptions: UseMutationOptions<CampaignContentTypesDestroyResponse, DefaultError, Options<CampaignContentTypesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignContentTypesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignContentTypesRetrieveQueryKey = (options: Options<CampaignContentTypesRetrieveData>) => createQueryKey('campaignContentTypesRetrieve', options);

export const campaignContentTypesRetrieveOptions = (options: Options<CampaignContentTypesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await campaignContentTypesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: campaignContentTypesRetrieveQueryKey(options)
    });
};

export const campaignContentTypesPartialUpdateMutation = (options?: Partial<Options<CampaignContentTypesPartialUpdateData>>): UseMutationOptions<CampaignContentTypesPartialUpdateResponse, DefaultError, Options<CampaignContentTypesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignContentTypesPartialUpdateResponse, DefaultError, Options<CampaignContentTypesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignContentTypesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignContentTypesUpdateMutation = (options?: Partial<Options<CampaignContentTypesUpdateData>>): UseMutationOptions<CampaignContentTypesUpdateResponse, DefaultError, Options<CampaignContentTypesUpdateData>> => {
    const mutationOptions: UseMutationOptions<CampaignContentTypesUpdateResponse, DefaultError, Options<CampaignContentTypesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await campaignContentTypesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configClientsListQueryKey = (options?: Options<ConfigClientsListData>) => createQueryKey('configClientsList', options);

export const configClientsListOptions = (options?: Options<ConfigClientsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configClientsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configClientsListQueryKey(options)
    });
};

export const configClientsListInfiniteQueryKey = (options?: Options<ConfigClientsListData>): QueryKey<Options<ConfigClientsListData>> => createQueryKey('configClientsList', options, true);

export const configClientsListInfiniteOptions = (options?: Options<ConfigClientsListData>) => {
    return infiniteQueryOptions<ConfigClientsListResponse, DefaultError, InfiniteData<ConfigClientsListResponse>, QueryKey<Options<ConfigClientsListData>>, number | Pick<QueryKey<Options<ConfigClientsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigClientsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configClientsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configClientsListInfiniteQueryKey(options)
    });
};

export const configClientsCreateQueryKey = (options: Options<ConfigClientsCreateData>) => createQueryKey('configClientsCreate', options);

export const configClientsCreateOptions = (options: Options<ConfigClientsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configClientsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configClientsCreateQueryKey(options)
    });
};

export const configClientsCreateMutation = (options?: Partial<Options<ConfigClientsCreateData>>): UseMutationOptions<ConfigClientsCreateResponse, DefaultError, Options<ConfigClientsCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigClientsCreateResponse, DefaultError, Options<ConfigClientsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configClientsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configClientsDestroyMutation = (options?: Partial<Options<ConfigClientsDestroyData>>): UseMutationOptions<ConfigClientsDestroyResponse, DefaultError, Options<ConfigClientsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ConfigClientsDestroyResponse, DefaultError, Options<ConfigClientsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configClientsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configClientsRetrieveQueryKey = (options: Options<ConfigClientsRetrieveData>) => createQueryKey('configClientsRetrieve', options);

export const configClientsRetrieveOptions = (options: Options<ConfigClientsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configClientsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configClientsRetrieveQueryKey(options)
    });
};

export const configClientsPartialUpdateMutation = (options?: Partial<Options<ConfigClientsPartialUpdateData>>): UseMutationOptions<ConfigClientsPartialUpdateResponse, DefaultError, Options<ConfigClientsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigClientsPartialUpdateResponse, DefaultError, Options<ConfigClientsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configClientsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configClientsUpdateMutation = (options?: Partial<Options<ConfigClientsUpdateData>>): UseMutationOptions<ConfigClientsUpdateResponse, DefaultError, Options<ConfigClientsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigClientsUpdateResponse, DefaultError, Options<ConfigClientsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configClientsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configClientsDetailsRetrieveQueryKey = (options: Options<ConfigClientsDetailsRetrieveData>) => createQueryKey('configClientsDetailsRetrieve', options);

export const configClientsDetailsRetrieveOptions = (options: Options<ConfigClientsDetailsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configClientsDetailsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configClientsDetailsRetrieveQueryKey(options)
    });
};

export const configClientsLanguagesRetrieveQueryKey = (options?: Options<ConfigClientsLanguagesRetrieveData>) => createQueryKey('configClientsLanguagesRetrieve', options);

export const configClientsLanguagesRetrieveOptions = (options?: Options<ConfigClientsLanguagesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configClientsLanguagesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configClientsLanguagesRetrieveQueryKey(options)
    });
};

export const configClientsLookupRetrieveQueryKey = (options: Options<ConfigClientsLookupRetrieveData>) => createQueryKey('configClientsLookupRetrieve', options);

export const configClientsLookupRetrieveOptions = (options: Options<ConfigClientsLookupRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configClientsLookupRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configClientsLookupRetrieveQueryKey(options)
    });
};

export const configCouriersListQueryKey = (options?: Options<ConfigCouriersListData>) => createQueryKey('configCouriersList', options);

export const configCouriersListOptions = (options?: Options<ConfigCouriersListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configCouriersList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configCouriersListQueryKey(options)
    });
};

export const configCouriersListInfiniteQueryKey = (options?: Options<ConfigCouriersListData>): QueryKey<Options<ConfigCouriersListData>> => createQueryKey('configCouriersList', options, true);

export const configCouriersListInfiniteOptions = (options?: Options<ConfigCouriersListData>) => {
    return infiniteQueryOptions<ConfigCouriersListResponse, DefaultError, InfiniteData<ConfigCouriersListResponse>, QueryKey<Options<ConfigCouriersListData>>, number | Pick<QueryKey<Options<ConfigCouriersListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigCouriersListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configCouriersList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configCouriersListInfiniteQueryKey(options)
    });
};

export const configCouriersCreateQueryKey = (options: Options<ConfigCouriersCreateData>) => createQueryKey('configCouriersCreate', options);

export const configCouriersCreateOptions = (options: Options<ConfigCouriersCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configCouriersCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configCouriersCreateQueryKey(options)
    });
};

export const configCouriersCreateMutation = (options?: Partial<Options<ConfigCouriersCreateData>>): UseMutationOptions<ConfigCouriersCreateResponse, DefaultError, Options<ConfigCouriersCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigCouriersCreateResponse, DefaultError, Options<ConfigCouriersCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configCouriersCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configCouriersDestroyMutation = (options?: Partial<Options<ConfigCouriersDestroyData>>): UseMutationOptions<ConfigCouriersDestroyResponse, DefaultError, Options<ConfigCouriersDestroyData>> => {
    const mutationOptions: UseMutationOptions<ConfigCouriersDestroyResponse, DefaultError, Options<ConfigCouriersDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configCouriersDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configCouriersRetrieveQueryKey = (options: Options<ConfigCouriersRetrieveData>) => createQueryKey('configCouriersRetrieve', options);

export const configCouriersRetrieveOptions = (options: Options<ConfigCouriersRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configCouriersRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configCouriersRetrieveQueryKey(options)
    });
};

export const configCouriersPartialUpdateMutation = (options?: Partial<Options<ConfigCouriersPartialUpdateData>>): UseMutationOptions<ConfigCouriersPartialUpdateResponse, DefaultError, Options<ConfigCouriersPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigCouriersPartialUpdateResponse, DefaultError, Options<ConfigCouriersPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configCouriersPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configCouriersUpdateMutation = (options?: Partial<Options<ConfigCouriersUpdateData>>): UseMutationOptions<ConfigCouriersUpdateResponse, DefaultError, Options<ConfigCouriersUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigCouriersUpdateResponse, DefaultError, Options<ConfigCouriersUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configCouriersUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configFilterFieldsListQueryKey = (options?: Options<ConfigFilterFieldsListData>) => createQueryKey('configFilterFieldsList', options);

export const configFilterFieldsListOptions = (options?: Options<ConfigFilterFieldsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configFilterFieldsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configFilterFieldsListQueryKey(options)
    });
};

export const configFilterFieldsListInfiniteQueryKey = (options?: Options<ConfigFilterFieldsListData>): QueryKey<Options<ConfigFilterFieldsListData>> => createQueryKey('configFilterFieldsList', options, true);

export const configFilterFieldsListInfiniteOptions = (options?: Options<ConfigFilterFieldsListData>) => {
    return infiniteQueryOptions<ConfigFilterFieldsListResponse, DefaultError, InfiniteData<ConfigFilterFieldsListResponse>, QueryKey<Options<ConfigFilterFieldsListData>>, number | Pick<QueryKey<Options<ConfigFilterFieldsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigFilterFieldsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configFilterFieldsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configFilterFieldsListInfiniteQueryKey(options)
    });
};

export const configFilterFieldsCreateQueryKey = (options: Options<ConfigFilterFieldsCreateData>) => createQueryKey('configFilterFieldsCreate', options);

export const configFilterFieldsCreateOptions = (options: Options<ConfigFilterFieldsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configFilterFieldsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configFilterFieldsCreateQueryKey(options)
    });
};

export const configFilterFieldsCreateMutation = (options?: Partial<Options<ConfigFilterFieldsCreateData>>): UseMutationOptions<ConfigFilterFieldsCreateResponse, DefaultError, Options<ConfigFilterFieldsCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigFilterFieldsCreateResponse, DefaultError, Options<ConfigFilterFieldsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configFilterFieldsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configFilterFieldsDestroyMutation = (options?: Partial<Options<ConfigFilterFieldsDestroyData>>): UseMutationOptions<ConfigFilterFieldsDestroyResponse, DefaultError, Options<ConfigFilterFieldsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ConfigFilterFieldsDestroyResponse, DefaultError, Options<ConfigFilterFieldsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configFilterFieldsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configFilterFieldsRetrieveQueryKey = (options: Options<ConfigFilterFieldsRetrieveData>) => createQueryKey('configFilterFieldsRetrieve', options);

export const configFilterFieldsRetrieveOptions = (options: Options<ConfigFilterFieldsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configFilterFieldsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configFilterFieldsRetrieveQueryKey(options)
    });
};

export const configFilterFieldsPartialUpdateMutation = (options?: Partial<Options<ConfigFilterFieldsPartialUpdateData>>): UseMutationOptions<ConfigFilterFieldsPartialUpdateResponse, DefaultError, Options<ConfigFilterFieldsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigFilterFieldsPartialUpdateResponse, DefaultError, Options<ConfigFilterFieldsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configFilterFieldsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configFilterFieldsUpdateMutation = (options?: Partial<Options<ConfigFilterFieldsUpdateData>>): UseMutationOptions<ConfigFilterFieldsUpdateResponse, DefaultError, Options<ConfigFilterFieldsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigFilterFieldsUpdateResponse, DefaultError, Options<ConfigFilterFieldsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configFilterFieldsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configIntegrationsListQueryKey = (options?: Options<ConfigIntegrationsListData>) => createQueryKey('configIntegrationsList', options);

export const configIntegrationsListOptions = (options?: Options<ConfigIntegrationsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configIntegrationsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configIntegrationsListQueryKey(options)
    });
};

export const configIntegrationsListInfiniteQueryKey = (options?: Options<ConfigIntegrationsListData>): QueryKey<Options<ConfigIntegrationsListData>> => createQueryKey('configIntegrationsList', options, true);

export const configIntegrationsListInfiniteOptions = (options?: Options<ConfigIntegrationsListData>) => {
    return infiniteQueryOptions<ConfigIntegrationsListResponse, DefaultError, InfiniteData<ConfigIntegrationsListResponse>, QueryKey<Options<ConfigIntegrationsListData>>, number | Pick<QueryKey<Options<ConfigIntegrationsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigIntegrationsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configIntegrationsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configIntegrationsListInfiniteQueryKey(options)
    });
};

export const configIntegrationsCreateQueryKey = (options: Options<ConfigIntegrationsCreateData>) => createQueryKey('configIntegrationsCreate', options);

export const configIntegrationsCreateOptions = (options: Options<ConfigIntegrationsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configIntegrationsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configIntegrationsCreateQueryKey(options)
    });
};

export const configIntegrationsCreateMutation = (options?: Partial<Options<ConfigIntegrationsCreateData>>): UseMutationOptions<ConfigIntegrationsCreateResponse, DefaultError, Options<ConfigIntegrationsCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigIntegrationsCreateResponse, DefaultError, Options<ConfigIntegrationsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configIntegrationsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configIntegrationsDestroyMutation = (options?: Partial<Options<ConfigIntegrationsDestroyData>>): UseMutationOptions<ConfigIntegrationsDestroyResponse, DefaultError, Options<ConfigIntegrationsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ConfigIntegrationsDestroyResponse, DefaultError, Options<ConfigIntegrationsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configIntegrationsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configIntegrationsRetrieveQueryKey = (options: Options<ConfigIntegrationsRetrieveData>) => createQueryKey('configIntegrationsRetrieve', options);

export const configIntegrationsRetrieveOptions = (options: Options<ConfigIntegrationsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configIntegrationsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configIntegrationsRetrieveQueryKey(options)
    });
};

export const configIntegrationsPartialUpdateMutation = (options?: Partial<Options<ConfigIntegrationsPartialUpdateData>>): UseMutationOptions<ConfigIntegrationsPartialUpdateResponse, DefaultError, Options<ConfigIntegrationsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigIntegrationsPartialUpdateResponse, DefaultError, Options<ConfigIntegrationsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configIntegrationsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configIntegrationsUpdateMutation = (options?: Partial<Options<ConfigIntegrationsUpdateData>>): UseMutationOptions<ConfigIntegrationsUpdateResponse, DefaultError, Options<ConfigIntegrationsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigIntegrationsUpdateResponse, DefaultError, Options<ConfigIntegrationsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configIntegrationsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configReferenceItemsListQueryKey = (options?: Options<ConfigReferenceItemsListData>) => createQueryKey('configReferenceItemsList', options);

export const configReferenceItemsListOptions = (options?: Options<ConfigReferenceItemsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configReferenceItemsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configReferenceItemsListQueryKey(options)
    });
};

export const configReferenceItemsListInfiniteQueryKey = (options?: Options<ConfigReferenceItemsListData>): QueryKey<Options<ConfigReferenceItemsListData>> => createQueryKey('configReferenceItemsList', options, true);

export const configReferenceItemsListInfiniteOptions = (options?: Options<ConfigReferenceItemsListData>) => {
    return infiniteQueryOptions<ConfigReferenceItemsListResponse, DefaultError, InfiniteData<ConfigReferenceItemsListResponse>, QueryKey<Options<ConfigReferenceItemsListData>>, number | Pick<QueryKey<Options<ConfigReferenceItemsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigReferenceItemsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configReferenceItemsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configReferenceItemsListInfiniteQueryKey(options)
    });
};

export const configReferenceItemsCreateQueryKey = (options: Options<ConfigReferenceItemsCreateData>) => createQueryKey('configReferenceItemsCreate', options);

export const configReferenceItemsCreateOptions = (options: Options<ConfigReferenceItemsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configReferenceItemsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configReferenceItemsCreateQueryKey(options)
    });
};

export const configReferenceItemsCreateMutation = (options?: Partial<Options<ConfigReferenceItemsCreateData>>): UseMutationOptions<ConfigReferenceItemsCreateResponse, DefaultError, Options<ConfigReferenceItemsCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigReferenceItemsCreateResponse, DefaultError, Options<ConfigReferenceItemsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configReferenceItemsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configReferenceItemsDestroyMutation = (options?: Partial<Options<ConfigReferenceItemsDestroyData>>): UseMutationOptions<ConfigReferenceItemsDestroyResponse, DefaultError, Options<ConfigReferenceItemsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ConfigReferenceItemsDestroyResponse, DefaultError, Options<ConfigReferenceItemsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configReferenceItemsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configReferenceItemsRetrieveQueryKey = (options: Options<ConfigReferenceItemsRetrieveData>) => createQueryKey('configReferenceItemsRetrieve', options);

export const configReferenceItemsRetrieveOptions = (options: Options<ConfigReferenceItemsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configReferenceItemsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configReferenceItemsRetrieveQueryKey(options)
    });
};

export const configReferenceItemsPartialUpdateMutation = (options?: Partial<Options<ConfigReferenceItemsPartialUpdateData>>): UseMutationOptions<ConfigReferenceItemsPartialUpdateResponse, DefaultError, Options<ConfigReferenceItemsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigReferenceItemsPartialUpdateResponse, DefaultError, Options<ConfigReferenceItemsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configReferenceItemsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configReferenceItemsUpdateMutation = (options?: Partial<Options<ConfigReferenceItemsUpdateData>>): UseMutationOptions<ConfigReferenceItemsUpdateResponse, DefaultError, Options<ConfigReferenceItemsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigReferenceItemsUpdateResponse, DefaultError, Options<ConfigReferenceItemsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configReferenceItemsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configSmsAutoreplyConfigListQueryKey = (options?: Options<ConfigSmsAutoreplyConfigListData>) => createQueryKey('configSmsAutoreplyConfigList', options);

export const configSmsAutoreplyConfigListOptions = (options?: Options<ConfigSmsAutoreplyConfigListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configSmsAutoreplyConfigList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configSmsAutoreplyConfigListQueryKey(options)
    });
};

export const configSmsAutoreplyConfigListInfiniteQueryKey = (options?: Options<ConfigSmsAutoreplyConfigListData>): QueryKey<Options<ConfigSmsAutoreplyConfigListData>> => createQueryKey('configSmsAutoreplyConfigList', options, true);

export const configSmsAutoreplyConfigListInfiniteOptions = (options?: Options<ConfigSmsAutoreplyConfigListData>) => {
    return infiniteQueryOptions<ConfigSmsAutoreplyConfigListResponse, DefaultError, InfiniteData<ConfigSmsAutoreplyConfigListResponse>, QueryKey<Options<ConfigSmsAutoreplyConfigListData>>, number | Pick<QueryKey<Options<ConfigSmsAutoreplyConfigListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigSmsAutoreplyConfigListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configSmsAutoreplyConfigList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configSmsAutoreplyConfigListInfiniteQueryKey(options)
    });
};

export const configSmsAutoreplyConfigCreateQueryKey = (options: Options<ConfigSmsAutoreplyConfigCreateData>) => createQueryKey('configSmsAutoreplyConfigCreate', options);

export const configSmsAutoreplyConfigCreateOptions = (options: Options<ConfigSmsAutoreplyConfigCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configSmsAutoreplyConfigCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configSmsAutoreplyConfigCreateQueryKey(options)
    });
};

export const configSmsAutoreplyConfigCreateMutation = (options?: Partial<Options<ConfigSmsAutoreplyConfigCreateData>>): UseMutationOptions<ConfigSmsAutoreplyConfigCreateResponse, DefaultError, Options<ConfigSmsAutoreplyConfigCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigSmsAutoreplyConfigCreateResponse, DefaultError, Options<ConfigSmsAutoreplyConfigCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configSmsAutoreplyConfigCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configSmsAutoreplyConfigDestroyMutation = (options?: Partial<Options<ConfigSmsAutoreplyConfigDestroyData>>): UseMutationOptions<ConfigSmsAutoreplyConfigDestroyResponse, DefaultError, Options<ConfigSmsAutoreplyConfigDestroyData>> => {
    const mutationOptions: UseMutationOptions<ConfigSmsAutoreplyConfigDestroyResponse, DefaultError, Options<ConfigSmsAutoreplyConfigDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configSmsAutoreplyConfigDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configSmsAutoreplyConfigRetrieveQueryKey = (options: Options<ConfigSmsAutoreplyConfigRetrieveData>) => createQueryKey('configSmsAutoreplyConfigRetrieve', options);

export const configSmsAutoreplyConfigRetrieveOptions = (options: Options<ConfigSmsAutoreplyConfigRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configSmsAutoreplyConfigRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configSmsAutoreplyConfigRetrieveQueryKey(options)
    });
};

export const configSmsAutoreplyConfigPartialUpdateMutation = (options?: Partial<Options<ConfigSmsAutoreplyConfigPartialUpdateData>>): UseMutationOptions<ConfigSmsAutoreplyConfigPartialUpdateResponse, DefaultError, Options<ConfigSmsAutoreplyConfigPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigSmsAutoreplyConfigPartialUpdateResponse, DefaultError, Options<ConfigSmsAutoreplyConfigPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configSmsAutoreplyConfigPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configSmsAutoreplyConfigUpdateMutation = (options?: Partial<Options<ConfigSmsAutoreplyConfigUpdateData>>): UseMutationOptions<ConfigSmsAutoreplyConfigUpdateResponse, DefaultError, Options<ConfigSmsAutoreplyConfigUpdateData>> => {
    const mutationOptions: UseMutationOptions<ConfigSmsAutoreplyConfigUpdateResponse, DefaultError, Options<ConfigSmsAutoreplyConfigUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configSmsAutoreplyConfigUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configWhitelabelDomainConfigsListQueryKey = (options?: Options<ConfigWhitelabelDomainConfigsListData>) => createQueryKey('configWhitelabelDomainConfigsList', options);

export const configWhitelabelDomainConfigsListOptions = (options?: Options<ConfigWhitelabelDomainConfigsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configWhitelabelDomainConfigsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelabelDomainConfigsListQueryKey(options)
    });
};

export const configWhitelabelDomainConfigsListInfiniteQueryKey = (options?: Options<ConfigWhitelabelDomainConfigsListData>): QueryKey<Options<ConfigWhitelabelDomainConfigsListData>> => createQueryKey('configWhitelabelDomainConfigsList', options, true);

export const configWhitelabelDomainConfigsListInfiniteOptions = (options?: Options<ConfigWhitelabelDomainConfigsListData>) => {
    return infiniteQueryOptions<ConfigWhitelabelDomainConfigsListResponse, DefaultError, InfiniteData<ConfigWhitelabelDomainConfigsListResponse>, QueryKey<Options<ConfigWhitelabelDomainConfigsListData>>, number | Pick<QueryKey<Options<ConfigWhitelabelDomainConfigsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigWhitelabelDomainConfigsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configWhitelabelDomainConfigsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelabelDomainConfigsListInfiniteQueryKey(options)
    });
};

export const configWhitelabelDomainConfigsRetrieveQueryKey = (options: Options<ConfigWhitelabelDomainConfigsRetrieveData>) => createQueryKey('configWhitelabelDomainConfigsRetrieve', options);

export const configWhitelabelDomainConfigsRetrieveOptions = (options: Options<ConfigWhitelabelDomainConfigsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configWhitelabelDomainConfigsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelabelDomainConfigsRetrieveQueryKey(options)
    });
};

export const configWhitelistedDomainsListQueryKey = (options?: Options<ConfigWhitelistedDomainsListData>) => createQueryKey('configWhitelistedDomainsList', options);

export const configWhitelistedDomainsListOptions = (options?: Options<ConfigWhitelistedDomainsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configWhitelistedDomainsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelistedDomainsListQueryKey(options)
    });
};

export const configWhitelistedDomainsListInfiniteQueryKey = (options?: Options<ConfigWhitelistedDomainsListData>): QueryKey<Options<ConfigWhitelistedDomainsListData>> => createQueryKey('configWhitelistedDomainsList', options, true);

export const configWhitelistedDomainsListInfiniteOptions = (options?: Options<ConfigWhitelistedDomainsListData>) => {
    return infiniteQueryOptions<ConfigWhitelistedDomainsListResponse, DefaultError, InfiniteData<ConfigWhitelistedDomainsListResponse>, QueryKey<Options<ConfigWhitelistedDomainsListData>>, number | Pick<QueryKey<Options<ConfigWhitelistedDomainsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConfigWhitelistedDomainsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await configWhitelistedDomainsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelistedDomainsListInfiniteQueryKey(options)
    });
};

export const configWhitelistedDomainsCreateQueryKey = (options: Options<ConfigWhitelistedDomainsCreateData>) => createQueryKey('configWhitelistedDomainsCreate', options);

export const configWhitelistedDomainsCreateOptions = (options: Options<ConfigWhitelistedDomainsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configWhitelistedDomainsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelistedDomainsCreateQueryKey(options)
    });
};

export const configWhitelistedDomainsCreateMutation = (options?: Partial<Options<ConfigWhitelistedDomainsCreateData>>): UseMutationOptions<ConfigWhitelistedDomainsCreateResponse, DefaultError, Options<ConfigWhitelistedDomainsCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigWhitelistedDomainsCreateResponse, DefaultError, Options<ConfigWhitelistedDomainsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configWhitelistedDomainsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configWhitelistedDomainsDestroyMutation = (options?: Partial<Options<ConfigWhitelistedDomainsDestroyData>>): UseMutationOptions<ConfigWhitelistedDomainsDestroyResponse, DefaultError, Options<ConfigWhitelistedDomainsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ConfigWhitelistedDomainsDestroyResponse, DefaultError, Options<ConfigWhitelistedDomainsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configWhitelistedDomainsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configWhitelistedDomainsBulkCreateCreateQueryKey = (options: Options<ConfigWhitelistedDomainsBulkCreateCreateData>) => createQueryKey('configWhitelistedDomainsBulkCreateCreate', options);

export const configWhitelistedDomainsBulkCreateCreateOptions = (options: Options<ConfigWhitelistedDomainsBulkCreateCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configWhitelistedDomainsBulkCreateCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelistedDomainsBulkCreateCreateQueryKey(options)
    });
};

export const configWhitelistedDomainsBulkCreateCreateMutation = (options?: Partial<Options<ConfigWhitelistedDomainsBulkCreateCreateData>>): UseMutationOptions<ConfigWhitelistedDomainsBulkCreateCreateResponse, DefaultError, Options<ConfigWhitelistedDomainsBulkCreateCreateData>> => {
    const mutationOptions: UseMutationOptions<ConfigWhitelistedDomainsBulkCreateCreateResponse, DefaultError, Options<ConfigWhitelistedDomainsBulkCreateCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await configWhitelistedDomainsBulkCreateCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configWhitelistedDomainsLookupRetrieveQueryKey = (options: Options<ConfigWhitelistedDomainsLookupRetrieveData>) => createQueryKey('configWhitelistedDomainsLookupRetrieve', options);

export const configWhitelistedDomainsLookupRetrieveOptions = (options: Options<ConfigWhitelistedDomainsLookupRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await configWhitelistedDomainsLookupRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: configWhitelistedDomainsLookupRetrieveQueryKey(options)
    });
};

export const importsListQueryKey = (options?: Options<ImportsListData>) => createQueryKey('importsList', options);

export const importsListOptions = (options?: Options<ImportsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await importsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: importsListQueryKey(options)
    });
};

export const importsListInfiniteQueryKey = (options?: Options<ImportsListData>): QueryKey<Options<ImportsListData>> => createQueryKey('importsList', options, true);

export const importsListInfiniteOptions = (options?: Options<ImportsListData>) => {
    return infiniteQueryOptions<ImportsListResponse, DefaultError, InfiniteData<ImportsListResponse>, QueryKey<Options<ImportsListData>>, number | Pick<QueryKey<Options<ImportsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ImportsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await importsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: importsListInfiniteQueryKey(options)
    });
};

export const importsCreateQueryKey = (options: Options<ImportsCreateData>) => createQueryKey('importsCreate', options);

export const importsCreateOptions = (options: Options<ImportsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await importsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: importsCreateQueryKey(options)
    });
};

export const importsCreateMutation = (options?: Partial<Options<ImportsCreateData>>): UseMutationOptions<ImportsCreateResponse, DefaultError, Options<ImportsCreateData>> => {
    const mutationOptions: UseMutationOptions<ImportsCreateResponse, DefaultError, Options<ImportsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await importsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const importsRetrieveQueryKey = (options: Options<ImportsRetrieveData>) => createQueryKey('importsRetrieve', options);

export const importsRetrieveOptions = (options: Options<ImportsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await importsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: importsRetrieveQueryKey(options)
    });
};

export const journeyConfigurationsListQueryKey = (options?: Options<JourneyConfigurationsListData>) => createQueryKey('journeyConfigurationsList', options);

export const journeyConfigurationsListOptions = (options?: Options<JourneyConfigurationsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyConfigurationsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyConfigurationsListQueryKey(options)
    });
};

export const journeyConfigurationsListInfiniteQueryKey = (options?: Options<JourneyConfigurationsListData>): QueryKey<Options<JourneyConfigurationsListData>> => createQueryKey('journeyConfigurationsList', options, true);

export const journeyConfigurationsListInfiniteOptions = (options?: Options<JourneyConfigurationsListData>) => {
    return infiniteQueryOptions<JourneyConfigurationsListResponse, DefaultError, InfiniteData<JourneyConfigurationsListResponse>, QueryKey<Options<JourneyConfigurationsListData>>, number | Pick<QueryKey<Options<JourneyConfigurationsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyConfigurationsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyConfigurationsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyConfigurationsListInfiniteQueryKey(options)
    });
};

export const journeyConfigurationsCreateQueryKey = (options: Options<JourneyConfigurationsCreateData>) => createQueryKey('journeyConfigurationsCreate', options);

export const journeyConfigurationsCreateOptions = (options: Options<JourneyConfigurationsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyConfigurationsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyConfigurationsCreateQueryKey(options)
    });
};

export const journeyConfigurationsCreateMutation = (options?: Partial<Options<JourneyConfigurationsCreateData>>): UseMutationOptions<JourneyConfigurationsCreateResponse, DefaultError, Options<JourneyConfigurationsCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyConfigurationsCreateResponse, DefaultError, Options<JourneyConfigurationsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyConfigurationsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyConfigurationsDestroyMutation = (options?: Partial<Options<JourneyConfigurationsDestroyData>>): UseMutationOptions<JourneyConfigurationsDestroyResponse, DefaultError, Options<JourneyConfigurationsDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyConfigurationsDestroyResponse, DefaultError, Options<JourneyConfigurationsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyConfigurationsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyConfigurationsRetrieveQueryKey = (options: Options<JourneyConfigurationsRetrieveData>) => createQueryKey('journeyConfigurationsRetrieve', options);

export const journeyConfigurationsRetrieveOptions = (options: Options<JourneyConfigurationsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyConfigurationsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyConfigurationsRetrieveQueryKey(options)
    });
};

export const journeyConfigurationsPartialUpdateMutation = (options?: Partial<Options<JourneyConfigurationsPartialUpdateData>>): UseMutationOptions<JourneyConfigurationsPartialUpdateResponse, DefaultError, Options<JourneyConfigurationsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyConfigurationsPartialUpdateResponse, DefaultError, Options<JourneyConfigurationsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyConfigurationsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyConfigurationsUpdateMutation = (options?: Partial<Options<JourneyConfigurationsUpdateData>>): UseMutationOptions<JourneyConfigurationsUpdateResponse, DefaultError, Options<JourneyConfigurationsUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyConfigurationsUpdateResponse, DefaultError, Options<JourneyConfigurationsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyConfigurationsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyConfigurationsPublishCreateQueryKey = (options: Options<JourneyConfigurationsPublishCreateData>) => createQueryKey('journeyConfigurationsPublishCreate', options);

export const journeyConfigurationsPublishCreateOptions = (options: Options<JourneyConfigurationsPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyConfigurationsPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyConfigurationsPublishCreateQueryKey(options)
    });
};

export const journeyConfigurationsPublishCreateMutation = (options?: Partial<Options<JourneyConfigurationsPublishCreateData>>): UseMutationOptions<JourneyConfigurationsPublishCreateResponse, DefaultError, Options<JourneyConfigurationsPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyConfigurationsPublishCreateResponse, DefaultError, Options<JourneyConfigurationsPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyConfigurationsPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyConfigurationsFlowAnalysisRetrieveQueryKey = (options: Options<JourneyConfigurationsFlowAnalysisRetrieveData>) => createQueryKey('journeyConfigurationsFlowAnalysisRetrieve', options);

export const journeyConfigurationsFlowAnalysisRetrieveOptions = (options: Options<JourneyConfigurationsFlowAnalysisRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyConfigurationsFlowAnalysisRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyConfigurationsFlowAnalysisRetrieveQueryKey(options)
    });
};

export const journeyConfigurationsLookupRetrieveQueryKey = (options: Options<JourneyConfigurationsLookupRetrieveData>) => createQueryKey('journeyConfigurationsLookupRetrieve', options);

export const journeyConfigurationsLookupRetrieveOptions = (options: Options<JourneyConfigurationsLookupRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyConfigurationsLookupRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyConfigurationsLookupRetrieveQueryKey(options)
    });
};

export const journeyEventsListQueryKey = (options?: Options<JourneyEventsListData>) => createQueryKey('journeyEventsList', options);

export const journeyEventsListOptions = (options?: Options<JourneyEventsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyEventsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyEventsListQueryKey(options)
    });
};

export const journeyEventsListInfiniteQueryKey = (options?: Options<JourneyEventsListData>): QueryKey<Options<JourneyEventsListData>> => createQueryKey('journeyEventsList', options, true);

export const journeyEventsListInfiniteOptions = (options?: Options<JourneyEventsListData>) => {
    return infiniteQueryOptions<JourneyEventsListResponse, DefaultError, InfiniteData<JourneyEventsListResponse>, QueryKey<Options<JourneyEventsListData>>, number | Pick<QueryKey<Options<JourneyEventsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyEventsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyEventsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyEventsListInfiniteQueryKey(options)
    });
};

export const journeyEventsCreateQueryKey = (options: Options<JourneyEventsCreateData>) => createQueryKey('journeyEventsCreate', options);

export const journeyEventsCreateOptions = (options: Options<JourneyEventsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyEventsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyEventsCreateQueryKey(options)
    });
};

export const journeyEventsCreateMutation = (options?: Partial<Options<JourneyEventsCreateData>>): UseMutationOptions<JourneyEventsCreateResponse, DefaultError, Options<JourneyEventsCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyEventsCreateResponse, DefaultError, Options<JourneyEventsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyEventsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyEventsDestroyMutation = (options?: Partial<Options<JourneyEventsDestroyData>>): UseMutationOptions<JourneyEventsDestroyResponse, DefaultError, Options<JourneyEventsDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyEventsDestroyResponse, DefaultError, Options<JourneyEventsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyEventsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyEventsRetrieveQueryKey = (options: Options<JourneyEventsRetrieveData>) => createQueryKey('journeyEventsRetrieve', options);

export const journeyEventsRetrieveOptions = (options: Options<JourneyEventsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyEventsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyEventsRetrieveQueryKey(options)
    });
};

export const journeyEventsPartialUpdateMutation = (options?: Partial<Options<JourneyEventsPartialUpdateData>>): UseMutationOptions<JourneyEventsPartialUpdateResponse, DefaultError, Options<JourneyEventsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyEventsPartialUpdateResponse, DefaultError, Options<JourneyEventsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyEventsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyEventsUpdateMutation = (options?: Partial<Options<JourneyEventsUpdateData>>): UseMutationOptions<JourneyEventsUpdateResponse, DefaultError, Options<JourneyEventsUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyEventsUpdateResponse, DefaultError, Options<JourneyEventsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyEventsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyExperimentsListQueryKey = (options?: Options<JourneyExperimentsListData>) => createQueryKey('journeyExperimentsList', options);

export const journeyExperimentsListOptions = (options?: Options<JourneyExperimentsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyExperimentsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyExperimentsListQueryKey(options)
    });
};

export const journeyExperimentsListInfiniteQueryKey = (options?: Options<JourneyExperimentsListData>): QueryKey<Options<JourneyExperimentsListData>> => createQueryKey('journeyExperimentsList', options, true);

export const journeyExperimentsListInfiniteOptions = (options?: Options<JourneyExperimentsListData>) => {
    return infiniteQueryOptions<JourneyExperimentsListResponse, DefaultError, InfiniteData<JourneyExperimentsListResponse>, QueryKey<Options<JourneyExperimentsListData>>, number | Pick<QueryKey<Options<JourneyExperimentsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyExperimentsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyExperimentsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyExperimentsListInfiniteQueryKey(options)
    });
};

export const journeyExperimentsCreateQueryKey = (options: Options<JourneyExperimentsCreateData>) => createQueryKey('journeyExperimentsCreate', options);

export const journeyExperimentsCreateOptions = (options: Options<JourneyExperimentsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyExperimentsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyExperimentsCreateQueryKey(options)
    });
};

export const journeyExperimentsCreateMutation = (options?: Partial<Options<JourneyExperimentsCreateData>>): UseMutationOptions<JourneyExperimentsCreateResponse, DefaultError, Options<JourneyExperimentsCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyExperimentsCreateResponse, DefaultError, Options<JourneyExperimentsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyExperimentsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyExperimentsDestroyMutation = (options?: Partial<Options<JourneyExperimentsDestroyData>>): UseMutationOptions<JourneyExperimentsDestroyResponse, DefaultError, Options<JourneyExperimentsDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyExperimentsDestroyResponse, DefaultError, Options<JourneyExperimentsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyExperimentsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyExperimentsRetrieveQueryKey = (options: Options<JourneyExperimentsRetrieveData>) => createQueryKey('journeyExperimentsRetrieve', options);

export const journeyExperimentsRetrieveOptions = (options: Options<JourneyExperimentsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyExperimentsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyExperimentsRetrieveQueryKey(options)
    });
};

export const journeyExperimentsPartialUpdateMutation = (options?: Partial<Options<JourneyExperimentsPartialUpdateData>>): UseMutationOptions<JourneyExperimentsPartialUpdateResponse, DefaultError, Options<JourneyExperimentsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyExperimentsPartialUpdateResponse, DefaultError, Options<JourneyExperimentsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyExperimentsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyExperimentsUpdateMutation = (options?: Partial<Options<JourneyExperimentsUpdateData>>): UseMutationOptions<JourneyExperimentsUpdateResponse, DefaultError, Options<JourneyExperimentsUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyExperimentsUpdateResponse, DefaultError, Options<JourneyExperimentsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyExperimentsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyExperimentsPublishCreateQueryKey = (options: Options<JourneyExperimentsPublishCreateData>) => createQueryKey('journeyExperimentsPublishCreate', options);

export const journeyExperimentsPublishCreateOptions = (options: Options<JourneyExperimentsPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyExperimentsPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyExperimentsPublishCreateQueryKey(options)
    });
};

export const journeyExperimentsPublishCreateMutation = (options?: Partial<Options<JourneyExperimentsPublishCreateData>>): UseMutationOptions<JourneyExperimentsPublishCreateResponse, DefaultError, Options<JourneyExperimentsPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyExperimentsPublishCreateResponse, DefaultError, Options<JourneyExperimentsPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyExperimentsPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyExperimentsResultsListQueryKey = (options: Options<JourneyExperimentsResultsListData>) => createQueryKey('journeyExperimentsResultsList', options);

export const journeyExperimentsResultsListOptions = (options: Options<JourneyExperimentsResultsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyExperimentsResultsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyExperimentsResultsListQueryKey(options)
    });
};

export const journeyExperimentsResultsListInfiniteQueryKey = (options: Options<JourneyExperimentsResultsListData>): QueryKey<Options<JourneyExperimentsResultsListData>> => createQueryKey('journeyExperimentsResultsList', options, true);

export const journeyExperimentsResultsListInfiniteOptions = (options: Options<JourneyExperimentsResultsListData>) => {
    return infiniteQueryOptions<JourneyExperimentsResultsListResponse, DefaultError, InfiniteData<JourneyExperimentsResultsListResponse>, QueryKey<Options<JourneyExperimentsResultsListData>>, number | Pick<QueryKey<Options<JourneyExperimentsResultsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyExperimentsResultsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyExperimentsResultsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyExperimentsResultsListInfiniteQueryKey(options)
    });
};

export const journeyExperimentsWinnerVariantPartialUpdateMutation = (options?: Partial<Options<JourneyExperimentsWinnerVariantPartialUpdateData>>): UseMutationOptions<JourneyExperimentsWinnerVariantPartialUpdateResponse, DefaultError, Options<JourneyExperimentsWinnerVariantPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyExperimentsWinnerVariantPartialUpdateResponse, DefaultError, Options<JourneyExperimentsWinnerVariantPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyExperimentsWinnerVariantPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyFlowVisualizationsListQueryKey = (options?: Options<JourneyFlowVisualizationsListData>) => createQueryKey('journeyFlowVisualizationsList', options);

export const journeyFlowVisualizationsListOptions = (options?: Options<JourneyFlowVisualizationsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyFlowVisualizationsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyFlowVisualizationsListQueryKey(options)
    });
};

export const journeyFlowVisualizationsListInfiniteQueryKey = (options?: Options<JourneyFlowVisualizationsListData>): QueryKey<Options<JourneyFlowVisualizationsListData>> => createQueryKey('journeyFlowVisualizationsList', options, true);

export const journeyFlowVisualizationsListInfiniteOptions = (options?: Options<JourneyFlowVisualizationsListData>) => {
    return infiniteQueryOptions<JourneyFlowVisualizationsListResponse, DefaultError, InfiniteData<JourneyFlowVisualizationsListResponse>, QueryKey<Options<JourneyFlowVisualizationsListData>>, number | Pick<QueryKey<Options<JourneyFlowVisualizationsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyFlowVisualizationsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyFlowVisualizationsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyFlowVisualizationsListInfiniteQueryKey(options)
    });
};

export const journeyFlowVisualizationsCreateQueryKey = (options: Options<JourneyFlowVisualizationsCreateData>) => createQueryKey('journeyFlowVisualizationsCreate', options);

export const journeyFlowVisualizationsCreateOptions = (options: Options<JourneyFlowVisualizationsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyFlowVisualizationsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyFlowVisualizationsCreateQueryKey(options)
    });
};

export const journeyFlowVisualizationsCreateMutation = (options?: Partial<Options<JourneyFlowVisualizationsCreateData>>): UseMutationOptions<JourneyFlowVisualizationsCreateResponse, DefaultError, Options<JourneyFlowVisualizationsCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyFlowVisualizationsCreateResponse, DefaultError, Options<JourneyFlowVisualizationsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyFlowVisualizationsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyFlowVisualizationsDestroyMutation = (options?: Partial<Options<JourneyFlowVisualizationsDestroyData>>): UseMutationOptions<JourneyFlowVisualizationsDestroyResponse, DefaultError, Options<JourneyFlowVisualizationsDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyFlowVisualizationsDestroyResponse, DefaultError, Options<JourneyFlowVisualizationsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyFlowVisualizationsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyFlowVisualizationsRetrieveQueryKey = (options: Options<JourneyFlowVisualizationsRetrieveData>) => createQueryKey('journeyFlowVisualizationsRetrieve', options);

export const journeyFlowVisualizationsRetrieveOptions = (options: Options<JourneyFlowVisualizationsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyFlowVisualizationsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyFlowVisualizationsRetrieveQueryKey(options)
    });
};

export const journeyFlowVisualizationsPartialUpdateMutation = (options?: Partial<Options<JourneyFlowVisualizationsPartialUpdateData>>): UseMutationOptions<JourneyFlowVisualizationsPartialUpdateResponse, DefaultError, Options<JourneyFlowVisualizationsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyFlowVisualizationsPartialUpdateResponse, DefaultError, Options<JourneyFlowVisualizationsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyFlowVisualizationsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyFlowVisualizationsUpdateMutation = (options?: Partial<Options<JourneyFlowVisualizationsUpdateData>>): UseMutationOptions<JourneyFlowVisualizationsUpdateResponse, DefaultError, Options<JourneyFlowVisualizationsUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyFlowVisualizationsUpdateResponse, DefaultError, Options<JourneyFlowVisualizationsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyFlowVisualizationsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyLayoutsListQueryKey = (options?: Options<JourneyLayoutsListData>) => createQueryKey('journeyLayoutsList', options);

export const journeyLayoutsListOptions = (options?: Options<JourneyLayoutsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsListQueryKey(options)
    });
};

export const journeyLayoutsListInfiniteQueryKey = (options?: Options<JourneyLayoutsListData>): QueryKey<Options<JourneyLayoutsListData>> => createQueryKey('journeyLayoutsList', options, true);

export const journeyLayoutsListInfiniteOptions = (options?: Options<JourneyLayoutsListData>) => {
    return infiniteQueryOptions<JourneyLayoutsListResponse, DefaultError, InfiniteData<JourneyLayoutsListResponse>, QueryKey<Options<JourneyLayoutsListData>>, number | Pick<QueryKey<Options<JourneyLayoutsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyLayoutsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyLayoutsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsListInfiniteQueryKey(options)
    });
};

export const journeyLayoutsCreateQueryKey = (options: Options<JourneyLayoutsCreateData>) => createQueryKey('journeyLayoutsCreate', options);

export const journeyLayoutsCreateOptions = (options: Options<JourneyLayoutsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsCreateQueryKey(options)
    });
};

export const journeyLayoutsCreateMutation = (options?: Partial<Options<JourneyLayoutsCreateData>>): UseMutationOptions<JourneyLayoutsCreateResponse, DefaultError, Options<JourneyLayoutsCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyLayoutsCreateResponse, DefaultError, Options<JourneyLayoutsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyLayoutsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyLayoutsDestroyMutation = (options?: Partial<Options<JourneyLayoutsDestroyData>>): UseMutationOptions<JourneyLayoutsDestroyResponse, DefaultError, Options<JourneyLayoutsDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyLayoutsDestroyResponse, DefaultError, Options<JourneyLayoutsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyLayoutsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyLayoutsRetrieveQueryKey = (options: Options<JourneyLayoutsRetrieveData>) => createQueryKey('journeyLayoutsRetrieve', options);

export const journeyLayoutsRetrieveOptions = (options: Options<JourneyLayoutsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsRetrieveQueryKey(options)
    });
};

export const journeyLayoutsPartialUpdateMutation = (options?: Partial<Options<JourneyLayoutsPartialUpdateData>>): UseMutationOptions<JourneyLayoutsPartialUpdateResponse, DefaultError, Options<JourneyLayoutsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyLayoutsPartialUpdateResponse, DefaultError, Options<JourneyLayoutsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyLayoutsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyLayoutsUpdateMutation = (options?: Partial<Options<JourneyLayoutsUpdateData>>): UseMutationOptions<JourneyLayoutsUpdateResponse, DefaultError, Options<JourneyLayoutsUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyLayoutsUpdateResponse, DefaultError, Options<JourneyLayoutsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyLayoutsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyLayoutsDetailsRetrieveQueryKey = (options: Options<JourneyLayoutsDetailsRetrieveData>) => createQueryKey('journeyLayoutsDetailsRetrieve', options);

export const journeyLayoutsDetailsRetrieveOptions = (options: Options<JourneyLayoutsDetailsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsDetailsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsDetailsRetrieveQueryKey(options)
    });
};

export const journeyLayoutsEditorConfigRetrieveQueryKey = (options: Options<JourneyLayoutsEditorConfigRetrieveData>) => createQueryKey('journeyLayoutsEditorConfigRetrieve', options);

export const journeyLayoutsEditorConfigRetrieveOptions = (options: Options<JourneyLayoutsEditorConfigRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsEditorConfigRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsEditorConfigRetrieveQueryKey(options)
    });
};

export const journeyLayoutsHistoryRetrieveQueryKey = (options: Options<JourneyLayoutsHistoryRetrieveData>) => createQueryKey('journeyLayoutsHistoryRetrieve', options);

export const journeyLayoutsHistoryRetrieveOptions = (options: Options<JourneyLayoutsHistoryRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsHistoryRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsHistoryRetrieveQueryKey(options)
    });
};

export const journeyLayoutsHistoryRetrieve2QueryKey = (options: Options<JourneyLayoutsHistoryRetrieve2Data>) => createQueryKey('journeyLayoutsHistoryRetrieve2', options);

export const journeyLayoutsHistoryRetrieve2Options = (options: Options<JourneyLayoutsHistoryRetrieve2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsHistoryRetrieve2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsHistoryRetrieve2QueryKey(options)
    });
};

export const journeyLayoutsPublishCreateQueryKey = (options: Options<JourneyLayoutsPublishCreateData>) => createQueryKey('journeyLayoutsPublishCreate', options);

export const journeyLayoutsPublishCreateOptions = (options: Options<JourneyLayoutsPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsPublishCreateQueryKey(options)
    });
};

export const journeyLayoutsPublishCreateMutation = (options?: Partial<Options<JourneyLayoutsPublishCreateData>>): UseMutationOptions<JourneyLayoutsPublishCreateResponse, DefaultError, Options<JourneyLayoutsPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyLayoutsPublishCreateResponse, DefaultError, Options<JourneyLayoutsPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyLayoutsPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyLayoutsRevertCreateQueryKey = (options: Options<JourneyLayoutsRevertCreateData>) => createQueryKey('journeyLayoutsRevertCreate', options);

export const journeyLayoutsRevertCreateOptions = (options: Options<JourneyLayoutsRevertCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsRevertCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsRevertCreateQueryKey(options)
    });
};

export const journeyLayoutsRevertCreateMutation = (options?: Partial<Options<JourneyLayoutsRevertCreateData>>): UseMutationOptions<JourneyLayoutsRevertCreateResponse, DefaultError, Options<JourneyLayoutsRevertCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyLayoutsRevertCreateResponse, DefaultError, Options<JourneyLayoutsRevertCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyLayoutsRevertCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyLayoutsDeletedRetrieveQueryKey = (options?: Options<JourneyLayoutsDeletedRetrieveData>) => createQueryKey('journeyLayoutsDeletedRetrieve', options);

export const journeyLayoutsDeletedRetrieveOptions = (options?: Options<JourneyLayoutsDeletedRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyLayoutsDeletedRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyLayoutsDeletedRetrieveQueryKey(options)
    });
};

export const journeyMediasListQueryKey = (options?: Options<JourneyMediasListData>) => createQueryKey('journeyMediasList', options);

export const journeyMediasListOptions = (options?: Options<JourneyMediasListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMediasList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMediasListQueryKey(options)
    });
};

export const journeyMediasListInfiniteQueryKey = (options?: Options<JourneyMediasListData>): QueryKey<Options<JourneyMediasListData>> => createQueryKey('journeyMediasList', options, true);

export const journeyMediasListInfiniteOptions = (options?: Options<JourneyMediasListData>) => {
    return infiniteQueryOptions<JourneyMediasListResponse, DefaultError, InfiniteData<JourneyMediasListResponse>, QueryKey<Options<JourneyMediasListData>>, number | Pick<QueryKey<Options<JourneyMediasListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyMediasListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyMediasList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMediasListInfiniteQueryKey(options)
    });
};

export const journeyMediasCreateQueryKey = (options: Options<JourneyMediasCreateData>) => createQueryKey('journeyMediasCreate', options);

export const journeyMediasCreateOptions = (options: Options<JourneyMediasCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMediasCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMediasCreateQueryKey(options)
    });
};

export const journeyMediasCreateMutation = (options?: Partial<Options<JourneyMediasCreateData>>): UseMutationOptions<JourneyMediasCreateResponse, DefaultError, Options<JourneyMediasCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMediasCreateResponse, DefaultError, Options<JourneyMediasCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMediasCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMediasDestroyMutation = (options?: Partial<Options<JourneyMediasDestroyData>>): UseMutationOptions<JourneyMediasDestroyResponse, DefaultError, Options<JourneyMediasDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyMediasDestroyResponse, DefaultError, Options<JourneyMediasDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMediasDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMediasRetrieveQueryKey = (options: Options<JourneyMediasRetrieveData>) => createQueryKey('journeyMediasRetrieve', options);

export const journeyMediasRetrieveOptions = (options: Options<JourneyMediasRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMediasRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMediasRetrieveQueryKey(options)
    });
};

export const journeyMediasPartialUpdateMutation = (options?: Partial<Options<JourneyMediasPartialUpdateData>>): UseMutationOptions<JourneyMediasPartialUpdateResponse, DefaultError, Options<JourneyMediasPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMediasPartialUpdateResponse, DefaultError, Options<JourneyMediasPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMediasPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMediasUpdateMutation = (options?: Partial<Options<JourneyMediasUpdateData>>): UseMutationOptions<JourneyMediasUpdateResponse, DefaultError, Options<JourneyMediasUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMediasUpdateResponse, DefaultError, Options<JourneyMediasUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMediasUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessageTypesListQueryKey = (options?: Options<JourneyMessageTypesListData>) => createQueryKey('journeyMessageTypesList', options);

export const journeyMessageTypesListOptions = (options?: Options<JourneyMessageTypesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessageTypesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessageTypesListQueryKey(options)
    });
};

export const journeyMessageTypesListInfiniteQueryKey = (options?: Options<JourneyMessageTypesListData>): QueryKey<Options<JourneyMessageTypesListData>> => createQueryKey('journeyMessageTypesList', options, true);

export const journeyMessageTypesListInfiniteOptions = (options?: Options<JourneyMessageTypesListData>) => {
    return infiniteQueryOptions<JourneyMessageTypesListResponse, DefaultError, InfiniteData<JourneyMessageTypesListResponse>, QueryKey<Options<JourneyMessageTypesListData>>, number | Pick<QueryKey<Options<JourneyMessageTypesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyMessageTypesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyMessageTypesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessageTypesListInfiniteQueryKey(options)
    });
};

export const journeyMessageTypesCreateQueryKey = (options: Options<JourneyMessageTypesCreateData>) => createQueryKey('journeyMessageTypesCreate', options);

export const journeyMessageTypesCreateOptions = (options: Options<JourneyMessageTypesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessageTypesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessageTypesCreateQueryKey(options)
    });
};

export const journeyMessageTypesCreateMutation = (options?: Partial<Options<JourneyMessageTypesCreateData>>): UseMutationOptions<JourneyMessageTypesCreateResponse, DefaultError, Options<JourneyMessageTypesCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessageTypesCreateResponse, DefaultError, Options<JourneyMessageTypesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessageTypesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessageTypesDestroyMutation = (options?: Partial<Options<JourneyMessageTypesDestroyData>>): UseMutationOptions<JourneyMessageTypesDestroyResponse, DefaultError, Options<JourneyMessageTypesDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessageTypesDestroyResponse, DefaultError, Options<JourneyMessageTypesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessageTypesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessageTypesRetrieveQueryKey = (options: Options<JourneyMessageTypesRetrieveData>) => createQueryKey('journeyMessageTypesRetrieve', options);

export const journeyMessageTypesRetrieveOptions = (options: Options<JourneyMessageTypesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessageTypesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessageTypesRetrieveQueryKey(options)
    });
};

export const journeyMessageTypesPartialUpdateMutation = (options?: Partial<Options<JourneyMessageTypesPartialUpdateData>>): UseMutationOptions<JourneyMessageTypesPartialUpdateResponse, DefaultError, Options<JourneyMessageTypesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessageTypesPartialUpdateResponse, DefaultError, Options<JourneyMessageTypesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessageTypesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessageTypesUpdateMutation = (options?: Partial<Options<JourneyMessageTypesUpdateData>>): UseMutationOptions<JourneyMessageTypesUpdateResponse, DefaultError, Options<JourneyMessageTypesUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessageTypesUpdateResponse, DefaultError, Options<JourneyMessageTypesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessageTypesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessageTypesAiGenerateCreateQueryKey = (options: Options<JourneyMessageTypesAiGenerateCreateData>) => createQueryKey('journeyMessageTypesAiGenerateCreate', options);

export const journeyMessageTypesAiGenerateCreateOptions = (options: Options<JourneyMessageTypesAiGenerateCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessageTypesAiGenerateCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessageTypesAiGenerateCreateQueryKey(options)
    });
};

export const journeyMessageTypesAiGenerateCreateMutation = (options?: Partial<Options<JourneyMessageTypesAiGenerateCreateData>>): UseMutationOptions<JourneyMessageTypesAiGenerateCreateResponse, DefaultError, Options<JourneyMessageTypesAiGenerateCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessageTypesAiGenerateCreateResponse, DefaultError, Options<JourneyMessageTypesAiGenerateCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessageTypesAiGenerateCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesListQueryKey = (options?: Options<JourneyMessagesListData>) => createQueryKey('journeyMessagesList', options);

export const journeyMessagesListOptions = (options?: Options<JourneyMessagesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesListQueryKey(options)
    });
};

export const journeyMessagesListInfiniteQueryKey = (options?: Options<JourneyMessagesListData>): QueryKey<Options<JourneyMessagesListData>> => createQueryKey('journeyMessagesList', options, true);

export const journeyMessagesListInfiniteOptions = (options?: Options<JourneyMessagesListData>) => {
    return infiniteQueryOptions<JourneyMessagesListResponse, DefaultError, InfiniteData<JourneyMessagesListResponse>, QueryKey<Options<JourneyMessagesListData>>, number | Pick<QueryKey<Options<JourneyMessagesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyMessagesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyMessagesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesListInfiniteQueryKey(options)
    });
};

export const journeyMessagesCreateQueryKey = (options: Options<JourneyMessagesCreateData>) => createQueryKey('journeyMessagesCreate', options);

export const journeyMessagesCreateOptions = (options: Options<JourneyMessagesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesCreateQueryKey(options)
    });
};

export const journeyMessagesCreateMutation = (options?: Partial<Options<JourneyMessagesCreateData>>): UseMutationOptions<JourneyMessagesCreateResponse, DefaultError, Options<JourneyMessagesCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesCreateResponse, DefaultError, Options<JourneyMessagesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesDestroyMutation = (options?: Partial<Options<JourneyMessagesDestroyData>>): UseMutationOptions<JourneyMessagesDestroyResponse, DefaultError, Options<JourneyMessagesDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesDestroyResponse, DefaultError, Options<JourneyMessagesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesRetrieveQueryKey = (options: Options<JourneyMessagesRetrieveData>) => createQueryKey('journeyMessagesRetrieve', options);

export const journeyMessagesRetrieveOptions = (options: Options<JourneyMessagesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesRetrieveQueryKey(options)
    });
};

export const journeyMessagesPartialUpdateMutation = (options?: Partial<Options<JourneyMessagesPartialUpdateData>>): UseMutationOptions<JourneyMessagesPartialUpdateResponse, DefaultError, Options<JourneyMessagesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesPartialUpdateResponse, DefaultError, Options<JourneyMessagesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesUpdateMutation = (options?: Partial<Options<JourneyMessagesUpdateData>>): UseMutationOptions<JourneyMessagesUpdateResponse, DefaultError, Options<JourneyMessagesUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesUpdateResponse, DefaultError, Options<JourneyMessagesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesDetailsRetrieveQueryKey = (options: Options<JourneyMessagesDetailsRetrieveData>) => createQueryKey('journeyMessagesDetailsRetrieve', options);

export const journeyMessagesDetailsRetrieveOptions = (options: Options<JourneyMessagesDetailsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesDetailsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesDetailsRetrieveQueryKey(options)
    });
};

export const journeyMessagesEditorConfigRetrieveQueryKey = (options: Options<JourneyMessagesEditorConfigRetrieveData>) => createQueryKey('journeyMessagesEditorConfigRetrieve', options);

export const journeyMessagesEditorConfigRetrieveOptions = (options: Options<JourneyMessagesEditorConfigRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesEditorConfigRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesEditorConfigRetrieveQueryKey(options)
    });
};

export const journeyMessagesHistoryRetrieveQueryKey = (options: Options<JourneyMessagesHistoryRetrieveData>) => createQueryKey('journeyMessagesHistoryRetrieve', options);

export const journeyMessagesHistoryRetrieveOptions = (options: Options<JourneyMessagesHistoryRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesHistoryRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesHistoryRetrieveQueryKey(options)
    });
};

export const journeyMessagesHistoryRetrieve2QueryKey = (options: Options<JourneyMessagesHistoryRetrieve2Data>) => createQueryKey('journeyMessagesHistoryRetrieve2', options);

export const journeyMessagesHistoryRetrieve2Options = (options: Options<JourneyMessagesHistoryRetrieve2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesHistoryRetrieve2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesHistoryRetrieve2QueryKey(options)
    });
};

export const journeyMessagesPublishCreateQueryKey = (options: Options<JourneyMessagesPublishCreateData>) => createQueryKey('journeyMessagesPublishCreate', options);

export const journeyMessagesPublishCreateOptions = (options: Options<JourneyMessagesPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesPublishCreateQueryKey(options)
    });
};

export const journeyMessagesPublishCreateMutation = (options?: Partial<Options<JourneyMessagesPublishCreateData>>): UseMutationOptions<JourneyMessagesPublishCreateResponse, DefaultError, Options<JourneyMessagesPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesPublishCreateResponse, DefaultError, Options<JourneyMessagesPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesRevertCreateQueryKey = (options: Options<JourneyMessagesRevertCreateData>) => createQueryKey('journeyMessagesRevertCreate', options);

export const journeyMessagesRevertCreateOptions = (options: Options<JourneyMessagesRevertCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesRevertCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesRevertCreateQueryKey(options)
    });
};

export const journeyMessagesRevertCreateMutation = (options?: Partial<Options<JourneyMessagesRevertCreateData>>): UseMutationOptions<JourneyMessagesRevertCreateResponse, DefaultError, Options<JourneyMessagesRevertCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesRevertCreateResponse, DefaultError, Options<JourneyMessagesRevertCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesRevertCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesTestCreateQueryKey = (options: Options<JourneyMessagesTestCreateData>) => createQueryKey('journeyMessagesTestCreate', options);

export const journeyMessagesTestCreateOptions = (options: Options<JourneyMessagesTestCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesTestCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesTestCreateQueryKey(options)
    });
};

export const journeyMessagesTestCreateMutation = (options?: Partial<Options<JourneyMessagesTestCreateData>>): UseMutationOptions<JourneyMessagesTestCreateResponse, DefaultError, Options<JourneyMessagesTestCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesTestCreateResponse, DefaultError, Options<JourneyMessagesTestCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesTestCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesTestWebhookCreateQueryKey = (options: Options<JourneyMessagesTestWebhookCreateData>) => createQueryKey('journeyMessagesTestWebhookCreate', options);

export const journeyMessagesTestWebhookCreateOptions = (options: Options<JourneyMessagesTestWebhookCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesTestWebhookCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesTestWebhookCreateQueryKey(options)
    });
};

export const journeyMessagesTestWebhookCreateMutation = (options?: Partial<Options<JourneyMessagesTestWebhookCreateData>>): UseMutationOptions<unknown, DefaultError, Options<JourneyMessagesTestWebhookCreateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<JourneyMessagesTestWebhookCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesTestWebhookCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesAiTranslateCreateQueryKey = (options: Options<JourneyMessagesAiTranslateCreateData>) => createQueryKey('journeyMessagesAiTranslateCreate', options);

export const journeyMessagesAiTranslateCreateOptions = (options: Options<JourneyMessagesAiTranslateCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesAiTranslateCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesAiTranslateCreateQueryKey(options)
    });
};

export const journeyMessagesAiTranslateCreateMutation = (options?: Partial<Options<JourneyMessagesAiTranslateCreateData>>): UseMutationOptions<JourneyMessagesAiTranslateCreateResponse, DefaultError, Options<JourneyMessagesAiTranslateCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesAiTranslateCreateResponse, DefaultError, Options<JourneyMessagesAiTranslateCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesAiTranslateCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyMessagesDeletedRetrieveQueryKey = (options?: Options<JourneyMessagesDeletedRetrieveData>) => createQueryKey('journeyMessagesDeletedRetrieve', options);

export const journeyMessagesDeletedRetrieveOptions = (options?: Options<JourneyMessagesDeletedRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesDeletedRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesDeletedRetrieveQueryKey(options)
    });
};

export const journeyMessagesGenerateRetrieveQueryKey = (options: Options<JourneyMessagesGenerateRetrieveData>) => createQueryKey('journeyMessagesGenerateRetrieve', options);

export const journeyMessagesGenerateRetrieveOptions = (options: Options<JourneyMessagesGenerateRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesGenerateRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesGenerateRetrieveQueryKey(options)
    });
};

export const journeyMessagesMigrateCreateQueryKey = (options: Options<JourneyMessagesMigrateCreateData>) => createQueryKey('journeyMessagesMigrateCreate', options);

export const journeyMessagesMigrateCreateOptions = (options: Options<JourneyMessagesMigrateCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyMessagesMigrateCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyMessagesMigrateCreateQueryKey(options)
    });
};

export const journeyMessagesMigrateCreateMutation = (options?: Partial<Options<JourneyMessagesMigrateCreateData>>): UseMutationOptions<JourneyMessagesMigrateCreateResponse, DefaultError, Options<JourneyMessagesMigrateCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyMessagesMigrateCreateResponse, DefaultError, Options<JourneyMessagesMigrateCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyMessagesMigrateCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPartialsListQueryKey = (options?: Options<JourneyPartialsListData>) => createQueryKey('journeyPartialsList', options);

export const journeyPartialsListOptions = (options?: Options<JourneyPartialsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsListQueryKey(options)
    });
};

export const journeyPartialsListInfiniteQueryKey = (options?: Options<JourneyPartialsListData>): QueryKey<Options<JourneyPartialsListData>> => createQueryKey('journeyPartialsList', options, true);

export const journeyPartialsListInfiniteOptions = (options?: Options<JourneyPartialsListData>) => {
    return infiniteQueryOptions<JourneyPartialsListResponse, DefaultError, InfiniteData<JourneyPartialsListResponse>, QueryKey<Options<JourneyPartialsListData>>, number | Pick<QueryKey<Options<JourneyPartialsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyPartialsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyPartialsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsListInfiniteQueryKey(options)
    });
};

export const journeyPartialsCreateQueryKey = (options: Options<JourneyPartialsCreateData>) => createQueryKey('journeyPartialsCreate', options);

export const journeyPartialsCreateOptions = (options: Options<JourneyPartialsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsCreateQueryKey(options)
    });
};

export const journeyPartialsCreateMutation = (options?: Partial<Options<JourneyPartialsCreateData>>): UseMutationOptions<JourneyPartialsCreateResponse, DefaultError, Options<JourneyPartialsCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPartialsCreateResponse, DefaultError, Options<JourneyPartialsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPartialsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPartialsDestroyMutation = (options?: Partial<Options<JourneyPartialsDestroyData>>): UseMutationOptions<JourneyPartialsDestroyResponse, DefaultError, Options<JourneyPartialsDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyPartialsDestroyResponse, DefaultError, Options<JourneyPartialsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPartialsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPartialsRetrieveQueryKey = (options: Options<JourneyPartialsRetrieveData>) => createQueryKey('journeyPartialsRetrieve', options);

export const journeyPartialsRetrieveOptions = (options: Options<JourneyPartialsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsRetrieveQueryKey(options)
    });
};

export const journeyPartialsPartialUpdateMutation = (options?: Partial<Options<JourneyPartialsPartialUpdateData>>): UseMutationOptions<JourneyPartialsPartialUpdateResponse, DefaultError, Options<JourneyPartialsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPartialsPartialUpdateResponse, DefaultError, Options<JourneyPartialsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPartialsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPartialsUpdateMutation = (options?: Partial<Options<JourneyPartialsUpdateData>>): UseMutationOptions<JourneyPartialsUpdateResponse, DefaultError, Options<JourneyPartialsUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPartialsUpdateResponse, DefaultError, Options<JourneyPartialsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPartialsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPartialsEditorConfigRetrieveQueryKey = (options: Options<JourneyPartialsEditorConfigRetrieveData>) => createQueryKey('journeyPartialsEditorConfigRetrieve', options);

export const journeyPartialsEditorConfigRetrieveOptions = (options: Options<JourneyPartialsEditorConfigRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsEditorConfigRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsEditorConfigRetrieveQueryKey(options)
    });
};

export const journeyPartialsHistoryRetrieveQueryKey = (options: Options<JourneyPartialsHistoryRetrieveData>) => createQueryKey('journeyPartialsHistoryRetrieve', options);

export const journeyPartialsHistoryRetrieveOptions = (options: Options<JourneyPartialsHistoryRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsHistoryRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsHistoryRetrieveQueryKey(options)
    });
};

export const journeyPartialsHistoryRetrieve2QueryKey = (options: Options<JourneyPartialsHistoryRetrieve2Data>) => createQueryKey('journeyPartialsHistoryRetrieve2', options);

export const journeyPartialsHistoryRetrieve2Options = (options: Options<JourneyPartialsHistoryRetrieve2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsHistoryRetrieve2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsHistoryRetrieve2QueryKey(options)
    });
};

export const journeyPartialsPublishCreateQueryKey = (options: Options<JourneyPartialsPublishCreateData>) => createQueryKey('journeyPartialsPublishCreate', options);

export const journeyPartialsPublishCreateOptions = (options: Options<JourneyPartialsPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsPublishCreateQueryKey(options)
    });
};

export const journeyPartialsPublishCreateMutation = (options?: Partial<Options<JourneyPartialsPublishCreateData>>): UseMutationOptions<JourneyPartialsPublishCreateResponse, DefaultError, Options<JourneyPartialsPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPartialsPublishCreateResponse, DefaultError, Options<JourneyPartialsPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPartialsPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPartialsRevertCreateQueryKey = (options: Options<JourneyPartialsRevertCreateData>) => createQueryKey('journeyPartialsRevertCreate', options);

export const journeyPartialsRevertCreateOptions = (options: Options<JourneyPartialsRevertCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsRevertCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsRevertCreateQueryKey(options)
    });
};

export const journeyPartialsRevertCreateMutation = (options?: Partial<Options<JourneyPartialsRevertCreateData>>): UseMutationOptions<JourneyPartialsRevertCreateResponse, DefaultError, Options<JourneyPartialsRevertCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPartialsRevertCreateResponse, DefaultError, Options<JourneyPartialsRevertCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPartialsRevertCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPartialsDeletedRetrieveQueryKey = (options?: Options<JourneyPartialsDeletedRetrieveData>) => createQueryKey('journeyPartialsDeletedRetrieve', options);

export const journeyPartialsDeletedRetrieveOptions = (options?: Options<JourneyPartialsDeletedRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPartialsDeletedRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPartialsDeletedRetrieveQueryKey(options)
    });
};

export const journeyPlaceholdersListQueryKey = (options?: Options<JourneyPlaceholdersListData>) => createQueryKey('journeyPlaceholdersList', options);

export const journeyPlaceholdersListOptions = (options?: Options<JourneyPlaceholdersListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPlaceholdersList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPlaceholdersListQueryKey(options)
    });
};

export const journeyPlaceholdersListInfiniteQueryKey = (options?: Options<JourneyPlaceholdersListData>): QueryKey<Options<JourneyPlaceholdersListData>> => createQueryKey('journeyPlaceholdersList', options, true);

export const journeyPlaceholdersListInfiniteOptions = (options?: Options<JourneyPlaceholdersListData>) => {
    return infiniteQueryOptions<JourneyPlaceholdersListResponse, DefaultError, InfiniteData<JourneyPlaceholdersListResponse>, QueryKey<Options<JourneyPlaceholdersListData>>, number | Pick<QueryKey<Options<JourneyPlaceholdersListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyPlaceholdersListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyPlaceholdersList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPlaceholdersListInfiniteQueryKey(options)
    });
};

export const journeyPlaceholdersCreateQueryKey = (options: Options<JourneyPlaceholdersCreateData>) => createQueryKey('journeyPlaceholdersCreate', options);

export const journeyPlaceholdersCreateOptions = (options: Options<JourneyPlaceholdersCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPlaceholdersCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPlaceholdersCreateQueryKey(options)
    });
};

export const journeyPlaceholdersCreateMutation = (options?: Partial<Options<JourneyPlaceholdersCreateData>>): UseMutationOptions<JourneyPlaceholdersCreateResponse, DefaultError, Options<JourneyPlaceholdersCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPlaceholdersCreateResponse, DefaultError, Options<JourneyPlaceholdersCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPlaceholdersCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPlaceholdersDestroyMutation = (options?: Partial<Options<JourneyPlaceholdersDestroyData>>): UseMutationOptions<JourneyPlaceholdersDestroyResponse, DefaultError, Options<JourneyPlaceholdersDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyPlaceholdersDestroyResponse, DefaultError, Options<JourneyPlaceholdersDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPlaceholdersDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPlaceholdersRetrieveQueryKey = (options: Options<JourneyPlaceholdersRetrieveData>) => createQueryKey('journeyPlaceholdersRetrieve', options);

export const journeyPlaceholdersRetrieveOptions = (options: Options<JourneyPlaceholdersRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyPlaceholdersRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyPlaceholdersRetrieveQueryKey(options)
    });
};

export const journeyPlaceholdersPartialUpdateMutation = (options?: Partial<Options<JourneyPlaceholdersPartialUpdateData>>): UseMutationOptions<JourneyPlaceholdersPartialUpdateResponse, DefaultError, Options<JourneyPlaceholdersPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPlaceholdersPartialUpdateResponse, DefaultError, Options<JourneyPlaceholdersPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPlaceholdersPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyPlaceholdersUpdateMutation = (options?: Partial<Options<JourneyPlaceholdersUpdateData>>): UseMutationOptions<JourneyPlaceholdersUpdateResponse, DefaultError, Options<JourneyPlaceholdersUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyPlaceholdersUpdateResponse, DefaultError, Options<JourneyPlaceholdersUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyPlaceholdersUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeySharedFiltersListQueryKey = (options?: Options<JourneySharedFiltersListData>) => createQueryKey('journeySharedFiltersList', options);

export const journeySharedFiltersListOptions = (options?: Options<JourneySharedFiltersListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeySharedFiltersList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeySharedFiltersListQueryKey(options)
    });
};

export const journeySharedFiltersListInfiniteQueryKey = (options?: Options<JourneySharedFiltersListData>): QueryKey<Options<JourneySharedFiltersListData>> => createQueryKey('journeySharedFiltersList', options, true);

export const journeySharedFiltersListInfiniteOptions = (options?: Options<JourneySharedFiltersListData>) => {
    return infiniteQueryOptions<JourneySharedFiltersListResponse, DefaultError, InfiniteData<JourneySharedFiltersListResponse>, QueryKey<Options<JourneySharedFiltersListData>>, number | Pick<QueryKey<Options<JourneySharedFiltersListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneySharedFiltersListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeySharedFiltersList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeySharedFiltersListInfiniteQueryKey(options)
    });
};

export const journeySharedFiltersCreateQueryKey = (options: Options<JourneySharedFiltersCreateData>) => createQueryKey('journeySharedFiltersCreate', options);

export const journeySharedFiltersCreateOptions = (options: Options<JourneySharedFiltersCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeySharedFiltersCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeySharedFiltersCreateQueryKey(options)
    });
};

export const journeySharedFiltersCreateMutation = (options?: Partial<Options<JourneySharedFiltersCreateData>>): UseMutationOptions<JourneySharedFiltersCreateResponse, DefaultError, Options<JourneySharedFiltersCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneySharedFiltersCreateResponse, DefaultError, Options<JourneySharedFiltersCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeySharedFiltersCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeySharedFiltersDestroyMutation = (options?: Partial<Options<JourneySharedFiltersDestroyData>>): UseMutationOptions<JourneySharedFiltersDestroyResponse, DefaultError, Options<JourneySharedFiltersDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneySharedFiltersDestroyResponse, DefaultError, Options<JourneySharedFiltersDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeySharedFiltersDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeySharedFiltersRetrieveQueryKey = (options: Options<JourneySharedFiltersRetrieveData>) => createQueryKey('journeySharedFiltersRetrieve', options);

export const journeySharedFiltersRetrieveOptions = (options: Options<JourneySharedFiltersRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeySharedFiltersRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeySharedFiltersRetrieveQueryKey(options)
    });
};

export const journeySharedFiltersPartialUpdateMutation = (options?: Partial<Options<JourneySharedFiltersPartialUpdateData>>): UseMutationOptions<JourneySharedFiltersPartialUpdateResponse, DefaultError, Options<JourneySharedFiltersPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneySharedFiltersPartialUpdateResponse, DefaultError, Options<JourneySharedFiltersPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeySharedFiltersPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeySharedFiltersUpdateMutation = (options?: Partial<Options<JourneySharedFiltersUpdateData>>): UseMutationOptions<JourneySharedFiltersUpdateResponse, DefaultError, Options<JourneySharedFiltersUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneySharedFiltersUpdateResponse, DefaultError, Options<JourneySharedFiltersUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeySharedFiltersUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyTriggersListQueryKey = (options?: Options<JourneyTriggersListData>) => createQueryKey('journeyTriggersList', options);

export const journeyTriggersListOptions = (options?: Options<JourneyTriggersListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyTriggersList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyTriggersListQueryKey(options)
    });
};

export const journeyTriggersListInfiniteQueryKey = (options?: Options<JourneyTriggersListData>): QueryKey<Options<JourneyTriggersListData>> => createQueryKey('journeyTriggersList', options, true);

export const journeyTriggersListInfiniteOptions = (options?: Options<JourneyTriggersListData>) => {
    return infiniteQueryOptions<JourneyTriggersListResponse, DefaultError, InfiniteData<JourneyTriggersListResponse>, QueryKey<Options<JourneyTriggersListData>>, number | Pick<QueryKey<Options<JourneyTriggersListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JourneyTriggersListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await journeyTriggersList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyTriggersListInfiniteQueryKey(options)
    });
};

export const journeyTriggersCreateQueryKey = (options: Options<JourneyTriggersCreateData>) => createQueryKey('journeyTriggersCreate', options);

export const journeyTriggersCreateOptions = (options: Options<JourneyTriggersCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyTriggersCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyTriggersCreateQueryKey(options)
    });
};

export const journeyTriggersCreateMutation = (options?: Partial<Options<JourneyTriggersCreateData>>): UseMutationOptions<JourneyTriggersCreateResponse, DefaultError, Options<JourneyTriggersCreateData>> => {
    const mutationOptions: UseMutationOptions<JourneyTriggersCreateResponse, DefaultError, Options<JourneyTriggersCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyTriggersCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyTriggersDestroyMutation = (options?: Partial<Options<JourneyTriggersDestroyData>>): UseMutationOptions<JourneyTriggersDestroyResponse, DefaultError, Options<JourneyTriggersDestroyData>> => {
    const mutationOptions: UseMutationOptions<JourneyTriggersDestroyResponse, DefaultError, Options<JourneyTriggersDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyTriggersDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyTriggersRetrieveQueryKey = (options: Options<JourneyTriggersRetrieveData>) => createQueryKey('journeyTriggersRetrieve', options);

export const journeyTriggersRetrieveOptions = (options: Options<JourneyTriggersRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await journeyTriggersRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: journeyTriggersRetrieveQueryKey(options)
    });
};

export const journeyTriggersPartialUpdateMutation = (options?: Partial<Options<JourneyTriggersPartialUpdateData>>): UseMutationOptions<JourneyTriggersPartialUpdateResponse, DefaultError, Options<JourneyTriggersPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyTriggersPartialUpdateResponse, DefaultError, Options<JourneyTriggersPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyTriggersPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const journeyTriggersUpdateMutation = (options?: Partial<Options<JourneyTriggersUpdateData>>): UseMutationOptions<JourneyTriggersUpdateResponse, DefaultError, Options<JourneyTriggersUpdateData>> => {
    const mutationOptions: UseMutationOptions<JourneyTriggersUpdateResponse, DefaultError, Options<JourneyTriggersUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await journeyTriggersUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationsNotificationListQueryKey = (options?: Options<NotificationsNotificationListData>) => createQueryKey('notificationsNotificationList', options);

export const notificationsNotificationListOptions = (options?: Options<NotificationsNotificationListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationsNotificationList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsNotificationListQueryKey(options)
    });
};

export const notificationsNotificationListInfiniteQueryKey = (options?: Options<NotificationsNotificationListData>): QueryKey<Options<NotificationsNotificationListData>> => createQueryKey('notificationsNotificationList', options, true);

export const notificationsNotificationListInfiniteOptions = (options?: Options<NotificationsNotificationListData>) => {
    return infiniteQueryOptions<NotificationsNotificationListResponse, DefaultError, InfiniteData<NotificationsNotificationListResponse>, QueryKey<Options<NotificationsNotificationListData>>, number | Pick<QueryKey<Options<NotificationsNotificationListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<NotificationsNotificationListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await notificationsNotificationList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsNotificationListInfiniteQueryKey(options)
    });
};

export const notificationsNotificationCreateQueryKey = (options: Options<NotificationsNotificationCreateData>) => createQueryKey('notificationsNotificationCreate', options);

export const notificationsNotificationCreateOptions = (options: Options<NotificationsNotificationCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationsNotificationCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsNotificationCreateQueryKey(options)
    });
};

export const notificationsNotificationCreateMutation = (options?: Partial<Options<NotificationsNotificationCreateData>>): UseMutationOptions<NotificationsNotificationCreateResponse, DefaultError, Options<NotificationsNotificationCreateData>> => {
    const mutationOptions: UseMutationOptions<NotificationsNotificationCreateResponse, DefaultError, Options<NotificationsNotificationCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await notificationsNotificationCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationsNotificationDestroyMutation = (options?: Partial<Options<NotificationsNotificationDestroyData>>): UseMutationOptions<NotificationsNotificationDestroyResponse, DefaultError, Options<NotificationsNotificationDestroyData>> => {
    const mutationOptions: UseMutationOptions<NotificationsNotificationDestroyResponse, DefaultError, Options<NotificationsNotificationDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await notificationsNotificationDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationsNotificationRetrieveQueryKey = (options: Options<NotificationsNotificationRetrieveData>) => createQueryKey('notificationsNotificationRetrieve', options);

export const notificationsNotificationRetrieveOptions = (options: Options<NotificationsNotificationRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationsNotificationRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsNotificationRetrieveQueryKey(options)
    });
};

export const notificationsNotificationPartialUpdateMutation = (options?: Partial<Options<NotificationsNotificationPartialUpdateData>>): UseMutationOptions<NotificationsNotificationPartialUpdateResponse, DefaultError, Options<NotificationsNotificationPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<NotificationsNotificationPartialUpdateResponse, DefaultError, Options<NotificationsNotificationPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await notificationsNotificationPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationsNotificationUpdateMutation = (options?: Partial<Options<NotificationsNotificationUpdateData>>): UseMutationOptions<NotificationsNotificationUpdateResponse, DefaultError, Options<NotificationsNotificationUpdateData>> => {
    const mutationOptions: UseMutationOptions<NotificationsNotificationUpdateResponse, DefaultError, Options<NotificationsNotificationUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await notificationsNotificationUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomAnalyticsListQueryKey = (options?: Options<PortalCustomAnalyticsListData>) => createQueryKey('portalCustomAnalyticsList', options);

export const portalCustomAnalyticsListOptions = (options?: Options<PortalCustomAnalyticsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalCustomAnalyticsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomAnalyticsListQueryKey(options)
    });
};

export const portalCustomAnalyticsListInfiniteQueryKey = (options?: Options<PortalCustomAnalyticsListData>): QueryKey<Options<PortalCustomAnalyticsListData>> => createQueryKey('portalCustomAnalyticsList', options, true);

export const portalCustomAnalyticsListInfiniteOptions = (options?: Options<PortalCustomAnalyticsListData>) => {
    return infiniteQueryOptions<PortalCustomAnalyticsListResponse, DefaultError, InfiniteData<PortalCustomAnalyticsListResponse>, QueryKey<Options<PortalCustomAnalyticsListData>>, number | Pick<QueryKey<Options<PortalCustomAnalyticsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PortalCustomAnalyticsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await portalCustomAnalyticsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomAnalyticsListInfiniteQueryKey(options)
    });
};

export const portalCustomAnalyticsCreateQueryKey = (options: Options<PortalCustomAnalyticsCreateData>) => createQueryKey('portalCustomAnalyticsCreate', options);

export const portalCustomAnalyticsCreateOptions = (options: Options<PortalCustomAnalyticsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalCustomAnalyticsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomAnalyticsCreateQueryKey(options)
    });
};

export const portalCustomAnalyticsCreateMutation = (options?: Partial<Options<PortalCustomAnalyticsCreateData>>): UseMutationOptions<PortalCustomAnalyticsCreateResponse, DefaultError, Options<PortalCustomAnalyticsCreateData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomAnalyticsCreateResponse, DefaultError, Options<PortalCustomAnalyticsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomAnalyticsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomAnalyticsDestroyMutation = (options?: Partial<Options<PortalCustomAnalyticsDestroyData>>): UseMutationOptions<PortalCustomAnalyticsDestroyResponse, DefaultError, Options<PortalCustomAnalyticsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomAnalyticsDestroyResponse, DefaultError, Options<PortalCustomAnalyticsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomAnalyticsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomAnalyticsRetrieveQueryKey = (options: Options<PortalCustomAnalyticsRetrieveData>) => createQueryKey('portalCustomAnalyticsRetrieve', options);

export const portalCustomAnalyticsRetrieveOptions = (options: Options<PortalCustomAnalyticsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalCustomAnalyticsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomAnalyticsRetrieveQueryKey(options)
    });
};

export const portalCustomAnalyticsPartialUpdateMutation = (options?: Partial<Options<PortalCustomAnalyticsPartialUpdateData>>): UseMutationOptions<PortalCustomAnalyticsPartialUpdateResponse, DefaultError, Options<PortalCustomAnalyticsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomAnalyticsPartialUpdateResponse, DefaultError, Options<PortalCustomAnalyticsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomAnalyticsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomAnalyticsUpdateMutation = (options?: Partial<Options<PortalCustomAnalyticsUpdateData>>): UseMutationOptions<PortalCustomAnalyticsUpdateResponse, DefaultError, Options<PortalCustomAnalyticsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomAnalyticsUpdateResponse, DefaultError, Options<PortalCustomAnalyticsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomAnalyticsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomAnalyticsIframeRetrieveQueryKey = (options: Options<PortalCustomAnalyticsIframeRetrieveData>) => createQueryKey('portalCustomAnalyticsIframeRetrieve', options);

export const portalCustomAnalyticsIframeRetrieveOptions = (options: Options<PortalCustomAnalyticsIframeRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalCustomAnalyticsIframeRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomAnalyticsIframeRetrieveQueryKey(options)
    });
};

export const portalCustomerPortalsListQueryKey = (options?: Options<PortalCustomerPortalsListData>) => createQueryKey('portalCustomerPortalsList', options);

export const portalCustomerPortalsListOptions = (options?: Options<PortalCustomerPortalsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalCustomerPortalsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomerPortalsListQueryKey(options)
    });
};

export const portalCustomerPortalsListInfiniteQueryKey = (options?: Options<PortalCustomerPortalsListData>): QueryKey<Options<PortalCustomerPortalsListData>> => createQueryKey('portalCustomerPortalsList', options, true);

export const portalCustomerPortalsListInfiniteOptions = (options?: Options<PortalCustomerPortalsListData>) => {
    return infiniteQueryOptions<PortalCustomerPortalsListResponse, DefaultError, InfiniteData<PortalCustomerPortalsListResponse>, QueryKey<Options<PortalCustomerPortalsListData>>, number | Pick<QueryKey<Options<PortalCustomerPortalsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PortalCustomerPortalsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await portalCustomerPortalsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomerPortalsListInfiniteQueryKey(options)
    });
};

export const portalCustomerPortalsCreateQueryKey = (options: Options<PortalCustomerPortalsCreateData>) => createQueryKey('portalCustomerPortalsCreate', options);

export const portalCustomerPortalsCreateOptions = (options: Options<PortalCustomerPortalsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalCustomerPortalsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomerPortalsCreateQueryKey(options)
    });
};

export const portalCustomerPortalsCreateMutation = (options?: Partial<Options<PortalCustomerPortalsCreateData>>): UseMutationOptions<PortalCustomerPortalsCreateResponse, DefaultError, Options<PortalCustomerPortalsCreateData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomerPortalsCreateResponse, DefaultError, Options<PortalCustomerPortalsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomerPortalsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomerPortalsDestroyMutation = (options?: Partial<Options<PortalCustomerPortalsDestroyData>>): UseMutationOptions<PortalCustomerPortalsDestroyResponse, DefaultError, Options<PortalCustomerPortalsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomerPortalsDestroyResponse, DefaultError, Options<PortalCustomerPortalsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomerPortalsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomerPortalsRetrieveQueryKey = (options: Options<PortalCustomerPortalsRetrieveData>) => createQueryKey('portalCustomerPortalsRetrieve', options);

export const portalCustomerPortalsRetrieveOptions = (options: Options<PortalCustomerPortalsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalCustomerPortalsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalCustomerPortalsRetrieveQueryKey(options)
    });
};

export const portalCustomerPortalsPartialUpdateMutation = (options?: Partial<Options<PortalCustomerPortalsPartialUpdateData>>): UseMutationOptions<PortalCustomerPortalsPartialUpdateResponse, DefaultError, Options<PortalCustomerPortalsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomerPortalsPartialUpdateResponse, DefaultError, Options<PortalCustomerPortalsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomerPortalsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalCustomerPortalsUpdateMutation = (options?: Partial<Options<PortalCustomerPortalsUpdateData>>): UseMutationOptions<PortalCustomerPortalsUpdateResponse, DefaultError, Options<PortalCustomerPortalsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalCustomerPortalsUpdateResponse, DefaultError, Options<PortalCustomerPortalsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalCustomerPortalsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalDataProtectionRequestsListQueryKey = (options?: Options<PortalDataProtectionRequestsListData>) => createQueryKey('portalDataProtectionRequestsList', options);

export const portalDataProtectionRequestsListOptions = (options?: Options<PortalDataProtectionRequestsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalDataProtectionRequestsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalDataProtectionRequestsListQueryKey(options)
    });
};

export const portalDataProtectionRequestsListInfiniteQueryKey = (options?: Options<PortalDataProtectionRequestsListData>): QueryKey<Options<PortalDataProtectionRequestsListData>> => createQueryKey('portalDataProtectionRequestsList', options, true);

export const portalDataProtectionRequestsListInfiniteOptions = (options?: Options<PortalDataProtectionRequestsListData>) => {
    return infiniteQueryOptions<PortalDataProtectionRequestsListResponse, DefaultError, InfiniteData<PortalDataProtectionRequestsListResponse>, QueryKey<Options<PortalDataProtectionRequestsListData>>, number | Pick<QueryKey<Options<PortalDataProtectionRequestsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PortalDataProtectionRequestsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await portalDataProtectionRequestsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalDataProtectionRequestsListInfiniteQueryKey(options)
    });
};

export const portalDataProtectionRequestsCreateQueryKey = (options: Options<PortalDataProtectionRequestsCreateData>) => createQueryKey('portalDataProtectionRequestsCreate', options);

export const portalDataProtectionRequestsCreateOptions = (options: Options<PortalDataProtectionRequestsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalDataProtectionRequestsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalDataProtectionRequestsCreateQueryKey(options)
    });
};

export const portalDataProtectionRequestsCreateMutation = (options?: Partial<Options<PortalDataProtectionRequestsCreateData>>): UseMutationOptions<PortalDataProtectionRequestsCreateResponse, DefaultError, Options<PortalDataProtectionRequestsCreateData>> => {
    const mutationOptions: UseMutationOptions<PortalDataProtectionRequestsCreateResponse, DefaultError, Options<PortalDataProtectionRequestsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalDataProtectionRequestsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalDataProtectionRequestsDestroyMutation = (options?: Partial<Options<PortalDataProtectionRequestsDestroyData>>): UseMutationOptions<PortalDataProtectionRequestsDestroyResponse, DefaultError, Options<PortalDataProtectionRequestsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PortalDataProtectionRequestsDestroyResponse, DefaultError, Options<PortalDataProtectionRequestsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalDataProtectionRequestsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalDataProtectionRequestsRetrieveQueryKey = (options: Options<PortalDataProtectionRequestsRetrieveData>) => createQueryKey('portalDataProtectionRequestsRetrieve', options);

export const portalDataProtectionRequestsRetrieveOptions = (options: Options<PortalDataProtectionRequestsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalDataProtectionRequestsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalDataProtectionRequestsRetrieveQueryKey(options)
    });
};

export const portalDataProtectionRequestsPartialUpdateMutation = (options?: Partial<Options<PortalDataProtectionRequestsPartialUpdateData>>): UseMutationOptions<PortalDataProtectionRequestsPartialUpdateResponse, DefaultError, Options<PortalDataProtectionRequestsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalDataProtectionRequestsPartialUpdateResponse, DefaultError, Options<PortalDataProtectionRequestsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalDataProtectionRequestsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalDataProtectionRequestsUpdateMutation = (options?: Partial<Options<PortalDataProtectionRequestsUpdateData>>): UseMutationOptions<PortalDataProtectionRequestsUpdateResponse, DefaultError, Options<PortalDataProtectionRequestsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalDataProtectionRequestsUpdateResponse, DefaultError, Options<PortalDataProtectionRequestsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalDataProtectionRequestsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalDataProtectionRequestsBulkCreateQueryKey = (options: Options<PortalDataProtectionRequestsBulkCreateData>) => createQueryKey('portalDataProtectionRequestsBulkCreate', options);

export const portalDataProtectionRequestsBulkCreateOptions = (options: Options<PortalDataProtectionRequestsBulkCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalDataProtectionRequestsBulkCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalDataProtectionRequestsBulkCreateQueryKey(options)
    });
};

export const portalDataProtectionRequestsBulkCreateInfiniteQueryKey = (options: Options<PortalDataProtectionRequestsBulkCreateData>): QueryKey<Options<PortalDataProtectionRequestsBulkCreateData>> => createQueryKey('portalDataProtectionRequestsBulkCreate', options, true);

export const portalDataProtectionRequestsBulkCreateInfiniteOptions = (options: Options<PortalDataProtectionRequestsBulkCreateData>) => {
    return infiniteQueryOptions<PortalDataProtectionRequestsBulkCreateResponse, DefaultError, InfiniteData<PortalDataProtectionRequestsBulkCreateResponse>, QueryKey<Options<PortalDataProtectionRequestsBulkCreateData>>, number | Pick<QueryKey<Options<PortalDataProtectionRequestsBulkCreateData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PortalDataProtectionRequestsBulkCreateData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await portalDataProtectionRequestsBulkCreate({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalDataProtectionRequestsBulkCreateInfiniteQueryKey(options)
    });
};

export const portalDataProtectionRequestsBulkCreateMutation = (options?: Partial<Options<PortalDataProtectionRequestsBulkCreateData>>): UseMutationOptions<PortalDataProtectionRequestsBulkCreateResponse, DefaultError, Options<PortalDataProtectionRequestsBulkCreateData>> => {
    const mutationOptions: UseMutationOptions<PortalDataProtectionRequestsBulkCreateResponse, DefaultError, Options<PortalDataProtectionRequestsBulkCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalDataProtectionRequestsBulkCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalReportEmbedTokenTokenCreateQueryKey = (options: Options<PortalReportEmbedTokenTokenCreateData>) => createQueryKey('portalReportEmbedTokenTokenCreate', options);

export const portalReportEmbedTokenTokenCreateOptions = (options: Options<PortalReportEmbedTokenTokenCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalReportEmbedTokenTokenCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalReportEmbedTokenTokenCreateQueryKey(options)
    });
};

export const portalReportEmbedTokenTokenCreateMutation = (options?: Partial<Options<PortalReportEmbedTokenTokenCreateData>>): UseMutationOptions<PortalReportEmbedTokenTokenCreateResponse, DefaultError, Options<PortalReportEmbedTokenTokenCreateData>> => {
    const mutationOptions: UseMutationOptions<PortalReportEmbedTokenTokenCreateResponse, DefaultError, Options<PortalReportEmbedTokenTokenCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalReportEmbedTokenTokenCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalReportsListQueryKey = (options?: Options<PortalReportsListData>) => createQueryKey('portalReportsList', options);

export const portalReportsListOptions = (options?: Options<PortalReportsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalReportsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalReportsListQueryKey(options)
    });
};

export const portalReportsListInfiniteQueryKey = (options?: Options<PortalReportsListData>): QueryKey<Options<PortalReportsListData>> => createQueryKey('portalReportsList', options, true);

export const portalReportsListInfiniteOptions = (options?: Options<PortalReportsListData>) => {
    return infiniteQueryOptions<PortalReportsListResponse, DefaultError, InfiniteData<PortalReportsListResponse>, QueryKey<Options<PortalReportsListData>>, number | Pick<QueryKey<Options<PortalReportsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PortalReportsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await portalReportsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalReportsListInfiniteQueryKey(options)
    });
};

export const portalReportsCreateQueryKey = (options: Options<PortalReportsCreateData>) => createQueryKey('portalReportsCreate', options);

export const portalReportsCreateOptions = (options: Options<PortalReportsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalReportsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalReportsCreateQueryKey(options)
    });
};

export const portalReportsCreateMutation = (options?: Partial<Options<PortalReportsCreateData>>): UseMutationOptions<PortalReportsCreateResponse, DefaultError, Options<PortalReportsCreateData>> => {
    const mutationOptions: UseMutationOptions<PortalReportsCreateResponse, DefaultError, Options<PortalReportsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalReportsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalReportsDestroyMutation = (options?: Partial<Options<PortalReportsDestroyData>>): UseMutationOptions<PortalReportsDestroyResponse, DefaultError, Options<PortalReportsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PortalReportsDestroyResponse, DefaultError, Options<PortalReportsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalReportsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalReportsRetrieveQueryKey = (options: Options<PortalReportsRetrieveData>) => createQueryKey('portalReportsRetrieve', options);

export const portalReportsRetrieveOptions = (options: Options<PortalReportsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalReportsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalReportsRetrieveQueryKey(options)
    });
};

export const portalReportsPartialUpdateMutation = (options?: Partial<Options<PortalReportsPartialUpdateData>>): UseMutationOptions<PortalReportsPartialUpdateResponse, DefaultError, Options<PortalReportsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalReportsPartialUpdateResponse, DefaultError, Options<PortalReportsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalReportsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalReportsUpdateMutation = (options?: Partial<Options<PortalReportsUpdateData>>): UseMutationOptions<PortalReportsUpdateResponse, DefaultError, Options<PortalReportsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalReportsUpdateResponse, DefaultError, Options<PortalReportsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalReportsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalSharedObjectsListQueryKey = (options?: Options<PortalSharedObjectsListData>) => createQueryKey('portalSharedObjectsList', options);

export const portalSharedObjectsListOptions = (options?: Options<PortalSharedObjectsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalSharedObjectsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalSharedObjectsListQueryKey(options)
    });
};

export const portalSharedObjectsListInfiniteQueryKey = (options?: Options<PortalSharedObjectsListData>): QueryKey<Options<PortalSharedObjectsListData>> => createQueryKey('portalSharedObjectsList', options, true);

export const portalSharedObjectsListInfiniteOptions = (options?: Options<PortalSharedObjectsListData>) => {
    return infiniteQueryOptions<PortalSharedObjectsListResponse, DefaultError, InfiniteData<PortalSharedObjectsListResponse>, QueryKey<Options<PortalSharedObjectsListData>>, number | Pick<QueryKey<Options<PortalSharedObjectsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PortalSharedObjectsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await portalSharedObjectsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalSharedObjectsListInfiniteQueryKey(options)
    });
};

export const portalSharedObjectsCreateQueryKey = (options: Options<PortalSharedObjectsCreateData>) => createQueryKey('portalSharedObjectsCreate', options);

export const portalSharedObjectsCreateOptions = (options: Options<PortalSharedObjectsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalSharedObjectsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalSharedObjectsCreateQueryKey(options)
    });
};

export const portalSharedObjectsCreateMutation = (options?: Partial<Options<PortalSharedObjectsCreateData>>): UseMutationOptions<PortalSharedObjectsCreateResponse, DefaultError, Options<PortalSharedObjectsCreateData>> => {
    const mutationOptions: UseMutationOptions<PortalSharedObjectsCreateResponse, DefaultError, Options<PortalSharedObjectsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalSharedObjectsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalSharedObjectsDestroyMutation = (options?: Partial<Options<PortalSharedObjectsDestroyData>>): UseMutationOptions<PortalSharedObjectsDestroyResponse, DefaultError, Options<PortalSharedObjectsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PortalSharedObjectsDestroyResponse, DefaultError, Options<PortalSharedObjectsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalSharedObjectsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalSharedObjectsRetrieveQueryKey = (options: Options<PortalSharedObjectsRetrieveData>) => createQueryKey('portalSharedObjectsRetrieve', options);

export const portalSharedObjectsRetrieveOptions = (options: Options<PortalSharedObjectsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await portalSharedObjectsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: portalSharedObjectsRetrieveQueryKey(options)
    });
};

export const portalSharedObjectsPartialUpdateMutation = (options?: Partial<Options<PortalSharedObjectsPartialUpdateData>>): UseMutationOptions<PortalSharedObjectsPartialUpdateResponse, DefaultError, Options<PortalSharedObjectsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalSharedObjectsPartialUpdateResponse, DefaultError, Options<PortalSharedObjectsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalSharedObjectsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const portalSharedObjectsUpdateMutation = (options?: Partial<Options<PortalSharedObjectsUpdateData>>): UseMutationOptions<PortalSharedObjectsUpdateResponse, DefaultError, Options<PortalSharedObjectsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PortalSharedObjectsUpdateResponse, DefaultError, Options<PortalSharedObjectsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await portalSharedObjectsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseCourierServiceLevelsListQueryKey = (options?: Options<PromiseCourierServiceLevelsListData>) => createQueryKey('promiseCourierServiceLevelsList', options);

export const promiseCourierServiceLevelsListOptions = (options?: Options<PromiseCourierServiceLevelsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseCourierServiceLevelsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseCourierServiceLevelsListQueryKey(options)
    });
};

export const promiseCourierServiceLevelsListInfiniteQueryKey = (options?: Options<PromiseCourierServiceLevelsListData>): QueryKey<Options<PromiseCourierServiceLevelsListData>> => createQueryKey('promiseCourierServiceLevelsList', options, true);

export const promiseCourierServiceLevelsListInfiniteOptions = (options?: Options<PromiseCourierServiceLevelsListData>) => {
    return infiniteQueryOptions<PromiseCourierServiceLevelsListResponse, DefaultError, InfiniteData<PromiseCourierServiceLevelsListResponse>, QueryKey<Options<PromiseCourierServiceLevelsListData>>, number | Pick<QueryKey<Options<PromiseCourierServiceLevelsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PromiseCourierServiceLevelsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await promiseCourierServiceLevelsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseCourierServiceLevelsListInfiniteQueryKey(options)
    });
};

export const promiseCourierServiceLevelsCreateQueryKey = (options: Options<PromiseCourierServiceLevelsCreateData>) => createQueryKey('promiseCourierServiceLevelsCreate', options);

export const promiseCourierServiceLevelsCreateOptions = (options: Options<PromiseCourierServiceLevelsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseCourierServiceLevelsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseCourierServiceLevelsCreateQueryKey(options)
    });
};

export const promiseCourierServiceLevelsCreateMutation = (options?: Partial<Options<PromiseCourierServiceLevelsCreateData>>): UseMutationOptions<PromiseCourierServiceLevelsCreateResponse, DefaultError, Options<PromiseCourierServiceLevelsCreateData>> => {
    const mutationOptions: UseMutationOptions<PromiseCourierServiceLevelsCreateResponse, DefaultError, Options<PromiseCourierServiceLevelsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseCourierServiceLevelsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseCourierServiceLevelsDestroyMutation = (options?: Partial<Options<PromiseCourierServiceLevelsDestroyData>>): UseMutationOptions<PromiseCourierServiceLevelsDestroyResponse, DefaultError, Options<PromiseCourierServiceLevelsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PromiseCourierServiceLevelsDestroyResponse, DefaultError, Options<PromiseCourierServiceLevelsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseCourierServiceLevelsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseCourierServiceLevelsRetrieveQueryKey = (options: Options<PromiseCourierServiceLevelsRetrieveData>) => createQueryKey('promiseCourierServiceLevelsRetrieve', options);

export const promiseCourierServiceLevelsRetrieveOptions = (options: Options<PromiseCourierServiceLevelsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseCourierServiceLevelsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseCourierServiceLevelsRetrieveQueryKey(options)
    });
};

export const promiseCourierServiceLevelsPartialUpdateMutation = (options?: Partial<Options<PromiseCourierServiceLevelsPartialUpdateData>>): UseMutationOptions<PromiseCourierServiceLevelsPartialUpdateResponse, DefaultError, Options<PromiseCourierServiceLevelsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseCourierServiceLevelsPartialUpdateResponse, DefaultError, Options<PromiseCourierServiceLevelsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseCourierServiceLevelsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseCourierServiceLevelsUpdateMutation = (options?: Partial<Options<PromiseCourierServiceLevelsUpdateData>>): UseMutationOptions<PromiseCourierServiceLevelsUpdateResponse, DefaultError, Options<PromiseCourierServiceLevelsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseCourierServiceLevelsUpdateResponse, DefaultError, Options<PromiseCourierServiceLevelsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseCourierServiceLevelsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryMethodsListQueryKey = (options?: Options<PromiseDeliveryMethodsListData>) => createQueryKey('promiseDeliveryMethodsList', options);

export const promiseDeliveryMethodsListOptions = (options?: Options<PromiseDeliveryMethodsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryMethodsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryMethodsListQueryKey(options)
    });
};

export const promiseDeliveryMethodsListInfiniteQueryKey = (options?: Options<PromiseDeliveryMethodsListData>): QueryKey<Options<PromiseDeliveryMethodsListData>> => createQueryKey('promiseDeliveryMethodsList', options, true);

export const promiseDeliveryMethodsListInfiniteOptions = (options?: Options<PromiseDeliveryMethodsListData>) => {
    return infiniteQueryOptions<PromiseDeliveryMethodsListResponse, DefaultError, InfiniteData<PromiseDeliveryMethodsListResponse>, QueryKey<Options<PromiseDeliveryMethodsListData>>, number | Pick<QueryKey<Options<PromiseDeliveryMethodsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PromiseDeliveryMethodsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await promiseDeliveryMethodsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryMethodsListInfiniteQueryKey(options)
    });
};

export const promiseDeliveryMethodsCreateQueryKey = (options: Options<PromiseDeliveryMethodsCreateData>) => createQueryKey('promiseDeliveryMethodsCreate', options);

export const promiseDeliveryMethodsCreateOptions = (options: Options<PromiseDeliveryMethodsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryMethodsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryMethodsCreateQueryKey(options)
    });
};

export const promiseDeliveryMethodsCreateMutation = (options?: Partial<Options<PromiseDeliveryMethodsCreateData>>): UseMutationOptions<PromiseDeliveryMethodsCreateResponse, DefaultError, Options<PromiseDeliveryMethodsCreateData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryMethodsCreateResponse, DefaultError, Options<PromiseDeliveryMethodsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryMethodsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryMethodsDestroyMutation = (options?: Partial<Options<PromiseDeliveryMethodsDestroyData>>): UseMutationOptions<PromiseDeliveryMethodsDestroyResponse, DefaultError, Options<PromiseDeliveryMethodsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryMethodsDestroyResponse, DefaultError, Options<PromiseDeliveryMethodsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryMethodsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryMethodsRetrieveQueryKey = (options: Options<PromiseDeliveryMethodsRetrieveData>) => createQueryKey('promiseDeliveryMethodsRetrieve', options);

export const promiseDeliveryMethodsRetrieveOptions = (options: Options<PromiseDeliveryMethodsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryMethodsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryMethodsRetrieveQueryKey(options)
    });
};

export const promiseDeliveryMethodsPartialUpdateMutation = (options?: Partial<Options<PromiseDeliveryMethodsPartialUpdateData>>): UseMutationOptions<PromiseDeliveryMethodsPartialUpdateResponse, DefaultError, Options<PromiseDeliveryMethodsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryMethodsPartialUpdateResponse, DefaultError, Options<PromiseDeliveryMethodsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryMethodsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryMethodsUpdateMutation = (options?: Partial<Options<PromiseDeliveryMethodsUpdateData>>): UseMutationOptions<PromiseDeliveryMethodsUpdateResponse, DefaultError, Options<PromiseDeliveryMethodsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryMethodsUpdateResponse, DefaultError, Options<PromiseDeliveryMethodsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryMethodsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryPredictionServicesListQueryKey = (options?: Options<PromiseDeliveryPredictionServicesListData>) => createQueryKey('promiseDeliveryPredictionServicesList', options);

export const promiseDeliveryPredictionServicesListOptions = (options?: Options<PromiseDeliveryPredictionServicesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryPredictionServicesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryPredictionServicesListQueryKey(options)
    });
};

export const promiseDeliveryPredictionServicesListInfiniteQueryKey = (options?: Options<PromiseDeliveryPredictionServicesListData>): QueryKey<Options<PromiseDeliveryPredictionServicesListData>> => createQueryKey('promiseDeliveryPredictionServicesList', options, true);

export const promiseDeliveryPredictionServicesListInfiniteOptions = (options?: Options<PromiseDeliveryPredictionServicesListData>) => {
    return infiniteQueryOptions<PromiseDeliveryPredictionServicesListResponse, DefaultError, InfiniteData<PromiseDeliveryPredictionServicesListResponse>, QueryKey<Options<PromiseDeliveryPredictionServicesListData>>, number | Pick<QueryKey<Options<PromiseDeliveryPredictionServicesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PromiseDeliveryPredictionServicesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await promiseDeliveryPredictionServicesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryPredictionServicesListInfiniteQueryKey(options)
    });
};

export const promiseDeliveryPredictionServicesCreateQueryKey = (options: Options<PromiseDeliveryPredictionServicesCreateData>) => createQueryKey('promiseDeliveryPredictionServicesCreate', options);

export const promiseDeliveryPredictionServicesCreateOptions = (options: Options<PromiseDeliveryPredictionServicesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryPredictionServicesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryPredictionServicesCreateQueryKey(options)
    });
};

export const promiseDeliveryPredictionServicesCreateMutation = (options?: Partial<Options<PromiseDeliveryPredictionServicesCreateData>>): UseMutationOptions<PromiseDeliveryPredictionServicesCreateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesCreateData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryPredictionServicesCreateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryPredictionServicesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryPredictionServicesDestroyMutation = (options?: Partial<Options<PromiseDeliveryPredictionServicesDestroyData>>): UseMutationOptions<PromiseDeliveryPredictionServicesDestroyResponse, DefaultError, Options<PromiseDeliveryPredictionServicesDestroyData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryPredictionServicesDestroyResponse, DefaultError, Options<PromiseDeliveryPredictionServicesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryPredictionServicesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryPredictionServicesRetrieveQueryKey = (options: Options<PromiseDeliveryPredictionServicesRetrieveData>) => createQueryKey('promiseDeliveryPredictionServicesRetrieve', options);

export const promiseDeliveryPredictionServicesRetrieveOptions = (options: Options<PromiseDeliveryPredictionServicesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryPredictionServicesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryPredictionServicesRetrieveQueryKey(options)
    });
};

export const promiseDeliveryPredictionServicesPartialUpdateMutation = (options?: Partial<Options<PromiseDeliveryPredictionServicesPartialUpdateData>>): UseMutationOptions<PromiseDeliveryPredictionServicesPartialUpdateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryPredictionServicesPartialUpdateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryPredictionServicesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryPredictionServicesUpdateMutation = (options?: Partial<Options<PromiseDeliveryPredictionServicesUpdateData>>): UseMutationOptions<PromiseDeliveryPredictionServicesUpdateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryPredictionServicesUpdateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryPredictionServicesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryPredictionServicesPublishCreateQueryKey = (options: Options<PromiseDeliveryPredictionServicesPublishCreateData>) => createQueryKey('promiseDeliveryPredictionServicesPublishCreate', options);

export const promiseDeliveryPredictionServicesPublishCreateOptions = (options: Options<PromiseDeliveryPredictionServicesPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryPredictionServicesPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryPredictionServicesPublishCreateQueryKey(options)
    });
};

export const promiseDeliveryPredictionServicesPublishCreateMutation = (options?: Partial<Options<PromiseDeliveryPredictionServicesPublishCreateData>>): UseMutationOptions<PromiseDeliveryPredictionServicesPublishCreateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<PromiseDeliveryPredictionServicesPublishCreateResponse, DefaultError, Options<PromiseDeliveryPredictionServicesPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseDeliveryPredictionServicesPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseDeliveryPredictionServicesPublishedRetrieveQueryKey = (options?: Options<PromiseDeliveryPredictionServicesPublishedRetrieveData>) => createQueryKey('promiseDeliveryPredictionServicesPublishedRetrieve', options);

export const promiseDeliveryPredictionServicesPublishedRetrieveOptions = (options?: Options<PromiseDeliveryPredictionServicesPublishedRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseDeliveryPredictionServicesPublishedRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseDeliveryPredictionServicesPublishedRetrieveQueryKey(options)
    });
};

export const promiseTrendingDelayConfigurationsListQueryKey = (options?: Options<PromiseTrendingDelayConfigurationsListData>) => createQueryKey('promiseTrendingDelayConfigurationsList', options);

export const promiseTrendingDelayConfigurationsListOptions = (options?: Options<PromiseTrendingDelayConfigurationsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseTrendingDelayConfigurationsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseTrendingDelayConfigurationsListQueryKey(options)
    });
};

export const promiseTrendingDelayConfigurationsListInfiniteQueryKey = (options?: Options<PromiseTrendingDelayConfigurationsListData>): QueryKey<Options<PromiseTrendingDelayConfigurationsListData>> => createQueryKey('promiseTrendingDelayConfigurationsList', options, true);

export const promiseTrendingDelayConfigurationsListInfiniteOptions = (options?: Options<PromiseTrendingDelayConfigurationsListData>) => {
    return infiniteQueryOptions<PromiseTrendingDelayConfigurationsListResponse, DefaultError, InfiniteData<PromiseTrendingDelayConfigurationsListResponse>, QueryKey<Options<PromiseTrendingDelayConfigurationsListData>>, number | Pick<QueryKey<Options<PromiseTrendingDelayConfigurationsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PromiseTrendingDelayConfigurationsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await promiseTrendingDelayConfigurationsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseTrendingDelayConfigurationsListInfiniteQueryKey(options)
    });
};

export const promiseTrendingDelayConfigurationsCreateQueryKey = (options: Options<PromiseTrendingDelayConfigurationsCreateData>) => createQueryKey('promiseTrendingDelayConfigurationsCreate', options);

export const promiseTrendingDelayConfigurationsCreateOptions = (options: Options<PromiseTrendingDelayConfigurationsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseTrendingDelayConfigurationsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseTrendingDelayConfigurationsCreateQueryKey(options)
    });
};

export const promiseTrendingDelayConfigurationsCreateMutation = (options?: Partial<Options<PromiseTrendingDelayConfigurationsCreateData>>): UseMutationOptions<PromiseTrendingDelayConfigurationsCreateResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsCreateData>> => {
    const mutationOptions: UseMutationOptions<PromiseTrendingDelayConfigurationsCreateResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseTrendingDelayConfigurationsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseTrendingDelayConfigurationsDestroyMutation = (options?: Partial<Options<PromiseTrendingDelayConfigurationsDestroyData>>): UseMutationOptions<PromiseTrendingDelayConfigurationsDestroyResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsDestroyData>> => {
    const mutationOptions: UseMutationOptions<PromiseTrendingDelayConfigurationsDestroyResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseTrendingDelayConfigurationsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseTrendingDelayConfigurationsRetrieveQueryKey = (options: Options<PromiseTrendingDelayConfigurationsRetrieveData>) => createQueryKey('promiseTrendingDelayConfigurationsRetrieve', options);

export const promiseTrendingDelayConfigurationsRetrieveOptions = (options: Options<PromiseTrendingDelayConfigurationsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseTrendingDelayConfigurationsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseTrendingDelayConfigurationsRetrieveQueryKey(options)
    });
};

export const promiseTrendingDelayConfigurationsPartialUpdateMutation = (options?: Partial<Options<PromiseTrendingDelayConfigurationsPartialUpdateData>>): UseMutationOptions<PromiseTrendingDelayConfigurationsPartialUpdateResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseTrendingDelayConfigurationsPartialUpdateResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseTrendingDelayConfigurationsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseTrendingDelayConfigurationsUpdateMutation = (options?: Partial<Options<PromiseTrendingDelayConfigurationsUpdateData>>): UseMutationOptions<PromiseTrendingDelayConfigurationsUpdateResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseTrendingDelayConfigurationsUpdateResponse, DefaultError, Options<PromiseTrendingDelayConfigurationsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseTrendingDelayConfigurationsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseWarehousesListQueryKey = (options?: Options<PromiseWarehousesListData>) => createQueryKey('promiseWarehousesList', options);

export const promiseWarehousesListOptions = (options?: Options<PromiseWarehousesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseWarehousesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseWarehousesListQueryKey(options)
    });
};

export const promiseWarehousesListInfiniteQueryKey = (options?: Options<PromiseWarehousesListData>): QueryKey<Options<PromiseWarehousesListData>> => createQueryKey('promiseWarehousesList', options, true);

export const promiseWarehousesListInfiniteOptions = (options?: Options<PromiseWarehousesListData>) => {
    return infiniteQueryOptions<PromiseWarehousesListResponse, DefaultError, InfiniteData<PromiseWarehousesListResponse>, QueryKey<Options<PromiseWarehousesListData>>, number | Pick<QueryKey<Options<PromiseWarehousesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PromiseWarehousesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await promiseWarehousesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseWarehousesListInfiniteQueryKey(options)
    });
};

export const promiseWarehousesCreateQueryKey = (options: Options<PromiseWarehousesCreateData>) => createQueryKey('promiseWarehousesCreate', options);

export const promiseWarehousesCreateOptions = (options: Options<PromiseWarehousesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseWarehousesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseWarehousesCreateQueryKey(options)
    });
};

export const promiseWarehousesCreateMutation = (options?: Partial<Options<PromiseWarehousesCreateData>>): UseMutationOptions<PromiseWarehousesCreateResponse, DefaultError, Options<PromiseWarehousesCreateData>> => {
    const mutationOptions: UseMutationOptions<PromiseWarehousesCreateResponse, DefaultError, Options<PromiseWarehousesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseWarehousesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseWarehousesDestroyMutation = (options?: Partial<Options<PromiseWarehousesDestroyData>>): UseMutationOptions<PromiseWarehousesDestroyResponse, DefaultError, Options<PromiseWarehousesDestroyData>> => {
    const mutationOptions: UseMutationOptions<PromiseWarehousesDestroyResponse, DefaultError, Options<PromiseWarehousesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseWarehousesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseWarehousesRetrieveQueryKey = (options: Options<PromiseWarehousesRetrieveData>) => createQueryKey('promiseWarehousesRetrieve', options);

export const promiseWarehousesRetrieveOptions = (options: Options<PromiseWarehousesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promiseWarehousesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promiseWarehousesRetrieveQueryKey(options)
    });
};

export const promiseWarehousesPartialUpdateMutation = (options?: Partial<Options<PromiseWarehousesPartialUpdateData>>): UseMutationOptions<PromiseWarehousesPartialUpdateResponse, DefaultError, Options<PromiseWarehousesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseWarehousesPartialUpdateResponse, DefaultError, Options<PromiseWarehousesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseWarehousesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promiseWarehousesUpdateMutation = (options?: Partial<Options<PromiseWarehousesUpdateData>>): UseMutationOptions<PromiseWarehousesUpdateResponse, DefaultError, Options<PromiseWarehousesUpdateData>> => {
    const mutationOptions: UseMutationOptions<PromiseWarehousesUpdateResponse, DefaultError, Options<PromiseWarehousesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promiseWarehousesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsCourierApisListQueryKey = (options?: Options<ReturnsCourierApisListData>) => createQueryKey('returnsCourierApisList', options);

export const returnsCourierApisListOptions = (options?: Options<ReturnsCourierApisListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsCourierApisList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsCourierApisListQueryKey(options)
    });
};

export const returnsCourierApisListInfiniteQueryKey = (options?: Options<ReturnsCourierApisListData>): QueryKey<Options<ReturnsCourierApisListData>> => createQueryKey('returnsCourierApisList', options, true);

export const returnsCourierApisListInfiniteOptions = (options?: Options<ReturnsCourierApisListData>) => {
    return infiniteQueryOptions<ReturnsCourierApisListResponse, DefaultError, InfiniteData<ReturnsCourierApisListResponse>, QueryKey<Options<ReturnsCourierApisListData>>, number | Pick<QueryKey<Options<ReturnsCourierApisListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsCourierApisListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsCourierApisList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsCourierApisListInfiniteQueryKey(options)
    });
};

export const returnsCourierApisCreateQueryKey = (options: Options<ReturnsCourierApisCreateData>) => createQueryKey('returnsCourierApisCreate', options);

export const returnsCourierApisCreateOptions = (options: Options<ReturnsCourierApisCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsCourierApisCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsCourierApisCreateQueryKey(options)
    });
};

export const returnsCourierApisCreateMutation = (options?: Partial<Options<ReturnsCourierApisCreateData>>): UseMutationOptions<ReturnsCourierApisCreateResponse, DefaultError, Options<ReturnsCourierApisCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsCourierApisCreateResponse, DefaultError, Options<ReturnsCourierApisCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsCourierApisCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsCourierApisDestroyMutation = (options?: Partial<Options<ReturnsCourierApisDestroyData>>): UseMutationOptions<ReturnsCourierApisDestroyResponse, DefaultError, Options<ReturnsCourierApisDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsCourierApisDestroyResponse, DefaultError, Options<ReturnsCourierApisDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsCourierApisDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsCourierApisRetrieveQueryKey = (options: Options<ReturnsCourierApisRetrieveData>) => createQueryKey('returnsCourierApisRetrieve', options);

export const returnsCourierApisRetrieveOptions = (options: Options<ReturnsCourierApisRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsCourierApisRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsCourierApisRetrieveQueryKey(options)
    });
};

export const returnsCourierApisPartialUpdateMutation = (options?: Partial<Options<ReturnsCourierApisPartialUpdateData>>): UseMutationOptions<ReturnsCourierApisPartialUpdateResponse, DefaultError, Options<ReturnsCourierApisPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsCourierApisPartialUpdateResponse, DefaultError, Options<ReturnsCourierApisPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsCourierApisPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsCourierApisUpdateMutation = (options?: Partial<Options<ReturnsCourierApisUpdateData>>): UseMutationOptions<ReturnsCourierApisUpdateResponse, DefaultError, Options<ReturnsCourierApisUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsCourierApisUpdateResponse, DefaultError, Options<ReturnsCourierApisUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsCourierApisUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsCourierApisSchemaRetrieveQueryKey = (options: Options<ReturnsCourierApisSchemaRetrieveData>) => createQueryKey('returnsCourierApisSchemaRetrieve', options);

export const returnsCourierApisSchemaRetrieveOptions = (options: Options<ReturnsCourierApisSchemaRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsCourierApisSchemaRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsCourierApisSchemaRetrieveQueryKey(options)
    });
};

export const returnsDocumentTemplatesListQueryKey = (options?: Options<ReturnsDocumentTemplatesListData>) => createQueryKey('returnsDocumentTemplatesList', options);

export const returnsDocumentTemplatesListOptions = (options?: Options<ReturnsDocumentTemplatesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsDocumentTemplatesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsDocumentTemplatesListQueryKey(options)
    });
};

export const returnsDocumentTemplatesListInfiniteQueryKey = (options?: Options<ReturnsDocumentTemplatesListData>): QueryKey<Options<ReturnsDocumentTemplatesListData>> => createQueryKey('returnsDocumentTemplatesList', options, true);

export const returnsDocumentTemplatesListInfiniteOptions = (options?: Options<ReturnsDocumentTemplatesListData>) => {
    return infiniteQueryOptions<ReturnsDocumentTemplatesListResponse, DefaultError, InfiniteData<ReturnsDocumentTemplatesListResponse>, QueryKey<Options<ReturnsDocumentTemplatesListData>>, number | Pick<QueryKey<Options<ReturnsDocumentTemplatesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsDocumentTemplatesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsDocumentTemplatesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsDocumentTemplatesListInfiniteQueryKey(options)
    });
};

export const returnsDocumentTemplatesCreateQueryKey = (options: Options<ReturnsDocumentTemplatesCreateData>) => createQueryKey('returnsDocumentTemplatesCreate', options);

export const returnsDocumentTemplatesCreateOptions = (options: Options<ReturnsDocumentTemplatesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsDocumentTemplatesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsDocumentTemplatesCreateQueryKey(options)
    });
};

export const returnsDocumentTemplatesCreateMutation = (options?: Partial<Options<ReturnsDocumentTemplatesCreateData>>): UseMutationOptions<ReturnsDocumentTemplatesCreateResponse, DefaultError, Options<ReturnsDocumentTemplatesCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsDocumentTemplatesCreateResponse, DefaultError, Options<ReturnsDocumentTemplatesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsDocumentTemplatesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsDocumentTemplatesDestroyMutation = (options?: Partial<Options<ReturnsDocumentTemplatesDestroyData>>): UseMutationOptions<ReturnsDocumentTemplatesDestroyResponse, DefaultError, Options<ReturnsDocumentTemplatesDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsDocumentTemplatesDestroyResponse, DefaultError, Options<ReturnsDocumentTemplatesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsDocumentTemplatesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsDocumentTemplatesRetrieveQueryKey = (options: Options<ReturnsDocumentTemplatesRetrieveData>) => createQueryKey('returnsDocumentTemplatesRetrieve', options);

export const returnsDocumentTemplatesRetrieveOptions = (options: Options<ReturnsDocumentTemplatesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsDocumentTemplatesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsDocumentTemplatesRetrieveQueryKey(options)
    });
};

export const returnsDocumentTemplatesPartialUpdateMutation = (options?: Partial<Options<ReturnsDocumentTemplatesPartialUpdateData>>): UseMutationOptions<ReturnsDocumentTemplatesPartialUpdateResponse, DefaultError, Options<ReturnsDocumentTemplatesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsDocumentTemplatesPartialUpdateResponse, DefaultError, Options<ReturnsDocumentTemplatesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsDocumentTemplatesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsDocumentTemplatesUpdateMutation = (options?: Partial<Options<ReturnsDocumentTemplatesUpdateData>>): UseMutationOptions<ReturnsDocumentTemplatesUpdateResponse, DefaultError, Options<ReturnsDocumentTemplatesUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsDocumentTemplatesUpdateResponse, DefaultError, Options<ReturnsDocumentTemplatesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsDocumentTemplatesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsDocumentTemplatesPublishCreateQueryKey = (options: Options<ReturnsDocumentTemplatesPublishCreateData>) => createQueryKey('returnsDocumentTemplatesPublishCreate', options);

export const returnsDocumentTemplatesPublishCreateOptions = (options: Options<ReturnsDocumentTemplatesPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsDocumentTemplatesPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsDocumentTemplatesPublishCreateQueryKey(options)
    });
};

export const returnsDocumentTemplatesPublishCreateMutation = (options?: Partial<Options<ReturnsDocumentTemplatesPublishCreateData>>): UseMutationOptions<ReturnsDocumentTemplatesPublishCreateResponse, DefaultError, Options<ReturnsDocumentTemplatesPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsDocumentTemplatesPublishCreateResponse, DefaultError, Options<ReturnsDocumentTemplatesPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsDocumentTemplatesPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsDocumentTemplatesLookupRetrieveQueryKey = (options: Options<ReturnsDocumentTemplatesLookupRetrieveData>) => createQueryKey('returnsDocumentTemplatesLookupRetrieve', options);

export const returnsDocumentTemplatesLookupRetrieveOptions = (options: Options<ReturnsDocumentTemplatesLookupRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsDocumentTemplatesLookupRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsDocumentTemplatesLookupRetrieveQueryKey(options)
    });
};

export const returnsOrderApisListQueryKey = (options?: Options<ReturnsOrderApisListData>) => createQueryKey('returnsOrderApisList', options);

export const returnsOrderApisListOptions = (options?: Options<ReturnsOrderApisListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsOrderApisList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsOrderApisListQueryKey(options)
    });
};

export const returnsOrderApisListInfiniteQueryKey = (options?: Options<ReturnsOrderApisListData>): QueryKey<Options<ReturnsOrderApisListData>> => createQueryKey('returnsOrderApisList', options, true);

export const returnsOrderApisListInfiniteOptions = (options?: Options<ReturnsOrderApisListData>) => {
    return infiniteQueryOptions<ReturnsOrderApisListResponse, DefaultError, InfiniteData<ReturnsOrderApisListResponse>, QueryKey<Options<ReturnsOrderApisListData>>, number | Pick<QueryKey<Options<ReturnsOrderApisListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsOrderApisListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsOrderApisList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsOrderApisListInfiniteQueryKey(options)
    });
};

export const returnsOrderApisCreateQueryKey = (options: Options<ReturnsOrderApisCreateData>) => createQueryKey('returnsOrderApisCreate', options);

export const returnsOrderApisCreateOptions = (options: Options<ReturnsOrderApisCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsOrderApisCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsOrderApisCreateQueryKey(options)
    });
};

export const returnsOrderApisCreateMutation = (options?: Partial<Options<ReturnsOrderApisCreateData>>): UseMutationOptions<ReturnsOrderApisCreateResponse, DefaultError, Options<ReturnsOrderApisCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsOrderApisCreateResponse, DefaultError, Options<ReturnsOrderApisCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsOrderApisCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsOrderApisDestroyMutation = (options?: Partial<Options<ReturnsOrderApisDestroyData>>): UseMutationOptions<ReturnsOrderApisDestroyResponse, DefaultError, Options<ReturnsOrderApisDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsOrderApisDestroyResponse, DefaultError, Options<ReturnsOrderApisDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsOrderApisDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsOrderApisRetrieveQueryKey = (options: Options<ReturnsOrderApisRetrieveData>) => createQueryKey('returnsOrderApisRetrieve', options);

export const returnsOrderApisRetrieveOptions = (options: Options<ReturnsOrderApisRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsOrderApisRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsOrderApisRetrieveQueryKey(options)
    });
};

export const returnsOrderApisPartialUpdateMutation = (options?: Partial<Options<ReturnsOrderApisPartialUpdateData>>): UseMutationOptions<ReturnsOrderApisPartialUpdateResponse, DefaultError, Options<ReturnsOrderApisPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsOrderApisPartialUpdateResponse, DefaultError, Options<ReturnsOrderApisPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsOrderApisPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsOrderApisUpdateMutation = (options?: Partial<Options<ReturnsOrderApisUpdateData>>): UseMutationOptions<ReturnsOrderApisUpdateResponse, DefaultError, Options<ReturnsOrderApisUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsOrderApisUpdateResponse, DefaultError, Options<ReturnsOrderApisUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsOrderApisUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsOrderApisSchemaRetrieveQueryKey = (options: Options<ReturnsOrderApisSchemaRetrieveData>) => createQueryKey('returnsOrderApisSchemaRetrieve', options);

export const returnsOrderApisSchemaRetrieveOptions = (options: Options<ReturnsOrderApisSchemaRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsOrderApisSchemaRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsOrderApisSchemaRetrieveQueryKey(options)
    });
};

export const returnsPortalsListQueryKey = (options?: Options<ReturnsPortalsListData>) => createQueryKey('returnsPortalsList', options);

export const returnsPortalsListOptions = (options?: Options<ReturnsPortalsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsPortalsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsListQueryKey(options)
    });
};

export const returnsPortalsListInfiniteQueryKey = (options?: Options<ReturnsPortalsListData>): QueryKey<Options<ReturnsPortalsListData>> => createQueryKey('returnsPortalsList', options, true);

export const returnsPortalsListInfiniteOptions = (options?: Options<ReturnsPortalsListData>) => {
    return infiniteQueryOptions<ReturnsPortalsListResponse, DefaultError, InfiniteData<ReturnsPortalsListResponse>, QueryKey<Options<ReturnsPortalsListData>>, number | Pick<QueryKey<Options<ReturnsPortalsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsPortalsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsPortalsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsListInfiniteQueryKey(options)
    });
};

export const returnsPortalsCreateQueryKey = (options: Options<ReturnsPortalsCreateData>) => createQueryKey('returnsPortalsCreate', options);

export const returnsPortalsCreateOptions = (options: Options<ReturnsPortalsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsPortalsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsCreateQueryKey(options)
    });
};

export const returnsPortalsCreateMutation = (options?: Partial<Options<ReturnsPortalsCreateData>>): UseMutationOptions<ReturnsPortalsCreateResponse, DefaultError, Options<ReturnsPortalsCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsPortalsCreateResponse, DefaultError, Options<ReturnsPortalsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsPortalsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsPortalsDestroyMutation = (options?: Partial<Options<ReturnsPortalsDestroyData>>): UseMutationOptions<ReturnsPortalsDestroyResponse, DefaultError, Options<ReturnsPortalsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsPortalsDestroyResponse, DefaultError, Options<ReturnsPortalsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsPortalsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsPortalsRetrieveQueryKey = (options: Options<ReturnsPortalsRetrieveData>) => createQueryKey('returnsPortalsRetrieve', options);

export const returnsPortalsRetrieveOptions = (options: Options<ReturnsPortalsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsPortalsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsRetrieveQueryKey(options)
    });
};

export const returnsPortalsPartialUpdateMutation = (options?: Partial<Options<ReturnsPortalsPartialUpdateData>>): UseMutationOptions<ReturnsPortalsPartialUpdateResponse, DefaultError, Options<ReturnsPortalsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsPortalsPartialUpdateResponse, DefaultError, Options<ReturnsPortalsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsPortalsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsPortalsUpdateMutation = (options?: Partial<Options<ReturnsPortalsUpdateData>>): UseMutationOptions<ReturnsPortalsUpdateResponse, DefaultError, Options<ReturnsPortalsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsPortalsUpdateResponse, DefaultError, Options<ReturnsPortalsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsPortalsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsPortalsDetailsRetrieveQueryKey = (options: Options<ReturnsPortalsDetailsRetrieveData>) => createQueryKey('returnsPortalsDetailsRetrieve', options);

export const returnsPortalsDetailsRetrieveOptions = (options: Options<ReturnsPortalsDetailsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsPortalsDetailsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsDetailsRetrieveQueryKey(options)
    });
};

export const returnsPortalsPublishCreateQueryKey = (options: Options<ReturnsPortalsPublishCreateData>) => createQueryKey('returnsPortalsPublishCreate', options);

export const returnsPortalsPublishCreateOptions = (options: Options<ReturnsPortalsPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsPortalsPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsPublishCreateQueryKey(options)
    });
};

export const returnsPortalsPublishCreateMutation = (options?: Partial<Options<ReturnsPortalsPublishCreateData>>): UseMutationOptions<ReturnsPortalsPublishCreateResponse, DefaultError, Options<ReturnsPortalsPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsPortalsPublishCreateResponse, DefaultError, Options<ReturnsPortalsPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsPortalsPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsPortalsSchemaRetrieveQueryKey = (options: Options<ReturnsPortalsSchemaRetrieveData>) => createQueryKey('returnsPortalsSchemaRetrieve', options);

export const returnsPortalsSchemaRetrieveOptions = (options: Options<ReturnsPortalsSchemaRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsPortalsSchemaRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsSchemaRetrieveQueryKey(options)
    });
};

export const returnsPortalsLookupRetrieveQueryKey = (options: Options<ReturnsPortalsLookupRetrieveData>) => createQueryKey('returnsPortalsLookupRetrieve', options);

export const returnsPortalsLookupRetrieveOptions = (options: Options<ReturnsPortalsLookupRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsPortalsLookupRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsPortalsLookupRetrieveQueryKey(options)
    });
};

export const returnsReturnReasonsListQueryKey = (options?: Options<ReturnsReturnReasonsListData>) => createQueryKey('returnsReturnReasonsList', options);

export const returnsReturnReasonsListOptions = (options?: Options<ReturnsReturnReasonsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnReasonsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnReasonsListQueryKey(options)
    });
};

export const returnsReturnReasonsListInfiniteQueryKey = (options?: Options<ReturnsReturnReasonsListData>): QueryKey<Options<ReturnsReturnReasonsListData>> => createQueryKey('returnsReturnReasonsList', options, true);

export const returnsReturnReasonsListInfiniteOptions = (options?: Options<ReturnsReturnReasonsListData>) => {
    return infiniteQueryOptions<ReturnsReturnReasonsListResponse, DefaultError, InfiniteData<ReturnsReturnReasonsListResponse>, QueryKey<Options<ReturnsReturnReasonsListData>>, number | Pick<QueryKey<Options<ReturnsReturnReasonsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsReturnReasonsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsReturnReasonsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnReasonsListInfiniteQueryKey(options)
    });
};

export const returnsReturnReasonsCreateQueryKey = (options: Options<ReturnsReturnReasonsCreateData>) => createQueryKey('returnsReturnReasonsCreate', options);

export const returnsReturnReasonsCreateOptions = (options: Options<ReturnsReturnReasonsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnReasonsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnReasonsCreateQueryKey(options)
    });
};

export const returnsReturnReasonsCreateMutation = (options?: Partial<Options<ReturnsReturnReasonsCreateData>>): UseMutationOptions<ReturnsReturnReasonsCreateResponse, DefaultError, Options<ReturnsReturnReasonsCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnReasonsCreateResponse, DefaultError, Options<ReturnsReturnReasonsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnReasonsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnReasonsDestroyMutation = (options?: Partial<Options<ReturnsReturnReasonsDestroyData>>): UseMutationOptions<ReturnsReturnReasonsDestroyResponse, DefaultError, Options<ReturnsReturnReasonsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnReasonsDestroyResponse, DefaultError, Options<ReturnsReturnReasonsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnReasonsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnReasonsRetrieveQueryKey = (options: Options<ReturnsReturnReasonsRetrieveData>) => createQueryKey('returnsReturnReasonsRetrieve', options);

export const returnsReturnReasonsRetrieveOptions = (options: Options<ReturnsReturnReasonsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnReasonsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnReasonsRetrieveQueryKey(options)
    });
};

export const returnsReturnReasonsPartialUpdateMutation = (options?: Partial<Options<ReturnsReturnReasonsPartialUpdateData>>): UseMutationOptions<ReturnsReturnReasonsPartialUpdateResponse, DefaultError, Options<ReturnsReturnReasonsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnReasonsPartialUpdateResponse, DefaultError, Options<ReturnsReturnReasonsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnReasonsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnReasonsUpdateMutation = (options?: Partial<Options<ReturnsReturnReasonsUpdateData>>): UseMutationOptions<ReturnsReturnReasonsUpdateResponse, DefaultError, Options<ReturnsReturnReasonsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnReasonsUpdateResponse, DefaultError, Options<ReturnsReturnReasonsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnReasonsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnReasonsMoveToCreateQueryKey = (options: Options<ReturnsReturnReasonsMoveToCreateData>) => createQueryKey('returnsReturnReasonsMoveToCreate', options);

export const returnsReturnReasonsMoveToCreateOptions = (options: Options<ReturnsReturnReasonsMoveToCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnReasonsMoveToCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnReasonsMoveToCreateQueryKey(options)
    });
};

export const returnsReturnReasonsMoveToCreateMutation = (options?: Partial<Options<ReturnsReturnReasonsMoveToCreateData>>): UseMutationOptions<ReturnsReturnReasonsMoveToCreateResponse, DefaultError, Options<ReturnsReturnReasonsMoveToCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnReasonsMoveToCreateResponse, DefaultError, Options<ReturnsReturnReasonsMoveToCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnReasonsMoveToCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnRegistrationsListQueryKey = (options?: Options<ReturnsReturnRegistrationsListData>) => createQueryKey('returnsReturnRegistrationsList', options);

export const returnsReturnRegistrationsListOptions = (options?: Options<ReturnsReturnRegistrationsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnRegistrationsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnRegistrationsListQueryKey(options)
    });
};

export const returnsReturnRegistrationsListInfiniteQueryKey = (options?: Options<ReturnsReturnRegistrationsListData>): QueryKey<Options<ReturnsReturnRegistrationsListData>> => createQueryKey('returnsReturnRegistrationsList', options, true);

export const returnsReturnRegistrationsListInfiniteOptions = (options?: Options<ReturnsReturnRegistrationsListData>) => {
    return infiniteQueryOptions<ReturnsReturnRegistrationsListResponse, DefaultError, InfiniteData<ReturnsReturnRegistrationsListResponse>, QueryKey<Options<ReturnsReturnRegistrationsListData>>, string | Pick<QueryKey<Options<ReturnsReturnRegistrationsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsReturnRegistrationsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsReturnRegistrationsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnRegistrationsListInfiniteQueryKey(options)
    });
};

export const returnsReturnRegistrationsCreateQueryKey = (options: Options<ReturnsReturnRegistrationsCreateData>) => createQueryKey('returnsReturnRegistrationsCreate', options);

export const returnsReturnRegistrationsCreateOptions = (options: Options<ReturnsReturnRegistrationsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnRegistrationsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnRegistrationsCreateQueryKey(options)
    });
};

export const returnsReturnRegistrationsCreateMutation = (options?: Partial<Options<ReturnsReturnRegistrationsCreateData>>): UseMutationOptions<ReturnsReturnRegistrationsCreateResponse, DefaultError, Options<ReturnsReturnRegistrationsCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnRegistrationsCreateResponse, DefaultError, Options<ReturnsReturnRegistrationsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnRegistrationsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnRegistrationsDestroyMutation = (options?: Partial<Options<ReturnsReturnRegistrationsDestroyData>>): UseMutationOptions<ReturnsReturnRegistrationsDestroyResponse, DefaultError, Options<ReturnsReturnRegistrationsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnRegistrationsDestroyResponse, DefaultError, Options<ReturnsReturnRegistrationsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnRegistrationsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnRegistrationsRetrieveQueryKey = (options: Options<ReturnsReturnRegistrationsRetrieveData>) => createQueryKey('returnsReturnRegistrationsRetrieve', options);

export const returnsReturnRegistrationsRetrieveOptions = (options: Options<ReturnsReturnRegistrationsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnRegistrationsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnRegistrationsRetrieveQueryKey(options)
    });
};

export const returnsReturnRegistrationsPartialUpdateMutation = (options?: Partial<Options<ReturnsReturnRegistrationsPartialUpdateData>>): UseMutationOptions<ReturnsReturnRegistrationsPartialUpdateResponse, DefaultError, Options<ReturnsReturnRegistrationsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnRegistrationsPartialUpdateResponse, DefaultError, Options<ReturnsReturnRegistrationsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnRegistrationsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnRegistrationsUpdateMutation = (options?: Partial<Options<ReturnsReturnRegistrationsUpdateData>>): UseMutationOptions<ReturnsReturnRegistrationsUpdateResponse, DefaultError, Options<ReturnsReturnRegistrationsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnRegistrationsUpdateResponse, DefaultError, Options<ReturnsReturnRegistrationsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnRegistrationsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsReturnRegistrationsStatusCreateQueryKey = (options: Options<ReturnsReturnRegistrationsStatusCreateData>) => createQueryKey('returnsReturnRegistrationsStatusCreate', options);

export const returnsReturnRegistrationsStatusCreateOptions = (options: Options<ReturnsReturnRegistrationsStatusCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsReturnRegistrationsStatusCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsReturnRegistrationsStatusCreateQueryKey(options)
    });
};

export const returnsReturnRegistrationsStatusCreateMutation = (options?: Partial<Options<ReturnsReturnRegistrationsStatusCreateData>>): UseMutationOptions<ReturnsReturnRegistrationsStatusCreateResponse, DefaultError, Options<ReturnsReturnRegistrationsStatusCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsReturnRegistrationsStatusCreateResponse, DefaultError, Options<ReturnsReturnRegistrationsStatusCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsReturnRegistrationsStatusCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsRulesListQueryKey = (options?: Options<ReturnsRulesListData>) => createQueryKey('returnsRulesList', options);

export const returnsRulesListOptions = (options?: Options<ReturnsRulesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsRulesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsRulesListQueryKey(options)
    });
};

export const returnsRulesListInfiniteQueryKey = (options?: Options<ReturnsRulesListData>): QueryKey<Options<ReturnsRulesListData>> => createQueryKey('returnsRulesList', options, true);

export const returnsRulesListInfiniteOptions = (options?: Options<ReturnsRulesListData>) => {
    return infiniteQueryOptions<ReturnsRulesListResponse, DefaultError, InfiniteData<ReturnsRulesListResponse>, QueryKey<Options<ReturnsRulesListData>>, number | Pick<QueryKey<Options<ReturnsRulesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsRulesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsRulesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsRulesListInfiniteQueryKey(options)
    });
};

export const returnsRulesCreateQueryKey = (options: Options<ReturnsRulesCreateData>) => createQueryKey('returnsRulesCreate', options);

export const returnsRulesCreateOptions = (options: Options<ReturnsRulesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsRulesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsRulesCreateQueryKey(options)
    });
};

export const returnsRulesCreateMutation = (options?: Partial<Options<ReturnsRulesCreateData>>): UseMutationOptions<ReturnsRulesCreateResponse, DefaultError, Options<ReturnsRulesCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsRulesCreateResponse, DefaultError, Options<ReturnsRulesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsRulesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsRulesDestroyMutation = (options?: Partial<Options<ReturnsRulesDestroyData>>): UseMutationOptions<ReturnsRulesDestroyResponse, DefaultError, Options<ReturnsRulesDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsRulesDestroyResponse, DefaultError, Options<ReturnsRulesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsRulesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsRulesRetrieveQueryKey = (options: Options<ReturnsRulesRetrieveData>) => createQueryKey('returnsRulesRetrieve', options);

export const returnsRulesRetrieveOptions = (options: Options<ReturnsRulesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsRulesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsRulesRetrieveQueryKey(options)
    });
};

export const returnsRulesPartialUpdateMutation = (options?: Partial<Options<ReturnsRulesPartialUpdateData>>): UseMutationOptions<ReturnsRulesPartialUpdateResponse, DefaultError, Options<ReturnsRulesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsRulesPartialUpdateResponse, DefaultError, Options<ReturnsRulesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsRulesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsRulesUpdateMutation = (options?: Partial<Options<ReturnsRulesUpdateData>>): UseMutationOptions<ReturnsRulesUpdateResponse, DefaultError, Options<ReturnsRulesUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsRulesUpdateResponse, DefaultError, Options<ReturnsRulesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsRulesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsTranslationsListQueryKey = (options?: Options<ReturnsTranslationsListData>) => createQueryKey('returnsTranslationsList', options);

export const returnsTranslationsListOptions = (options?: Options<ReturnsTranslationsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsTranslationsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsTranslationsListQueryKey(options)
    });
};

export const returnsTranslationsListInfiniteQueryKey = (options?: Options<ReturnsTranslationsListData>): QueryKey<Options<ReturnsTranslationsListData>> => createQueryKey('returnsTranslationsList', options, true);

export const returnsTranslationsListInfiniteOptions = (options?: Options<ReturnsTranslationsListData>) => {
    return infiniteQueryOptions<ReturnsTranslationsListResponse, DefaultError, InfiniteData<ReturnsTranslationsListResponse>, QueryKey<Options<ReturnsTranslationsListData>>, number | Pick<QueryKey<Options<ReturnsTranslationsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReturnsTranslationsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await returnsTranslationsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsTranslationsListInfiniteQueryKey(options)
    });
};

export const returnsTranslationsCreateQueryKey = (options: Options<ReturnsTranslationsCreateData>) => createQueryKey('returnsTranslationsCreate', options);

export const returnsTranslationsCreateOptions = (options: Options<ReturnsTranslationsCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsTranslationsCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsTranslationsCreateQueryKey(options)
    });
};

export const returnsTranslationsCreateMutation = (options?: Partial<Options<ReturnsTranslationsCreateData>>): UseMutationOptions<ReturnsTranslationsCreateResponse, DefaultError, Options<ReturnsTranslationsCreateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsTranslationsCreateResponse, DefaultError, Options<ReturnsTranslationsCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsTranslationsCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsTranslationsDestroyMutation = (options?: Partial<Options<ReturnsTranslationsDestroyData>>): UseMutationOptions<ReturnsTranslationsDestroyResponse, DefaultError, Options<ReturnsTranslationsDestroyData>> => {
    const mutationOptions: UseMutationOptions<ReturnsTranslationsDestroyResponse, DefaultError, Options<ReturnsTranslationsDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsTranslationsDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsTranslationsRetrieveQueryKey = (options: Options<ReturnsTranslationsRetrieveData>) => createQueryKey('returnsTranslationsRetrieve', options);

export const returnsTranslationsRetrieveOptions = (options: Options<ReturnsTranslationsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsTranslationsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsTranslationsRetrieveQueryKey(options)
    });
};

export const returnsTranslationsPartialUpdateMutation = (options?: Partial<Options<ReturnsTranslationsPartialUpdateData>>): UseMutationOptions<ReturnsTranslationsPartialUpdateResponse, DefaultError, Options<ReturnsTranslationsPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsTranslationsPartialUpdateResponse, DefaultError, Options<ReturnsTranslationsPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsTranslationsPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsTranslationsUpdateMutation = (options?: Partial<Options<ReturnsTranslationsUpdateData>>): UseMutationOptions<ReturnsTranslationsUpdateResponse, DefaultError, Options<ReturnsTranslationsUpdateData>> => {
    const mutationOptions: UseMutationOptions<ReturnsTranslationsUpdateResponse, DefaultError, Options<ReturnsTranslationsUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await returnsTranslationsUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const returnsTranslationsSchemaRetrieveQueryKey = (options: Options<ReturnsTranslationsSchemaRetrieveData>) => createQueryKey('returnsTranslationsSchemaRetrieve', options);

export const returnsTranslationsSchemaRetrieveOptions = (options: Options<ReturnsTranslationsSchemaRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await returnsTranslationsSchemaRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: returnsTranslationsSchemaRetrieveQueryKey(options)
    });
};

export const serviceRecipesListQueryKey = (options?: Options<ServiceRecipesListData>) => createQueryKey('serviceRecipesList', options);

export const serviceRecipesListOptions = (options?: Options<ServiceRecipesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceRecipesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesListQueryKey(options)
    });
};

export const serviceRecipesListInfiniteQueryKey = (options?: Options<ServiceRecipesListData>): QueryKey<Options<ServiceRecipesListData>> => createQueryKey('serviceRecipesList', options, true);

export const serviceRecipesListInfiniteOptions = (options?: Options<ServiceRecipesListData>) => {
    return infiniteQueryOptions<ServiceRecipesListResponse, DefaultError, InfiniteData<ServiceRecipesListResponse>, QueryKey<Options<ServiceRecipesListData>>, number | Pick<QueryKey<Options<ServiceRecipesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ServiceRecipesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await serviceRecipesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesListInfiniteQueryKey(options)
    });
};

export const serviceRecipesRetrieveQueryKey = (options: Options<ServiceRecipesRetrieveData>) => createQueryKey('serviceRecipesRetrieve', options);

export const serviceRecipesRetrieveOptions = (options: Options<ServiceRecipesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceRecipesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesRetrieveQueryKey(options)
    });
};

export const serviceRecipesApplyCreateQueryKey = (options: Options<ServiceRecipesApplyCreateData>) => createQueryKey('serviceRecipesApplyCreate', options);

export const serviceRecipesApplyCreateOptions = (options: Options<ServiceRecipesApplyCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceRecipesApplyCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesApplyCreateQueryKey(options)
    });
};

export const serviceRecipesApplyCreateMutation = (options?: Partial<Options<ServiceRecipesApplyCreateData>>): UseMutationOptions<ServiceRecipesApplyCreateResponse, DefaultError, Options<ServiceRecipesApplyCreateData>> => {
    const mutationOptions: UseMutationOptions<ServiceRecipesApplyCreateResponse, DefaultError, Options<ServiceRecipesApplyCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceRecipesApplyCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceRecipesApplicationsListQueryKey = (options?: Options<ServiceRecipesApplicationsListData>) => createQueryKey('serviceRecipesApplicationsList', options);

export const serviceRecipesApplicationsListOptions = (options?: Options<ServiceRecipesApplicationsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceRecipesApplicationsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesApplicationsListQueryKey(options)
    });
};

export const serviceRecipesApplicationsListInfiniteQueryKey = (options?: Options<ServiceRecipesApplicationsListData>): QueryKey<Options<ServiceRecipesApplicationsListData>> => createQueryKey('serviceRecipesApplicationsList', options, true);

export const serviceRecipesApplicationsListInfiniteOptions = (options?: Options<ServiceRecipesApplicationsListData>) => {
    return infiniteQueryOptions<ServiceRecipesApplicationsListResponse, DefaultError, InfiniteData<ServiceRecipesApplicationsListResponse>, QueryKey<Options<ServiceRecipesApplicationsListData>>, number | Pick<QueryKey<Options<ServiceRecipesApplicationsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ServiceRecipesApplicationsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await serviceRecipesApplicationsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesApplicationsListInfiniteQueryKey(options)
    });
};

export const serviceRecipesApplicationsRetrieveQueryKey = (options: Options<ServiceRecipesApplicationsRetrieveData>) => createQueryKey('serviceRecipesApplicationsRetrieve', options);

export const serviceRecipesApplicationsRetrieveOptions = (options: Options<ServiceRecipesApplicationsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceRecipesApplicationsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesApplicationsRetrieveQueryKey(options)
    });
};

export const serviceRecipesApplicationsPublishCreateQueryKey = (options: Options<ServiceRecipesApplicationsPublishCreateData>) => createQueryKey('serviceRecipesApplicationsPublishCreate', options);

export const serviceRecipesApplicationsPublishCreateOptions = (options: Options<ServiceRecipesApplicationsPublishCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceRecipesApplicationsPublishCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceRecipesApplicationsPublishCreateQueryKey(options)
    });
};

export const serviceRecipesApplicationsPublishCreateMutation = (options?: Partial<Options<ServiceRecipesApplicationsPublishCreateData>>): UseMutationOptions<ServiceRecipesApplicationsPublishCreateResponse, DefaultError, Options<ServiceRecipesApplicationsPublishCreateData>> => {
    const mutationOptions: UseMutationOptions<ServiceRecipesApplicationsPublishCreateResponse, DefaultError, Options<ServiceRecipesApplicationsPublishCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceRecipesApplicationsPublishCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceServicesListQueryKey = (options?: Options<ServiceServicesListData>) => createQueryKey('serviceServicesList', options);

export const serviceServicesListOptions = (options?: Options<ServiceServicesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceServicesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceServicesListQueryKey(options)
    });
};

export const serviceServicesListInfiniteQueryKey = (options?: Options<ServiceServicesListData>): QueryKey<Options<ServiceServicesListData>> => createQueryKey('serviceServicesList', options, true);

export const serviceServicesListInfiniteOptions = (options?: Options<ServiceServicesListData>) => {
    return infiniteQueryOptions<ServiceServicesListResponse, DefaultError, InfiniteData<ServiceServicesListResponse>, QueryKey<Options<ServiceServicesListData>>, number | Pick<QueryKey<Options<ServiceServicesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ServiceServicesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await serviceServicesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceServicesListInfiniteQueryKey(options)
    });
};

export const serviceServicesCreateQueryKey = (options: Options<ServiceServicesCreateData>) => createQueryKey('serviceServicesCreate', options);

export const serviceServicesCreateOptions = (options: Options<ServiceServicesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceServicesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceServicesCreateQueryKey(options)
    });
};

export const serviceServicesCreateMutation = (options?: Partial<Options<ServiceServicesCreateData>>): UseMutationOptions<ServiceServicesCreateResponse, DefaultError, Options<ServiceServicesCreateData>> => {
    const mutationOptions: UseMutationOptions<ServiceServicesCreateResponse, DefaultError, Options<ServiceServicesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceServicesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceServicesDestroyMutation = (options?: Partial<Options<ServiceServicesDestroyData>>): UseMutationOptions<ServiceServicesDestroyResponse, DefaultError, Options<ServiceServicesDestroyData>> => {
    const mutationOptions: UseMutationOptions<ServiceServicesDestroyResponse, DefaultError, Options<ServiceServicesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceServicesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceServicesRetrieveQueryKey = (options: Options<ServiceServicesRetrieveData>) => createQueryKey('serviceServicesRetrieve', options);

export const serviceServicesRetrieveOptions = (options: Options<ServiceServicesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceServicesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceServicesRetrieveQueryKey(options)
    });
};

export const serviceServicesPartialUpdateMutation = (options?: Partial<Options<ServiceServicesPartialUpdateData>>): UseMutationOptions<ServiceServicesPartialUpdateResponse, DefaultError, Options<ServiceServicesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<ServiceServicesPartialUpdateResponse, DefaultError, Options<ServiceServicesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceServicesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceServicesUpdateMutation = (options?: Partial<Options<ServiceServicesUpdateData>>): UseMutationOptions<ServiceServicesUpdateResponse, DefaultError, Options<ServiceServicesUpdateData>> => {
    const mutationOptions: UseMutationOptions<ServiceServicesUpdateResponse, DefaultError, Options<ServiceServicesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceServicesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceServicesSchemaRetrieveQueryKey = (options?: Options<ServiceServicesSchemaRetrieveData>) => createQueryKey('serviceServicesSchemaRetrieve', options);

export const serviceServicesSchemaRetrieveOptions = (options?: Options<ServiceServicesSchemaRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceServicesSchemaRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceServicesSchemaRetrieveQueryKey(options)
    });
};

export const testappTestListQueryKey = (options?: Options<TestappTestListData>) => createQueryKey('testappTestList', options);

export const testappTestListOptions = (options?: Options<TestappTestListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await testappTestList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: testappTestListQueryKey(options)
    });
};

export const testappTestListInfiniteQueryKey = (options?: Options<TestappTestListData>): QueryKey<Options<TestappTestListData>> => createQueryKey('testappTestList', options, true);

export const testappTestListInfiniteOptions = (options?: Options<TestappTestListData>) => {
    return infiniteQueryOptions<TestappTestListResponse, DefaultError, InfiniteData<TestappTestListResponse>, QueryKey<Options<TestappTestListData>>, number | Pick<QueryKey<Options<TestappTestListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TestappTestListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await testappTestList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: testappTestListInfiniteQueryKey(options)
    });
};

export const testappTestCreateQueryKey = (options: Options<TestappTestCreateData>) => createQueryKey('testappTestCreate', options);

export const testappTestCreateOptions = (options: Options<TestappTestCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await testappTestCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: testappTestCreateQueryKey(options)
    });
};

export const testappTestCreateMutation = (options?: Partial<Options<TestappTestCreateData>>): UseMutationOptions<TestappTestCreateResponse, DefaultError, Options<TestappTestCreateData>> => {
    const mutationOptions: UseMutationOptions<TestappTestCreateResponse, DefaultError, Options<TestappTestCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await testappTestCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testappTestDestroyMutation = (options?: Partial<Options<TestappTestDestroyData>>): UseMutationOptions<TestappTestDestroyResponse, DefaultError, Options<TestappTestDestroyData>> => {
    const mutationOptions: UseMutationOptions<TestappTestDestroyResponse, DefaultError, Options<TestappTestDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await testappTestDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testappTestRetrieveQueryKey = (options: Options<TestappTestRetrieveData>) => createQueryKey('testappTestRetrieve', options);

export const testappTestRetrieveOptions = (options: Options<TestappTestRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await testappTestRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: testappTestRetrieveQueryKey(options)
    });
};

export const testappTestPartialUpdateMutation = (options?: Partial<Options<TestappTestPartialUpdateData>>): UseMutationOptions<TestappTestPartialUpdateResponse, DefaultError, Options<TestappTestPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<TestappTestPartialUpdateResponse, DefaultError, Options<TestappTestPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await testappTestPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testappTestUpdateMutation = (options?: Partial<Options<TestappTestUpdateData>>): UseMutationOptions<TestappTestUpdateResponse, DefaultError, Options<TestappTestUpdateData>> => {
    const mutationOptions: UseMutationOptions<TestappTestUpdateResponse, DefaultError, Options<TestappTestUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await testappTestUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testappTestRaiseErrorRetrieveQueryKey = (options?: Options<TestappTestRaiseErrorRetrieveData>) => createQueryKey('testappTestRaiseErrorRetrieve', options);

export const testappTestRaiseErrorRetrieveOptions = (options?: Options<TestappTestRaiseErrorRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await testappTestRaiseErrorRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: testappTestRaiseErrorRetrieveQueryKey(options)
    });
};

export const trackEmailsListQueryKey = (options?: Options<TrackEmailsListData>) => createQueryKey('trackEmailsList', options);

export const trackEmailsListOptions = (options?: Options<TrackEmailsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackEmailsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackEmailsListQueryKey(options)
    });
};

export const trackEmailsListInfiniteQueryKey = (options?: Options<TrackEmailsListData>): QueryKey<Options<TrackEmailsListData>> => createQueryKey('trackEmailsList', options, true);

export const trackEmailsListInfiniteOptions = (options?: Options<TrackEmailsListData>) => {
    return infiniteQueryOptions<TrackEmailsListResponse, DefaultError, InfiniteData<TrackEmailsListResponse>, QueryKey<Options<TrackEmailsListData>>, string | Pick<QueryKey<Options<TrackEmailsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TrackEmailsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await trackEmailsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackEmailsListInfiniteQueryKey(options)
    });
};

export const trackEmailsRetrieveQueryKey = (options: Options<TrackEmailsRetrieveData>) => createQueryKey('trackEmailsRetrieve', options);

export const trackEmailsRetrieveOptions = (options: Options<TrackEmailsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackEmailsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackEmailsRetrieveQueryKey(options)
    });
};

export const trackEventsListQueryKey = (options?: Options<TrackEventsListData>) => createQueryKey('trackEventsList', options);

export const trackEventsListOptions = (options?: Options<TrackEventsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackEventsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackEventsListQueryKey(options)
    });
};

export const trackEventsListInfiniteQueryKey = (options?: Options<TrackEventsListData>): QueryKey<Options<TrackEventsListData>> => createQueryKey('trackEventsList', options, true);

export const trackEventsListInfiniteOptions = (options?: Options<TrackEventsListData>) => {
    return infiniteQueryOptions<TrackEventsListResponse, DefaultError, InfiniteData<TrackEventsListResponse>, QueryKey<Options<TrackEventsListData>>, string | Pick<QueryKey<Options<TrackEventsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TrackEventsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await trackEventsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackEventsListInfiniteQueryKey(options)
    });
};

export const trackEventsRetrieveQueryKey = (options: Options<TrackEventsRetrieveData>) => createQueryKey('trackEventsRetrieve', options);

export const trackEventsRetrieveOptions = (options: Options<TrackEventsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackEventsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackEventsRetrieveQueryKey(options)
    });
};

export const trackEventsAvailableTypesRetrieveQueryKey = (options?: Options<TrackEventsAvailableTypesRetrieveData>) => createQueryKey('trackEventsAvailableTypesRetrieve', options);

export const trackEventsAvailableTypesRetrieveOptions = (options?: Options<TrackEventsAvailableTypesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackEventsAvailableTypesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackEventsAvailableTypesRetrieveQueryKey(options)
    });
};

export const trackOrderStatusPagesListQueryKey = (options?: Options<TrackOrderStatusPagesListData>) => createQueryKey('trackOrderStatusPagesList', options);

export const trackOrderStatusPagesListOptions = (options?: Options<TrackOrderStatusPagesListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackOrderStatusPagesList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackOrderStatusPagesListQueryKey(options)
    });
};

export const trackOrderStatusPagesListInfiniteQueryKey = (options?: Options<TrackOrderStatusPagesListData>): QueryKey<Options<TrackOrderStatusPagesListData>> => createQueryKey('trackOrderStatusPagesList', options, true);

export const trackOrderStatusPagesListInfiniteOptions = (options?: Options<TrackOrderStatusPagesListData>) => {
    return infiniteQueryOptions<TrackOrderStatusPagesListResponse, DefaultError, InfiniteData<TrackOrderStatusPagesListResponse>, QueryKey<Options<TrackOrderStatusPagesListData>>, number | Pick<QueryKey<Options<TrackOrderStatusPagesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TrackOrderStatusPagesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await trackOrderStatusPagesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackOrderStatusPagesListInfiniteQueryKey(options)
    });
};

export const trackOrderStatusPagesCreateQueryKey = (options: Options<TrackOrderStatusPagesCreateData>) => createQueryKey('trackOrderStatusPagesCreate', options);

export const trackOrderStatusPagesCreateOptions = (options: Options<TrackOrderStatusPagesCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackOrderStatusPagesCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackOrderStatusPagesCreateQueryKey(options)
    });
};

export const trackOrderStatusPagesCreateMutation = (options?: Partial<Options<TrackOrderStatusPagesCreateData>>): UseMutationOptions<TrackOrderStatusPagesCreateResponse, DefaultError, Options<TrackOrderStatusPagesCreateData>> => {
    const mutationOptions: UseMutationOptions<TrackOrderStatusPagesCreateResponse, DefaultError, Options<TrackOrderStatusPagesCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackOrderStatusPagesCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackOrderStatusPagesDestroyMutation = (options?: Partial<Options<TrackOrderStatusPagesDestroyData>>): UseMutationOptions<TrackOrderStatusPagesDestroyResponse, DefaultError, Options<TrackOrderStatusPagesDestroyData>> => {
    const mutationOptions: UseMutationOptions<TrackOrderStatusPagesDestroyResponse, DefaultError, Options<TrackOrderStatusPagesDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackOrderStatusPagesDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackOrderStatusPagesRetrieveQueryKey = (options: Options<TrackOrderStatusPagesRetrieveData>) => createQueryKey('trackOrderStatusPagesRetrieve', options);

export const trackOrderStatusPagesRetrieveOptions = (options: Options<TrackOrderStatusPagesRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackOrderStatusPagesRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackOrderStatusPagesRetrieveQueryKey(options)
    });
};

export const trackOrderStatusPagesPartialUpdateMutation = (options?: Partial<Options<TrackOrderStatusPagesPartialUpdateData>>): UseMutationOptions<TrackOrderStatusPagesPartialUpdateResponse, DefaultError, Options<TrackOrderStatusPagesPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<TrackOrderStatusPagesPartialUpdateResponse, DefaultError, Options<TrackOrderStatusPagesPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackOrderStatusPagesPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackOrderStatusPagesUpdateMutation = (options?: Partial<Options<TrackOrderStatusPagesUpdateData>>): UseMutationOptions<TrackOrderStatusPagesUpdateResponse, DefaultError, Options<TrackOrderStatusPagesUpdateData>> => {
    const mutationOptions: UseMutationOptions<TrackOrderStatusPagesUpdateResponse, DefaultError, Options<TrackOrderStatusPagesUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackOrderStatusPagesUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackPlaceInfoListQueryKey = (options?: Options<TrackPlaceInfoListData>) => createQueryKey('trackPlaceInfoList', options);

export const trackPlaceInfoListOptions = (options?: Options<TrackPlaceInfoListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackPlaceInfoList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackPlaceInfoListQueryKey(options)
    });
};

export const trackPlaceInfoListInfiniteQueryKey = (options?: Options<TrackPlaceInfoListData>): QueryKey<Options<TrackPlaceInfoListData>> => createQueryKey('trackPlaceInfoList', options, true);

export const trackPlaceInfoListInfiniteOptions = (options?: Options<TrackPlaceInfoListData>) => {
    return infiniteQueryOptions<TrackPlaceInfoListResponse, DefaultError, InfiniteData<TrackPlaceInfoListResponse>, QueryKey<Options<TrackPlaceInfoListData>>, number | Pick<QueryKey<Options<TrackPlaceInfoListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TrackPlaceInfoListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await trackPlaceInfoList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackPlaceInfoListInfiniteQueryKey(options)
    });
};

export const trackPlaceInfoCreateQueryKey = (options: Options<TrackPlaceInfoCreateData>) => createQueryKey('trackPlaceInfoCreate', options);

export const trackPlaceInfoCreateOptions = (options: Options<TrackPlaceInfoCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackPlaceInfoCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackPlaceInfoCreateQueryKey(options)
    });
};

export const trackPlaceInfoCreateMutation = (options?: Partial<Options<TrackPlaceInfoCreateData>>): UseMutationOptions<TrackPlaceInfoCreateResponse, DefaultError, Options<TrackPlaceInfoCreateData>> => {
    const mutationOptions: UseMutationOptions<TrackPlaceInfoCreateResponse, DefaultError, Options<TrackPlaceInfoCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackPlaceInfoCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackPlaceInfoDestroyMutation = (options?: Partial<Options<TrackPlaceInfoDestroyData>>): UseMutationOptions<TrackPlaceInfoDestroyResponse, DefaultError, Options<TrackPlaceInfoDestroyData>> => {
    const mutationOptions: UseMutationOptions<TrackPlaceInfoDestroyResponse, DefaultError, Options<TrackPlaceInfoDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackPlaceInfoDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackPlaceInfoRetrieveQueryKey = (options: Options<TrackPlaceInfoRetrieveData>) => createQueryKey('trackPlaceInfoRetrieve', options);

export const trackPlaceInfoRetrieveOptions = (options: Options<TrackPlaceInfoRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackPlaceInfoRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackPlaceInfoRetrieveQueryKey(options)
    });
};

export const trackPlaceInfoPartialUpdateMutation = (options?: Partial<Options<TrackPlaceInfoPartialUpdateData>>): UseMutationOptions<TrackPlaceInfoPartialUpdateResponse, DefaultError, Options<TrackPlaceInfoPartialUpdateData>> => {
    const mutationOptions: UseMutationOptions<TrackPlaceInfoPartialUpdateResponse, DefaultError, Options<TrackPlaceInfoPartialUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackPlaceInfoPartialUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackPlaceInfoUpdateMutation = (options?: Partial<Options<TrackPlaceInfoUpdateData>>): UseMutationOptions<TrackPlaceInfoUpdateResponse, DefaultError, Options<TrackPlaceInfoUpdateData>> => {
    const mutationOptions: UseMutationOptions<TrackPlaceInfoUpdateResponse, DefaultError, Options<TrackPlaceInfoUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackPlaceInfoUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackPlaceInfoLookupCreateQueryKey = (options: Options<TrackPlaceInfoLookupCreateData>) => createQueryKey('trackPlaceInfoLookupCreate', options);

export const trackPlaceInfoLookupCreateOptions = (options: Options<TrackPlaceInfoLookupCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackPlaceInfoLookupCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackPlaceInfoLookupCreateQueryKey(options)
    });
};

export const trackPlaceInfoLookupCreateMutation = (options?: Partial<Options<TrackPlaceInfoLookupCreateData>>): UseMutationOptions<TrackPlaceInfoLookupCreateResponse, DefaultError, Options<TrackPlaceInfoLookupCreateData>> => {
    const mutationOptions: UseMutationOptions<TrackPlaceInfoLookupCreateResponse, DefaultError, Options<TrackPlaceInfoLookupCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trackPlaceInfoLookupCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackRecipientsListQueryKey = (options?: Options<TrackRecipientsListData>) => createQueryKey('trackRecipientsList', options);

export const trackRecipientsListOptions = (options?: Options<TrackRecipientsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackRecipientsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackRecipientsListQueryKey(options)
    });
};

export const trackRecipientsListInfiniteQueryKey = (options?: Options<TrackRecipientsListData>): QueryKey<Options<TrackRecipientsListData>> => createQueryKey('trackRecipientsList', options, true);

export const trackRecipientsListInfiniteOptions = (options?: Options<TrackRecipientsListData>) => {
    return infiniteQueryOptions<TrackRecipientsListResponse, DefaultError, InfiniteData<TrackRecipientsListResponse>, QueryKey<Options<TrackRecipientsListData>>, string | Pick<QueryKey<Options<TrackRecipientsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TrackRecipientsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await trackRecipientsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackRecipientsListInfiniteQueryKey(options)
    });
};

export const trackRecipientsRetrieveQueryKey = (options: Options<TrackRecipientsRetrieveData>) => createQueryKey('trackRecipientsRetrieve', options);

export const trackRecipientsRetrieveOptions = (options: Options<TrackRecipientsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackRecipientsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackRecipientsRetrieveQueryKey(options)
    });
};

export const trackTrackingsListQueryKey = (options?: Options<TrackTrackingsListData>) => createQueryKey('trackTrackingsList', options);

export const trackTrackingsListOptions = (options?: Options<TrackTrackingsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackTrackingsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackTrackingsListQueryKey(options)
    });
};

export const trackTrackingsListInfiniteQueryKey = (options?: Options<TrackTrackingsListData>): QueryKey<Options<TrackTrackingsListData>> => createQueryKey('trackTrackingsList', options, true);

export const trackTrackingsListInfiniteOptions = (options?: Options<TrackTrackingsListData>) => {
    return infiniteQueryOptions<TrackTrackingsListResponse, DefaultError, InfiniteData<TrackTrackingsListResponse>, QueryKey<Options<TrackTrackingsListData>>, string | Pick<QueryKey<Options<TrackTrackingsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TrackTrackingsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await trackTrackingsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackTrackingsListInfiniteQueryKey(options)
    });
};

export const trackTrackingsRetrieveQueryKey = (options: Options<TrackTrackingsRetrieveData>) => createQueryKey('trackTrackingsRetrieve', options);

export const trackTrackingsRetrieveOptions = (options: Options<TrackTrackingsRetrieveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trackTrackingsRetrieve({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trackTrackingsRetrieveQueryKey(options)
    });
};